//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.3.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

@Injectable({
    providedIn: 'root'
})
export class TokenClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    echo(): Observable<AuthSecContext> {
        let url_ = this.baseUrl + "/api/v1/token/echo";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEcho(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEcho(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthSecContext>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthSecContext>;
        }));
    }

    protected processEcho(response: HttpResponseBase): Observable<AuthSecContext> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthSecContext.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    environment(): Observable<AuthSecContext> {
        let url_ = this.baseUrl + "/api/v1/token/environment";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processEnvironment(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processEnvironment(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthSecContext>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthSecContext>;
        }));
    }

    protected processEnvironment(response: HttpResponseBase): Observable<AuthSecContext> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthSecContext.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    processToken(authParam: AuthParam): Observable<AuthSecContext> {
        let url_ = this.baseUrl + "/api/v1/token";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(authParam);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcessToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcessToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthSecContext>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthSecContext>;
        }));
    }

    protected processProcessToken(response: HttpResponseBase): Observable<AuthSecContext> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthSecContext.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    processTokenFromAccessCode(authParam: AuthParam): Observable<AuthSecContext> {
        let url_ = this.baseUrl + "/api/v1/token/tokenAG";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(authParam);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcessTokenFromAccessCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcessTokenFromAccessCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthSecContext>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthSecContext>;
        }));
    }

    protected processProcessTokenFromAccessCode(response: HttpResponseBase): Observable<AuthSecContext> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthSecContext.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    processTokenFromMobile(authParam: AuthParam): Observable<AuthSecContext> {
        let url_ = this.baseUrl + "/api/v1/token/tokenMB";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(authParam);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processProcessTokenFromMobile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processProcessTokenFromMobile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthSecContext>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthSecContext>;
        }));
    }

    protected processProcessTokenFromMobile(response: HttpResponseBase): Observable<AuthSecContext> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthSecContext.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    setupMFA(setup: AuthMFASetup): Observable<AuthSecContext> {
        let url_ = this.baseUrl + "/api/v1/token/setup/mfa";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(setup);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSetupMFA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSetupMFA(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthSecContext>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthSecContext>;
        }));
    }

    protected processSetupMFA(response: HttpResponseBase): Observable<AuthSecContext> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthSecContext.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    validateMFA(code: string): Observable<AuthSecContext> {
        let url_ = this.baseUrl + "/api/v1/token/mfa";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(code);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processValidateMFA(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processValidateMFA(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthSecContext>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthSecContext>;
        }));
    }

    protected processValidateMFA(response: HttpResponseBase): Observable<AuthSecContext> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthSecContext.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    expireToken(): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v1/token/ExpireToken";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExpireToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExpireToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processExpireToken(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    refreshToken(): Observable<AuthSecContext> {
        let url_ = this.baseUrl + "/api/v1/token/Refresh";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRefreshToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRefreshToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthSecContext>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthSecContext>;
        }));
    }

    protected processRefreshToken(response: HttpResponseBase): Observable<AuthSecContext> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthSecContext.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    renewToken(): Observable<AuthSecContextInt> {
        let url_ = this.baseUrl + "/api/v1/token/Renew";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRenewToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRenewToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthSecContextInt>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthSecContextInt>;
        }));
    }

    protected processRenewToken(response: HttpResponseBase): Observable<AuthSecContextInt> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthSecContextInt.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class RoleClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getRoles(): Observable<RoleV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/roles/roles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleV1Model[]>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<RoleV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoleV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getApiPermissions(): Observable<APIPermissionModel[]> {
        let url_ = this.baseUrl + "/api/v1/roles/apiPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApiPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApiPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<APIPermissionModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<APIPermissionModel[]>;
        }));
    }

    protected processGetApiPermissions(response: HttpResponseBase): Observable<APIPermissionModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(APIPermissionModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getRolePermissions(roleId: number | undefined): Observable<APIPermissionModel[]> {
        let url_ = this.baseUrl + "/api/v1/roles/rolePermissions?";
        if (roleId === null)
            throw new Error("The parameter 'roleId' cannot be null.");
        else if (roleId !== undefined)
            url_ += "roleId=" + encodeURIComponent("" + roleId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRolePermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRolePermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<APIPermissionModel[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<APIPermissionModel[]>;
        }));
    }

    protected processGetRolePermissions(response: HttpResponseBase): Observable<APIPermissionModel[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(APIPermissionModel.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUserRoles(userId: number): Observable<RoleV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/roles/roles/user/{userId}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RoleV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RoleV1Model[]>;
        }));
    }

    protected processGetUserRoles(response: HttpResponseBase): Observable<RoleV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(RoleV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ExistingUsersODClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfUserV1Model> {
        let url_ = this.baseUrl + "/api/ExistingUsersOD?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfUserV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfUserV1Model>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfUserV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfUserV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get2(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfUserV1Model> {
        let url_ = this.baseUrl + "/api/ExistingUsersOD/$count?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfUserV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfUserV1Model>;
        }));
    }

    protected processGet2(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfUserV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfUserV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class PasswordClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    beginResetPassword(email: string): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/password/ResetPassword/{email}";
        if (email === undefined || email === null)
            throw new Error("The parameter 'email' must be defined.");
        url_ = url_.replace("{email}", encodeURIComponent("" + email));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processBeginResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processBeginResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processBeginResetPassword(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    resetPassword(request: ResetPasswordV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/password/ResetPassword";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPassword(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPassword(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processResetPassword(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    resetPasswordAuthenticated(request: ResetPasswordV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/password/ResetPassword/Authenticated";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPasswordAuthenticated(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPasswordAuthenticated(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processResetPasswordAuthenticated(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    resetPasswordUser(userId: number, password: string): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/password/ResetPassword/User/{userId}/{password}";
        if (userId === undefined || userId === null)
            throw new Error("The parameter 'userId' must be defined.");
        url_ = url_.replace("{userId}", encodeURIComponent("" + userId));
        if (password === undefined || password === null)
            throw new Error("The parameter 'password' must be defined.");
        url_ = url_.replace("{password}", encodeURIComponent("" + password));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetPasswordUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetPasswordUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processResetPasswordUser(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UserClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getUser(): Observable<UserV1Model> {
        let url_ = this.baseUrl + "/api/v1/user/User";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserV1Model>;
        }));
    }

    protected processGetUser(response: HttpResponseBase): Observable<UserV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUserId(): Observable<number> {
        let url_ = this.baseUrl + "/api/v1/user/id";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processGetUserId(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByID(user_id: number): Observable<UserV1Model> {
        let url_ = this.baseUrl + "/api/v1/user/{user_id}";
        if (user_id === undefined || user_id === null)
            throw new Error("The parameter 'user_id' must be defined.");
        url_ = url_.replace("{user_id}", encodeURIComponent("" + user_id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByID(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByID(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserV1Model>;
        }));
    }

    protected processGetByID(response: HttpResponseBase): Observable<UserV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUsers(): Observable<UserV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/user/users";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserV1Model[]>;
        }));
    }

    protected processGetUsers(response: HttpResponseBase): Observable<UserV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    insertUser(model: UserInsertV1Model): Observable<InsertResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/user/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsertResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsertResponseV1Model>;
        }));
    }

    protected processInsertUser(response: HttpResponseBase): Observable<InsertResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsertResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUserAccounts(userId: number): Observable<UserAccountV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/user/GetUserAccounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userId);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserAccounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAccounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserAccountV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserAccountV1Model[]>;
        }));
    }

    protected processGetUserAccounts(response: HttpResponseBase): Observable<UserAccountV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserAccountV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUsersForAccount(accountId: number): Observable<UserV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/user/GetUsersForAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(accountId);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUsersForAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUsersForAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserV1Model[]>;
        }));
    }

    protected processGetUsersForAccount(response: HttpResponseBase): Observable<UserV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getInspectorsForFacility(facilityId: number): Observable<UserV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/user/GetInspectorsForFacility";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(facilityId);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetInspectorsForFacility(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetInspectorsForFacility(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserV1Model[]>;
        }));
    }

    protected processGetInspectorsForFacility(response: HttpResponseBase): Observable<UserV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateUser(model: UserUpdateV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/user/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processUpdateUser(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateUserRoles(model: UserUpdateV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/user/UpdateUserRoles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processUpdateUserRoles(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteUser(userId: number): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/user/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userId);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processDeleteUser(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUserSettings(): Observable<UserSettingV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/user/UserSettings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserSettingV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserSettingV1Model[]>;
        }));
    }

    protected processGetUserSettings(response: HttpResponseBase): Observable<UserSettingV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(UserSettingV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateUserSetting(setting: UserSettingV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/user/UpdateUserSetting";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(setting);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserSetting(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserSetting(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processUpdateUserSetting(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateUserSettings(settings: UserSettingV1Model[]): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/user/UpdateUserSettings";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(settings);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserSettings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserSettings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processUpdateUserSettings(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class UserODClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfUserV1Model> {
        let url_ = this.baseUrl + "/api/UserOD?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfUserV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfUserV1Model>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfUserV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfUserV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get2(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfUserV1Model> {
        let url_ = this.baseUrl + "/api/UserOD/$count?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfUserV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfUserV1Model>;
        }));
    }

    protected processGet2(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfUserV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfUserV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FilePUBLICClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    downloadFile(tableName: string, fileGuid: string): Observable<CommonResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/file/download/{tableName}/{fileGuid}";
        if (tableName === undefined || tableName === null)
            throw new Error("The parameter 'tableName' must be defined.");
        url_ = url_.replace("{tableName}", encodeURIComponent("" + tableName));
        if (fileGuid === undefined || fileGuid === null)
            throw new Error("The parameter 'fileGuid' must be defined.");
        url_ = url_.replace("{fileGuid}", encodeURIComponent("" + fileGuid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonResponseV1Model>;
        }));
    }

    protected processDownloadFile(response: HttpResponseBase): Observable<CommonResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommonResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadAssetBlueprintThumbnail(fileGuid: string): Observable<CommonResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/file/GetAssetBlueprintThumbnail/{fileGuid}";
        if (fileGuid === undefined || fileGuid === null)
            throw new Error("The parameter 'fileGuid' must be defined.");
        url_ = url_.replace("{fileGuid}", encodeURIComponent("" + fileGuid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadAssetBlueprintThumbnail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadAssetBlueprintThumbnail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonResponseV1Model>;
        }));
    }

    protected processDownloadAssetBlueprintThumbnail(response: HttpResponseBase): Observable<CommonResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommonResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadFileByGuid(fileGuid: string): Observable<CommonResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/file/download/{fileGuid}";
        if (fileGuid === undefined || fileGuid === null)
            throw new Error("The parameter 'fileGuid' must be defined.");
        url_ = url_.replace("{fileGuid}", encodeURIComponent("" + fileGuid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFileByGuid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFileByGuid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonResponseV1Model>;
        }));
    }

    protected processDownloadFileByGuid(response: HttpResponseBase): Observable<CommonResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommonResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class DevOpsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    logError(error: ErrorV1Model): Observable<InsertResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/DevOps/api/V1/DevOps/LogError";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(error);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processLogError(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processLogError(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsertResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsertResponseV1Model>;
        }));
    }

    protected processLogError(response: HttpResponseBase): Observable<InsertResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsertResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getHelp(helpContentId: number): Observable<FieldLevelHelpV1Model> {
        let url_ = this.baseUrl + "/api/v1/DevOps/help/{helpContentId}";
        if (helpContentId === undefined || helpContentId === null)
            throw new Error("The parameter 'helpContentId' must be defined.");
        url_ = url_.replace("{helpContentId}", encodeURIComponent("" + helpContentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetHelp(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetHelp(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FieldLevelHelpV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FieldLevelHelpV1Model>;
        }));
    }

    protected processGetHelp(response: HttpResponseBase): Observable<FieldLevelHelpV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FieldLevelHelpV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BlueprintClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAllByFloorId(floorId: number): Observable<BlueprintV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/blueprint/GetAllByFloorId/{floorId}";
        if (floorId === undefined || floorId === null)
            throw new Error("The parameter 'floorId' must be defined.");
        url_ = url_.replace("{floorId}", encodeURIComponent("" + floorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByFloorId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByFloorId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BlueprintV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BlueprintV1Model[]>;
        }));
    }

    protected processGetAllByFloorId(response: HttpResponseBase): Observable<BlueprintV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BlueprintV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllByFacilityId(facilityId: number): Observable<BlueprintV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/blueprint/GetAllByFacilityId/{facilityId}";
        if (facilityId === undefined || facilityId === null)
            throw new Error("The parameter 'facilityId' must be defined.");
        url_ = url_.replace("{facilityId}", encodeURIComponent("" + facilityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByFacilityId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByFacilityId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BlueprintV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BlueprintV1Model[]>;
        }));
    }

    protected processGetAllByFacilityId(response: HttpResponseBase): Observable<BlueprintV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BlueprintV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getById(blueprintId: number | undefined, blueprintTypeId: string): Observable<BlueprintV1Model> {
        let url_ = this.baseUrl + "/api/v1/blueprint/{blueprintTypeId}?";
        if (blueprintTypeId === undefined || blueprintTypeId === null)
            throw new Error("The parameter 'blueprintTypeId' must be defined.");
        url_ = url_.replace("{blueprintTypeId}", encodeURIComponent("" + blueprintTypeId));
        if (blueprintId === null)
            throw new Error("The parameter 'blueprintId' cannot be null.");
        else if (blueprintId !== undefined)
            url_ += "blueprintId=" + encodeURIComponent("" + blueprintId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BlueprintV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BlueprintV1Model>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<BlueprintV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BlueprintV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllByProjectId(projectId: number): Observable<BlueprintV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/blueprint/GetAllByProjectId/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByProjectId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByProjectId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BlueprintV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BlueprintV1Model[]>;
        }));
    }

    protected processGetAllByProjectId(response: HttpResponseBase): Observable<BlueprintV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BlueprintV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    insert(model: BlueprintInsertV1Model): Observable<InsertResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/blueprint/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsertResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsertResponseV1Model>;
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<InsertResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsertResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(model: BlueprintUpdateV1Model): Observable<InsertResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/blueprint/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsertResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsertResponseV1Model>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<InsertResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsertResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportPDF(model: BlueprintExportV1Model): Observable<FileV1Model> {
        let url_ = this.baseUrl + "/api/v1/blueprint/Export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportPDF(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportPDF(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileV1Model>;
        }));
    }

    protected processExportPDF(response: HttpResponseBase): Observable<FileV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BlueprintTypeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAll(): Observable<BlueprintTypeV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/blueprint-type/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BlueprintTypeV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BlueprintTypeV1Model[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<BlueprintTypeV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BlueprintTypeV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAvailableTypes(floorId: number): Observable<BlueprintTypeV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/blueprint-type/GetAvailableTypes/{floorId}";
        if (floorId === undefined || floorId === null)
            throw new Error("The parameter 'floorId' must be defined.");
        url_ = url_.replace("{floorId}", encodeURIComponent("" + floorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BlueprintTypeV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BlueprintTypeV1Model[]>;
        }));
    }

    protected processGetAvailableTypes(response: HttpResponseBase): Observable<BlueprintTypeV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(BlueprintTypeV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getById(blueprintTypeId: number): Observable<BlueprintTypeV1Model> {
        let url_ = this.baseUrl + "/api/v1/blueprint-type/{blueprintTypeId}";
        if (blueprintTypeId === undefined || blueprintTypeId === null)
            throw new Error("The parameter 'blueprintTypeId' must be defined.");
        url_ = url_.replace("{blueprintTypeId}", encodeURIComponent("" + blueprintTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<BlueprintTypeV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<BlueprintTypeV1Model>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<BlueprintTypeV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = BlueprintTypeV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    insert(model: BlueprintTypeInsertV1Model): Observable<InsertResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/blueprint-type/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsertResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsertResponseV1Model>;
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<InsertResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsertResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(model: BlueprintTypeUpdateV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/blueprint-type/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class BlueprintTypeODClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfBlueprintTypeV1Model> {
        let url_ = this.baseUrl + "/api/BlueprintTypeOD?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfBlueprintTypeV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfBlueprintTypeV1Model>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfBlueprintTypeV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfBlueprintTypeV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get2(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfBlueprintTypeV1Model> {
        let url_ = this.baseUrl + "/api/BlueprintTypeOD/$count?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfBlueprintTypeV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfBlueprintTypeV1Model>;
        }));
    }

    protected processGet2(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfBlueprintTypeV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfBlueprintTypeV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FacilityTypeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAll(): Observable<FacilityTypeV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/facility-type/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FacilityTypeV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FacilityTypeV1Model[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<FacilityTypeV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FacilityTypeV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getById(facilityTypeId: number): Observable<FacilityTypeV1Model> {
        let url_ = this.baseUrl + "/api/v1/facility-type/{facilityTypeId}";
        if (facilityTypeId === undefined || facilityTypeId === null)
            throw new Error("The parameter 'facilityTypeId' must be defined.");
        url_ = url_.replace("{facilityTypeId}", encodeURIComponent("" + facilityTypeId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FacilityTypeV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FacilityTypeV1Model>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<FacilityTypeV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FacilityTypeV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    insert(model: FacilityTypeInsertV1Model): Observable<InsertResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/facility-type/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsertResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsertResponseV1Model>;
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<InsertResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsertResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(model: FacilityTypeUpdateV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/facility-type/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FacilityTypeODClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfFacilityTypeV1Model> {
        let url_ = this.baseUrl + "/api/FacilityTypeOD?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfFacilityTypeV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfFacilityTypeV1Model>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfFacilityTypeV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfFacilityTypeV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get2(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfFacilityTypeV1Model> {
        let url_ = this.baseUrl + "/api/FacilityTypeOD/$count?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfFacilityTypeV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfFacilityTypeV1Model>;
        }));
    }

    protected processGet2(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfFacilityTypeV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfFacilityTypeV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AssetVideoPUBLICClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    downloadVideo(fileGuid: string): Observable<CommonResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/video/download/{fileGuid}";
        if (fileGuid === undefined || fileGuid === null)
            throw new Error("The parameter 'fileGuid' must be defined.");
        url_ = url_.replace("{fileGuid}", encodeURIComponent("" + fileGuid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadVideo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadVideo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonResponseV1Model>;
        }));
    }

    protected processDownloadVideo(response: HttpResponseBase): Observable<CommonResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommonResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getVideoPreview(videoGuid: string): Observable<CommonResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/video/preview/{videoGuid}";
        if (videoGuid === undefined || videoGuid === null)
            throw new Error("The parameter 'videoGuid' must be defined.");
        url_ = url_.replace("{videoGuid}", encodeURIComponent("" + videoGuid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetVideoPreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetVideoPreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonResponseV1Model>;
        }));
    }

    protected processGetVideoPreview(response: HttpResponseBase): Observable<CommonResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommonResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class WorkOrderClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    search(model: WorkOrderSearchV1Model): Observable<WorkOrderV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/workOrder/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkOrderV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkOrderV1Model[]>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<WorkOrderV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkOrderV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByAssetId(assetId: number): Observable<WorkOrderV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/workOrder/GetByAssetId/{assetId}";
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByAssetId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByAssetId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkOrderV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkOrderV1Model[]>;
        }));
    }

    protected processGetByAssetId(response: HttpResponseBase): Observable<WorkOrderV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(WorkOrderV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getById(workOrderId: number): Observable<WorkOrderV1Model> {
        let url_ = this.baseUrl + "/api/v1/workOrder/{workOrderId}";
        if (workOrderId === undefined || workOrderId === null)
            throw new Error("The parameter 'workOrderId' must be defined.");
        url_ = url_.replace("{workOrderId}", encodeURIComponent("" + workOrderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkOrderV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkOrderV1Model>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<WorkOrderV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkOrderV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    insert(model: WorkOrderInsertV1Model): Observable<InsertResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/workOrder/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsertResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsertResponseV1Model>;
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<InsertResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsertResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    insertNewAssetWorkOrder(model: WorkOrderAssetInsertV1Model): Observable<InsertResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/workOrder/InsertNewAssetWorkOrder";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertNewAssetWorkOrder(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertNewAssetWorkOrder(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsertResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsertResponseV1Model>;
        }));
    }

    protected processInsertNewAssetWorkOrder(response: HttpResponseBase): Observable<InsertResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsertResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(model: WorkOrderUpdateV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/workOrder/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateStatus(model: WorkOrderUpdateStatusV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/workOrder/UpdateStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processUpdateStatus(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    workOrderBulkUpdate(model: WorkOrderBulkUpdateV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/workOrder/WorkOrderBulkUpdate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorkOrderBulkUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorkOrderBulkUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processWorkOrderBulkUpdate(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    workOrderBulkCreate(model: WorkOrderBulkCreateV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/workOrder/WorkOrderBulkCreate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processWorkOrderBulkCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processWorkOrderBulkCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processWorkOrderBulkCreate(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    import(model: WorkOrderImportM1V1Model): Observable<InsertResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/workOrder/Import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsertResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsertResponseV1Model>;
        }));
    }

    protected processImport(response: HttpResponseBase): Observable<InsertResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsertResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadImport(workOrderImportId: number): Observable<WorkOrderImportFileV1Model> {
        let url_ = this.baseUrl + "/api/v1/workOrder/Download/Import/{workOrderImportId}";
        if (workOrderImportId === undefined || workOrderImportId === null)
            throw new Error("The parameter 'workOrderImportId' must be defined.");
        url_ = url_.replace("{workOrderImportId}", encodeURIComponent("" + workOrderImportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<WorkOrderImportFileV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<WorkOrderImportFileV1Model>;
        }));
    }

    protected processDownloadImport(response: HttpResponseBase): Observable<WorkOrderImportFileV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = WorkOrderImportFileV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportWorkOrders(model: WorkOrderSearchV1Model): Observable<FileV1Model> {
        let url_ = this.baseUrl + "/api/v1/workOrder/Download/Export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportWorkOrders(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportWorkOrders(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileV1Model>;
        }));
    }

    protected processExportWorkOrders(response: HttpResponseBase): Observable<FileV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FileV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class WorkOrderODClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfWorkOrderV1Model> {
        let url_ = this.baseUrl + "/api/WorkOrderOD?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfWorkOrderV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfWorkOrderV1Model>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfWorkOrderV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfWorkOrderV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get2(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfWorkOrderV1Model> {
        let url_ = this.baseUrl + "/api/WorkOrderOD/$count?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfWorkOrderV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfWorkOrderV1Model>;
        }));
    }

    protected processGet2(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfWorkOrderV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfWorkOrderV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ProjectClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    insert(model: ProjectInsertV1Model): Observable<InsertResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/project/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsertResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsertResponseV1Model>;
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<InsertResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsertResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(model: ProjectUpdateV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/project/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProjectsWithSummaryInfo(model: ProjectSummarySearchV1Model): Observable<ProjectV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/project/GetProjectsWithSummaryInfo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectsWithSummaryInfo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectsWithSummaryInfo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectV1Model[]>;
        }));
    }

    protected processGetProjectsWithSummaryInfo(response: HttpResponseBase): Observable<ProjectV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllProjectsForAccount(accountId: number): Observable<ProjectV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/project/GetAllProjectsForAccount/{accountId}";
        if (accountId === undefined || accountId === null)
            throw new Error("The parameter 'accountId' must be defined.");
        url_ = url_.replace("{accountId}", encodeURIComponent("" + accountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllProjectsForAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProjectsForAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectV1Model[]>;
        }));
    }

    protected processGetAllProjectsForAccount(response: HttpResponseBase): Observable<ProjectV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllProjects(facilityId: number): Observable<ProjectV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/project/GetAllProjects/{facilityId}";
        if (facilityId === undefined || facilityId === null)
            throw new Error("The parameter 'facilityId' must be defined.");
        url_ = url_.replace("{facilityId}", encodeURIComponent("" + facilityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllProjects(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllProjects(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectV1Model[]>;
        }));
    }

    protected processGetAllProjects(response: HttpResponseBase): Observable<ProjectV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDistinctFacilityGroups(facilityId: number): Observable<string[]> {
        let url_ = this.baseUrl + "/api/v1/project/GetDistinctFacilityGroups/{facilityId}";
        if (facilityId === undefined || facilityId === null)
            throw new Error("The parameter 'facilityId' must be defined.");
        url_ = url_.replace("{facilityId}", encodeURIComponent("" + facilityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDistinctFacilityGroups(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDistinctFacilityGroups(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetDistinctFacilityGroups(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProjectsAssignedToBlueprint(blueprintId: number): Observable<ProjectV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/project/GetProjectsAssignedToBlueprint/{blueprintId}";
        if (blueprintId === undefined || blueprintId === null)
            throw new Error("The parameter 'blueprintId' must be defined.");
        url_ = url_.replace("{blueprintId}", encodeURIComponent("" + blueprintId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectsAssignedToBlueprint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectsAssignedToBlueprint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectV1Model[]>;
        }));
    }

    protected processGetProjectsAssignedToBlueprint(response: HttpResponseBase): Observable<ProjectV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProjectsAssignedToFloor(floorId: number): Observable<ProjectV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/project/GetProjectsAssignedToFloor/{floorId}";
        if (floorId === undefined || floorId === null)
            throw new Error("The parameter 'floorId' must be defined.");
        url_ = url_.replace("{floorId}", encodeURIComponent("" + floorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectsAssignedToFloor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectsAssignedToFloor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectV1Model[]>;
        }));
    }

    protected processGetProjectsAssignedToFloor(response: HttpResponseBase): Observable<ProjectV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProjectWithFloors(projectId: number): Observable<ProjectWithFloorsV1Model> {
        let url_ = this.baseUrl + "/api/v1/project/GetProjectWithFloors/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectWithFloors(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectWithFloors(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectWithFloorsV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectWithFloorsV1Model>;
        }));
    }

    protected processGetProjectWithFloors(response: HttpResponseBase): Observable<ProjectWithFloorsV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectWithFloorsV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    exportPDF(projectId: number): Observable<boolean> {
        let url_ = this.baseUrl + "/api/v1/project/Export/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportPDF(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportPDF(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<boolean>;
                }
            } else
                return _observableThrow(response_) as any as Observable<boolean>;
        }));
    }

    protected processExportPDF(response: HttpResponseBase): Observable<boolean> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ProjectBlueprintLineClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    insert(model: ProjectBlueprintLineInsertV1Model): Observable<InsertResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/project-blueprint-lines/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsertResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsertResponseV1Model>;
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<InsertResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsertResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    search(model: ProjectBlueprintLineSearchV1Model): Observable<ProjectBlueprintLineV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/project-blueprint-lines/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectBlueprintLineV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectBlueprintLineV1Model[]>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<ProjectBlueprintLineV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectBlueprintLineV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(projectBlueprintLineId: number): Observable<CommonResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/project-blueprint-lines/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(projectBlueprintLineId);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonResponseV1Model>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<CommonResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommonResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateNote(model: ProjectBlueprintLineUpdateV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/project-blueprint-lines/UpdateNote";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateNote(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateNote(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processUpdateNote(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ProjectODClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfProjectV1Model> {
        let url_ = this.baseUrl + "/api/ProjectOD?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfProjectV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfProjectV1Model>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfProjectV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfProjectV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get2(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfProjectV1Model> {
        let url_ = this.baseUrl + "/api/ProjectOD/$count?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfProjectV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfProjectV1Model>;
        }));
    }

    protected processGet2(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfProjectV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfProjectV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class ProjectPhaseClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getByProject(projectId: number): Observable<ProjectPhaseV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/projectPhase/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectPhaseV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectPhaseV1Model[]>;
        }));
    }

    protected processGetByProject(response: HttpResponseBase): Observable<ProjectPhaseV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(ProjectPhaseV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    insert(model: ProjectPhaseInsertV1Model): Observable<InsertResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/projectPhase/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsertResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsertResponseV1Model>;
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<InsertResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsertResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(model: ProjectPhaseUpdateV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/projectPhase/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class OfflineSyncClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    syncForFacility(facilityId: number): Observable<OfflineDataSyncV1Model> {
        let url_ = this.baseUrl + "/api/v1/offline-sync/SyncForFacility";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(facilityId);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSyncForFacility(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSyncForFacility(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OfflineDataSyncV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OfflineDataSyncV1Model>;
        }));
    }

    protected processSyncForFacility(response: HttpResponseBase): Observable<OfflineDataSyncV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OfflineDataSyncV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSchema(): Observable<OfflineSchemaSyncV1Model> {
        let url_ = this.baseUrl + "/api/v1/offline-sync/GetSchema";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSchema(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSchema(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<OfflineSchemaSyncV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<OfflineSchemaSyncV1Model>;
        }));
    }

    protected processGetSchema(response: HttpResponseBase): Observable<OfflineSchemaSyncV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = OfflineSchemaSyncV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class IconClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAll(): Observable<IconV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/icon/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IconV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IconV1Model[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<IconV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IconV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    search(model: IconSearchV1Model): Observable<IconV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/icon/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IconV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IconV1Model[]>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<IconV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(IconV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    upload(model: IconUploadV1Model): Observable<InsertResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/icon/Upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpload(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpload(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsertResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsertResponseV1Model>;
        }));
    }

    protected processUpload(response: HttpResponseBase): Observable<InsertResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsertResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateIcon(model: IconUpdateV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/icon/UpdateIcon";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateIcon(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateIcon(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processUpdateIcon(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadIcon(icon: IconV1Model): Observable<IconV1Model> {
        let url_ = this.baseUrl + "/api/v1/icon/DownloadIcon";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(icon);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadIcon(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadIcon(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<IconV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<IconV1Model>;
        }));
    }

    protected processDownloadIcon(response: HttpResponseBase): Observable<IconV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = IconV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(fileGuid: string): Observable<CommonResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/icon/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fileGuid);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonResponseV1Model>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<CommonResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommonResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class IconODClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfIconV1Model> {
        let url_ = this.baseUrl + "/api/IconOD?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfIconV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfIconV1Model>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfIconV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfIconV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get2(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfIconV1Model> {
        let url_ = this.baseUrl + "/api/IconOD/$count?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfIconV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfIconV1Model>;
        }));
    }

    protected processGet2(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfIconV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfIconV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class IconPUBLICClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    downloadFile(fileGuid: string): Observable<CommonResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/icon/download/{fileGuid}";
        if (fileGuid === undefined || fileGuid === null)
            throw new Error("The parameter 'fileGuid' must be defined.");
        url_ = url_.replace("{fileGuid}", encodeURIComponent("" + fileGuid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonResponseV1Model>;
        }));
    }

    protected processDownloadFile(response: HttpResponseBase): Observable<CommonResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommonResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadFilePreview(fileGuid: string): Observable<CommonResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/icon/download/preview/{fileGuid}";
        if (fileGuid === undefined || fileGuid === null)
            throw new Error("The parameter 'fileGuid' must be defined.");
        url_ = url_.replace("{fileGuid}", encodeURIComponent("" + fileGuid));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFilePreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFilePreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonResponseV1Model>;
        }));
    }

    protected processDownloadFilePreview(response: HttpResponseBase): Observable<CommonResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommonResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class GridClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getGridColumns(modelName: string): Observable<GridColumnV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/grid/{modelName}";
        if (modelName === undefined || modelName === null)
            throw new Error("The parameter 'modelName' must be defined.");
        url_ = url_.replace("{modelName}", encodeURIComponent("" + modelName));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetGridColumns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetGridColumns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GridColumnV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GridColumnV1Model[]>;
        }));
    }

    protected processGetGridColumns(response: HttpResponseBase): Observable<GridColumnV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(GridColumnV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FormCategoryClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAll(): Observable<FormCategoryV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/formCategory/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FormCategoryV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FormCategoryV1Model[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<FormCategoryV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FormCategoryV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FormClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAll(): Observable<FormV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/form/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FormV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FormV1Model[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<FormV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FormV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getWorkOrderForm(formId: number, workOrderId: number): Observable<FormV1Model> {
        let url_ = this.baseUrl + "/api/v1/form/{formId}/{workOrderId}";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        if (workOrderId === undefined || workOrderId === null)
            throw new Error("The parameter 'workOrderId' must be defined.");
        url_ = url_.replace("{workOrderId}", encodeURIComponent("" + workOrderId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorkOrderForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorkOrderForm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FormV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FormV1Model>;
        }));
    }

    protected processGetWorkOrderForm(response: HttpResponseBase): Observable<FormV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FormV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFormFields(formId: number): Observable<FormFieldV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/form/GetFormFields/{formId}";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFormFields(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFormFields(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FormFieldV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FormFieldV1Model[]>;
        }));
    }

    protected processGetFormFields(response: HttpResponseBase): Observable<FormFieldV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FormFieldV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getFormFieldRules(formId: number): Observable<FormFieldRuleV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/form/GetFormFieldRules/{formId}";
        if (formId === undefined || formId === null)
            throw new Error("The parameter 'formId' must be defined.");
        url_ = url_.replace("{formId}", encodeURIComponent("" + formId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFormFieldRules(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFormFieldRules(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FormFieldRuleV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FormFieldRuleV1Model[]>;
        }));
    }

    protected processGetFormFieldRules(response: HttpResponseBase): Observable<FormFieldRuleV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FormFieldRuleV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateForm(model: FormUpdateV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/form/UpdateForm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateForm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processUpdateForm(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    completeForm(model: FormUpdateV1Model): Observable<InsertResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/form/CompleteForm";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCompleteForm(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCompleteForm(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsertResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsertResponseV1Model>;
        }));
    }

    protected processCompleteForm(response: HttpResponseBase): Observable<InsertResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsertResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    formUpdateAsset(model: FormUpdateAssetV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/form/FormUpdateAsset";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processFormUpdateAsset(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processFormUpdateAsset(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processFormUpdateAsset(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    insertMultipleFormFieldFiles(files: FormFieldFileV1Model[]): Observable<string[]> {
        let url_ = this.baseUrl + "/api/v1/form/InsertMultipleFormFieldFiles";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(files);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertMultipleFormFieldFiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertMultipleFormFieldFiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processInsertMultipleFormFieldFiles(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    insertFormFieldFile(model: FormFieldFileV1Model): Observable<string> {
        let url_ = this.baseUrl + "/api/v1/form/InsertFormFieldFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertFormFieldFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertFormFieldFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processInsertFormFieldFile(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteFieldFormFile(model: FormFieldFileV1Model): Observable<CommonResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/form/DeleteFieldFormFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteFieldFormFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteFieldFormFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonResponseV1Model>;
        }));
    }

    protected processDeleteFieldFormFile(response: HttpResponseBase): Observable<CommonResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommonResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FloorClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getById(floorId: number): Observable<FloorV1Model> {
        let url_ = this.baseUrl + "/api/v1/floor/{floorId}";
        if (floorId === undefined || floorId === null)
            throw new Error("The parameter 'floorId' must be defined.");
        url_ = url_.replace("{floorId}", encodeURIComponent("" + floorId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FloorV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FloorV1Model>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<FloorV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FloorV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllByFacilityId(facilityId: number): Observable<FloorV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/floor/GetAllByFacilityId/{facilityId}";
        if (facilityId === undefined || facilityId === null)
            throw new Error("The parameter 'facilityId' must be defined.");
        url_ = url_.replace("{facilityId}", encodeURIComponent("" + facilityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByFacilityId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByFacilityId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FloorV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FloorV1Model[]>;
        }));
    }

    protected processGetAllByFacilityId(response: HttpResponseBase): Observable<FloorV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FloorV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    search(model: FloorSearchV1Model): Observable<FloorV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/floor/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FloorV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FloorV1Model[]>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<FloorV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FloorV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    insert(model: FloorInsertV1Model): Observable<InsertResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/floor/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsertResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsertResponseV1Model>;
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<InsertResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsertResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(model: FloorUpdateV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/floor/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(floorId: number): Observable<CommonResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/floor/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(floorId);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonResponseV1Model>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<CommonResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommonResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FloorODClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfFloorV1Model> {
        let url_ = this.baseUrl + "/api/FloorOD?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfFloorV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfFloorV1Model>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfFloorV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfFloorV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get2(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfFloorV1Model> {
        let url_ = this.baseUrl + "/api/FloorOD/$count?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfFloorV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfFloorV1Model>;
        }));
    }

    protected processGet2(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfFloorV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfFloorV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FacilityClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getById(facilityId: number): Observable<FacilityV1Model> {
        let url_ = this.baseUrl + "/api/v1/facility/{facilityId}";
        if (facilityId === undefined || facilityId === null)
            throw new Error("The parameter 'facilityId' must be defined.");
        url_ = url_.replace("{facilityId}", encodeURIComponent("" + facilityId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FacilityV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FacilityV1Model>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<FacilityV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FacilityV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchForMap(model: FacilitySearchV1Model): Observable<FacilityMapInfoV1Model> {
        let url_ = this.baseUrl + "/api/v1/facility/SearchForMap";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchForMap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchForMap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FacilityMapInfoV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FacilityMapInfoV1Model>;
        }));
    }

    protected processSearchForMap(response: HttpResponseBase): Observable<FacilityMapInfoV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = FacilityMapInfoV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    search(model: FacilitySearchV1Model): Observable<FacilityV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/facility/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FacilityV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FacilityV1Model[]>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<FacilityV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FacilityV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    insert(model: FacilityInsertV1Model): Observable<InsertResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/facility/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsertResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsertResponseV1Model>;
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<InsertResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsertResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(campusId: number): Observable<FacilityV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/facility/GetAll/{campusId}";
        if (campusId === undefined || campusId === null)
            throw new Error("The parameter 'campusId' must be defined.");
        url_ = url_.replace("{campusId}", encodeURIComponent("" + campusId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FacilityV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FacilityV1Model[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<FacilityV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(FacilityV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(model: FacilityUpdateV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/facility/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(facilityId: number): Observable<CommonResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/facility/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(facilityId);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonResponseV1Model>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<CommonResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommonResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class FacilityODClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfFacilityV1Model> {
        let url_ = this.baseUrl + "/api/FacilityOD?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfFacilityV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfFacilityV1Model>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfFacilityV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfFacilityV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get2(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfFacilityV1Model> {
        let url_ = this.baseUrl + "/api/FacilityOD/$count?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfFacilityV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfFacilityV1Model>;
        }));
    }

    protected processGet2(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfFacilityV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfFacilityV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CustomerAccountClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getById(customerAccountId: number): Observable<CustomerAccountV1Model> {
        let url_ = this.baseUrl + "/api/v1/customerAccount/{customerAccountId}";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined.");
        url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerAccountV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerAccountV1Model>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<CustomerAccountV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerAccountV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchForMap(model: CustomerAccountSearchV1Model): Observable<CustomerAccountMapInfoV1Model> {
        let url_ = this.baseUrl + "/api/v1/customerAccount/SearchForMap";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchForMap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchForMap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerAccountMapInfoV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerAccountMapInfoV1Model>;
        }));
    }

    protected processSearchForMap(response: HttpResponseBase): Observable<CustomerAccountMapInfoV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CustomerAccountMapInfoV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    search(model: CustomerAccountSearchV1Model): Observable<CustomerAccountV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/customerAccount/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerAccountV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerAccountV1Model[]>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<CustomerAccountV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerAccountV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    insert(model: CustomerAccountInsertV1Model): Observable<InsertResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/customerAccount/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsertResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsertResponseV1Model>;
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<InsertResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsertResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(): Observable<CustomerAccountV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/customerAccount/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CustomerAccountV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CustomerAccountV1Model[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CustomerAccountV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CustomerAccountV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(model: CustomerAccountUpdateV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/customerAccount/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(customerAccountId: number): Observable<CommonResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/customerAccount/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(customerAccountId);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonResponseV1Model>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<CommonResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommonResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CustomerAccountODClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfCustomerAccountV1Model> {
        let url_ = this.baseUrl + "/api/CustomerAccountOD?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfCustomerAccountV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfCustomerAccountV1Model>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfCustomerAccountV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfCustomerAccountV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get2(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfCustomerAccountV1Model> {
        let url_ = this.baseUrl + "/api/CustomerAccountOD/$count?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfCustomerAccountV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfCustomerAccountV1Model>;
        }));
    }

    protected processGet2(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfCustomerAccountV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfCustomerAccountV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CampusClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getById(campusId: number): Observable<CampusV1Model> {
        let url_ = this.baseUrl + "/api/v1/campus/{campusId}";
        if (campusId === undefined || campusId === null)
            throw new Error("The parameter 'campusId' must be defined.");
        url_ = url_.replace("{campusId}", encodeURIComponent("" + campusId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CampusV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CampusV1Model>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<CampusV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CampusV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    searchForMap(model: CampusSearchV1Model): Observable<CampusMapInfoV1Model> {
        let url_ = this.baseUrl + "/api/v1/campus/SearchForMap";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchForMap(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchForMap(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CampusMapInfoV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CampusMapInfoV1Model>;
        }));
    }

    protected processSearchForMap(response: HttpResponseBase): Observable<CampusMapInfoV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CampusMapInfoV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    search(model: CampusSearchV1Model): Observable<CampusV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/campus/Search";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearch(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearch(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CampusV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CampusV1Model[]>;
        }));
    }

    protected processSearch(response: HttpResponseBase): Observable<CampusV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CampusV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    insert(model: CampusInsertV1Model): Observable<InsertResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/campus/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsertResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsertResponseV1Model>;
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<InsertResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsertResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAllByAccount(): Observable<CampusV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/campus/GetAllByAccount";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CampusV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CampusV1Model[]>;
        }));
    }

    protected processGetAllByAccount(response: HttpResponseBase): Observable<CampusV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CampusV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAll(customerAccountId: number): Observable<CampusV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/campus/GetAll/{customerAccountId}";
        if (customerAccountId === undefined || customerAccountId === null)
            throw new Error("The parameter 'customerAccountId' must be defined.");
        url_ = url_.replace("{customerAccountId}", encodeURIComponent("" + customerAccountId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CampusV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CampusV1Model[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<CampusV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CampusV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(model: CampusUpdateV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/campus/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(campusId: number): Observable<CommonResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/campus/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(campusId);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonResponseV1Model>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<CommonResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommonResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CampusODClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfCampusV1Model> {
        let url_ = this.baseUrl + "/api/CampusOD?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfCampusV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfCampusV1Model>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfCampusV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfCampusV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get2(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfCampusV1Model> {
        let url_ = this.baseUrl + "/api/CampusOD/$count?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfCampusV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfCampusV1Model>;
        }));
    }

    protected processGet2(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfCampusV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfCampusV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CalloutClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    insert(model: CalloutLocationInsertV1Model): Observable<InsertResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/callout/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsertResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsertResponseV1Model>;
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<InsertResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsertResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBlueprintCallouts(blueprintId: number): Observable<CalloutLocationV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/callout/GetBlueprintCallouts/{blueprintId}";
        if (blueprintId === undefined || blueprintId === null)
            throw new Error("The parameter 'blueprintId' must be defined.");
        url_ = url_.replace("{blueprintId}", encodeURIComponent("" + blueprintId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBlueprintCallouts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBlueprintCallouts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalloutLocationV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalloutLocationV1Model[]>;
        }));
    }

    protected processGetBlueprintCallouts(response: HttpResponseBase): Observable<CalloutLocationV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(CalloutLocationV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    resetBlueprintCallouts(blueprintId: number): Observable<CommonResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/callout/ResetBlueprintCallouts/{blueprintId}";
        if (blueprintId === undefined || blueprintId === null)
            throw new Error("The parameter 'blueprintId' must be defined.");
        url_ = url_.replace("{blueprintId}", encodeURIComponent("" + blueprintId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processResetBlueprintCallouts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processResetBlueprintCallouts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonResponseV1Model>;
        }));
    }

    protected processResetBlueprintCallouts(response: HttpResponseBase): Observable<CommonResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommonResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CorrespondingAssetClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getCorrespondingAssets(assetId: number): Observable<AssetV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/correspondingAsset/GetCorrespondingAssets/{assetId}";
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCorrespondingAssets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCorrespondingAssets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetV1Model[]>;
        }));
    }

    protected processGetCorrespondingAssets(response: HttpResponseBase): Observable<AssetV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssetV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAvailableAssets(facilityId: number, assetId: number): Observable<AssetV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/correspondingAsset/GetAvailableAssets/{facilityId}/{assetId}";
        if (facilityId === undefined || facilityId === null)
            throw new Error("The parameter 'facilityId' must be defined.");
        url_ = url_.replace("{facilityId}", encodeURIComponent("" + facilityId));
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAvailableAssets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAvailableAssets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetV1Model[]>;
        }));
    }

    protected processGetAvailableAssets(response: HttpResponseBase): Observable<AssetV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssetV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    insert(model: CorrespondingAssetV1Model): Observable<InsertResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/correspondingAsset/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsertResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsertResponseV1Model>;
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<InsertResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsertResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    remove(model: CorrespondingAssetV1Model): Observable<CommonResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/correspondingAsset/Remove";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRemove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRemove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonResponseV1Model>;
        }));
    }

    protected processRemove(response: HttpResponseBase): Observable<CommonResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommonResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AssetClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getById(assetId: number): Observable<AssetV1Model> {
        let url_ = this.baseUrl + "/api/v1/asset/{assetId}";
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetV1Model>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<AssetV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByGuid(qrCodeGuid: string | null | undefined): Observable<AssetV1Model> {
        let url_ = this.baseUrl + "/api/v1/asset/GetByGuid?";
        if (qrCodeGuid !== undefined && qrCodeGuid !== null)
            url_ += "qrCodeGuid=" + encodeURIComponent("" + qrCodeGuid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByGuid(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByGuid(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetV1Model>;
        }));
    }

    protected processGetByGuid(response: HttpResponseBase): Observable<AssetV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByFacilityId(facilityId: number | undefined): Observable<AssetV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/asset/GetByFacilityId?";
        if (facilityId === null)
            throw new Error("The parameter 'facilityId' cannot be null.");
        else if (facilityId !== undefined)
            url_ += "facilityId=" + encodeURIComponent("" + facilityId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByFacilityId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByFacilityId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetV1Model[]>;
        }));
    }

    protected processGetByFacilityId(response: HttpResponseBase): Observable<AssetV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssetV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUnassignedFloorAssets(model: AssetSearchV1Model): Observable<AssetV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/asset/GetUnassignedFloorAssets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUnassignedFloorAssets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUnassignedFloorAssets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetV1Model[]>;
        }));
    }

    protected processGetUnassignedFloorAssets(response: HttpResponseBase): Observable<AssetV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssetV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getItemCount(assetId: number): Observable<AssetItemCountV1Model> {
        let url_ = this.baseUrl + "/api/v1/asset/GetItemCount/{assetId}";
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetItemCount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetItemCount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetItemCountV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetItemCountV1Model>;
        }));
    }

    protected processGetItemCount(response: HttpResponseBase): Observable<AssetItemCountV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetItemCountV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    insert(model: AssetInsertV1Model): Observable<InsertResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/asset/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsertResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsertResponseV1Model>;
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<InsertResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsertResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    insertForBlueprint(model: AssetInsertV1Model): Observable<AssetInsertForBlueprintResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/asset/InsertForBlueprint";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertForBlueprint(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertForBlueprint(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetInsertForBlueprintResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetInsertForBlueprintResponseV1Model>;
        }));
    }

    protected processInsertForBlueprint(response: HttpResponseBase): Observable<AssetInsertForBlueprintResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetInsertForBlueprintResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(model: AssetUpdateV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/asset/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(assetId: number): Observable<CommonResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/asset/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(assetId);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonResponseV1Model>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<CommonResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommonResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    checkForDuplicateAssetNumber(model: AssetNumberCheckV1Model): Observable<number> {
        let url_ = this.baseUrl + "/api/v1/asset/CheckForDuplicateAssetNumber";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCheckForDuplicateAssetNumber(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCheckForDuplicateAssetNumber(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<number>;
                }
            } else
                return _observableThrow(response_) as any as Observable<number>;
        }));
    }

    protected processCheckForDuplicateAssetNumber(response: HttpResponseBase): Observable<number> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    import(model: AssetImportM1V1Model): Observable<InsertResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/asset/Import";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsertResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsertResponseV1Model>;
        }));
    }

    protected processImport(response: HttpResponseBase): Observable<InsertResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsertResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    downloadImport(assetImportId: number): Observable<AssetImportFileV1Model> {
        let url_ = this.baseUrl + "/api/v1/asset/Download/Import/{assetImportId}";
        if (assetImportId === undefined || assetImportId === null)
            throw new Error("The parameter 'assetImportId' must be defined.");
        url_ = url_.replace("{assetImportId}", encodeURIComponent("" + assetImportId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadImport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadImport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetImportFileV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetImportFileV1Model>;
        }));
    }

    protected processDownloadImport(response: HttpResponseBase): Observable<AssetImportFileV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetImportFileV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AssetDocumentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAssetDocuments(assetId: number): Observable<AssetDocumentV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/assetDocument/GetAssetDocuments/{assetId}";
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetDocumentV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetDocumentV1Model[]>;
        }));
    }

    protected processGetAssetDocuments(response: HttpResponseBase): Observable<AssetDocumentV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssetDocumentV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getById(assetDocumentId: number): Observable<AssetDocumentV1Model> {
        let url_ = this.baseUrl + "/api/v1/assetDocument/{assetDocumentId}";
        if (assetDocumentId === undefined || assetDocumentId === null)
            throw new Error("The parameter 'assetDocumentId' must be defined.");
        url_ = url_.replace("{assetDocumentId}", encodeURIComponent("" + assetDocumentId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetDocumentV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetDocumentV1Model>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<AssetDocumentV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetDocumentV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    insert(model: AssetDocumentInsertV1Model): Observable<InsertResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/assetDocument/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsertResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsertResponseV1Model>;
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<InsertResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsertResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(model: AssetDocumentUpdateV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/assetDocument/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(fileGuid: string): Observable<CommonResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/assetDocument/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fileGuid);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonResponseV1Model>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<CommonResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommonResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AssetDrawingClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAssetDrawings(assetId: number): Observable<AssetDrawingV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/assetDrawing/GetAssetDrawings/{assetId}";
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetDrawings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetDrawings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetDrawingV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetDrawingV1Model[]>;
        }));
    }

    protected processGetAssetDrawings(response: HttpResponseBase): Observable<AssetDrawingV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssetDrawingV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getById(assetDrawingId: number): Observable<AssetDrawingV1Model> {
        let url_ = this.baseUrl + "/api/v1/assetDrawing/{assetDrawingId}";
        if (assetDrawingId === undefined || assetDrawingId === null)
            throw new Error("The parameter 'assetDrawingId' must be defined.");
        url_ = url_.replace("{assetDrawingId}", encodeURIComponent("" + assetDrawingId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetDrawingV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetDrawingV1Model>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<AssetDrawingV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetDrawingV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    insert(model: AssetDrawingInsertV1Model): Observable<InsertResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/assetDrawing/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsertResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsertResponseV1Model>;
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<InsertResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsertResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(model: AssetDrawingUpdateV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/assetDrawing/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(fileGuid: string): Observable<CommonResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/assetDrawing/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fileGuid);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonResponseV1Model>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<CommonResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommonResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AssetLocationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    searchBlueprintAssets(model: AssetLocationSearchV1Model): Observable<AssetLocationV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/assetLocation/SearchBlueprintAssets";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchBlueprintAssets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchBlueprintAssets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetLocationV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetLocationV1Model[]>;
        }));
    }

    protected processSearchBlueprintAssets(response: HttpResponseBase): Observable<AssetLocationV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssetLocationV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getById(assetLocationId: number): Observable<AssetLocationV1Model> {
        let url_ = this.baseUrl + "/api/v1/assetLocation/{assetLocationId}";
        if (assetLocationId === undefined || assetLocationId === null)
            throw new Error("The parameter 'assetLocationId' must be defined.");
        url_ = url_.replace("{assetLocationId}", encodeURIComponent("" + assetLocationId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetLocationV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetLocationV1Model>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<AssetLocationV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetLocationV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBlueprintAssets(blueprintId: number): Observable<AssetLocationV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/assetLocation/GetBlueprintAssets/{blueprintId}";
        if (blueprintId === undefined || blueprintId === null)
            throw new Error("The parameter 'blueprintId' must be defined.");
        url_ = url_.replace("{blueprintId}", encodeURIComponent("" + blueprintId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBlueprintAssets(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBlueprintAssets(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetLocationV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetLocationV1Model[]>;
        }));
    }

    protected processGetBlueprintAssets(response: HttpResponseBase): Observable<AssetLocationV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssetLocationV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    insert(model: AssetLocationInsertV1Model): Observable<InsertResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/assetLocation/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsertResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsertResponseV1Model>;
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<InsertResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsertResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(model: AssetLocationUpdateV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/assetLocation/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(assetLocationId: number): Observable<CommonResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/assetLocation/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(assetLocationId);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonResponseV1Model>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<CommonResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommonResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AssetODClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfAssetV1Model> {
        let url_ = this.baseUrl + "/api/AssetOD?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfAssetV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfAssetV1Model>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfAssetV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfAssetV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get2(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfAssetV1Model> {
        let url_ = this.baseUrl + "/api/AssetOD/$count?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfAssetV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfAssetV1Model>;
        }));
    }

    protected processGet2(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfAssetV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfAssetV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AssetPhotoClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAssetPhotos(assetId: number): Observable<AssetPhotoV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/assetPhoto/GetAssetPhotos/{assetId}";
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetPhotos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetPhotos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetPhotoV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetPhotoV1Model[]>;
        }));
    }

    protected processGetAssetPhotos(response: HttpResponseBase): Observable<AssetPhotoV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssetPhotoV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getAssetPhotoTypes(assetId: number): Observable<AssetPhotoTypeV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/assetPhoto/GetAssetPhotoTypes/{assetId}";
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetPhotoTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetPhotoTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetPhotoTypeV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetPhotoTypeV1Model[]>;
        }));
    }

    protected processGetAssetPhotoTypes(response: HttpResponseBase): Observable<AssetPhotoTypeV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssetPhotoTypeV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getById(assetPhotoId: number): Observable<AssetPhotoV1Model> {
        let url_ = this.baseUrl + "/api/v1/assetPhoto/{assetPhotoId}";
        if (assetPhotoId === undefined || assetPhotoId === null)
            throw new Error("The parameter 'assetPhotoId' must be defined.");
        url_ = url_.replace("{assetPhotoId}", encodeURIComponent("" + assetPhotoId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetPhotoV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetPhotoV1Model>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<AssetPhotoV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetPhotoV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    insert(model: AssetPhotoInsertV1Model): Observable<InsertResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/assetPhoto/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsertResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsertResponseV1Model>;
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<InsertResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsertResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(model: AssetPhotoUpdateV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/assetPhoto/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(fileGuid: string): Observable<CommonResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/assetPhoto/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fileGuid);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonResponseV1Model>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<CommonResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommonResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AssetVideoClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAssetVideos(assetId: number): Observable<AssetVideoV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/assetVideo/GetAssetVideos/{assetId}";
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetVideos(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetVideos(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetVideoV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetVideoV1Model[]>;
        }));
    }

    protected processGetAssetVideos(response: HttpResponseBase): Observable<AssetVideoV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssetVideoV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getById(assetVideoId: number): Observable<AssetVideoV1Model> {
        let url_ = this.baseUrl + "/api/v1/assetVideo/{assetVideoId}";
        if (assetVideoId === undefined || assetVideoId === null)
            throw new Error("The parameter 'assetVideoId' must be defined.");
        url_ = url_.replace("{assetVideoId}", encodeURIComponent("" + assetVideoId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetVideoV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetVideoV1Model>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<AssetVideoV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetVideoV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    insert(contentType: string | null | undefined, contentDisposition: string | null | undefined, headers: any[] | null | undefined, length: number | undefined, name: string | null | undefined, fileName: string | null | undefined, assetId: string | null | undefined): Observable<InsertResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/assetVideo/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (contentType !== null && contentType !== undefined)
            content_.append("ContentType", contentType.toString());
        if (contentDisposition !== null && contentDisposition !== undefined)
            content_.append("ContentDisposition", contentDisposition.toString());
        if (headers !== null && headers !== undefined)
            headers.forEach(item_ => content_.append("Headers", item_.toString()));
        if (length === null || length === undefined)
            throw new Error("The parameter 'length' cannot be null.");
        else
            content_.append("Length", length.toString());
        if (name !== null && name !== undefined)
            content_.append("Name", name.toString());
        if (fileName !== null && fileName !== undefined)
            content_.append("FileName", fileName.toString());
        if (assetId !== null && assetId !== undefined)
            content_.append("assetId", assetId.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsertResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsertResponseV1Model>;
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<InsertResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsertResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(model: AssetVideoUpdateV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/assetVideo/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(fileGuid: string): Observable<CommonResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/assetVideo/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fileGuid);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonResponseV1Model>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<CommonResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommonResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AssetWarrantyClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAssetWarranties(assetId: number): Observable<AssetWarrantyV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/assetWarranty/GetAssetWarrantys/{assetId}";
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAssetWarranties(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAssetWarranties(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetWarrantyV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetWarrantyV1Model[]>;
        }));
    }

    protected processGetAssetWarranties(response: HttpResponseBase): Observable<AssetWarrantyV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssetWarrantyV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getById(assetWarrantyId: number): Observable<AssetWarrantyV1Model> {
        let url_ = this.baseUrl + "/api/v1/assetWarranty/{assetWarrantyId}";
        if (assetWarrantyId === undefined || assetWarrantyId === null)
            throw new Error("The parameter 'assetWarrantyId' must be defined.");
        url_ = url_.replace("{assetWarrantyId}", encodeURIComponent("" + assetWarrantyId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetWarrantyV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetWarrantyV1Model>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<AssetWarrantyV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetWarrantyV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    insert(model: AssetWarrantyInsertV1Model): Observable<InsertResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/assetWarranty/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsertResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsertResponseV1Model>;
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<InsertResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsertResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(model: AssetWarrantyUpdateV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/assetWarranty/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(fileGuid: string): Observable<CommonResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/assetWarranty/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(fileGuid);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonResponseV1Model>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<CommonResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommonResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class CorrespondingAssetODClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfAssetV1Model> {
        let url_ = this.baseUrl + "/api/CorrespondingAssetOD?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfAssetV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfAssetV1Model>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfAssetV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfAssetV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get2(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfAssetV1Model> {
        let url_ = this.baseUrl + "/api/CorrespondingAssetOD/$count?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfAssetV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfAssetV1Model>;
        }));
    }

    protected processGet2(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfAssetV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfAssetV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AssetProfileTypeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAllByProfileId(assetProfileTypeId: number | undefined): Observable<AssetProfileTypeV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/asset-profile-type/GetAllByProfileId?";
        if (assetProfileTypeId === null)
            throw new Error("The parameter 'assetProfileTypeId' cannot be null.");
        else if (assetProfileTypeId !== undefined)
            url_ += "assetProfileTypeId=" + encodeURIComponent("" + assetProfileTypeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllByProfileId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllByProfileId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetProfileTypeV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetProfileTypeV1Model[]>;
        }));
    }

    protected processGetAllByProfileId(response: HttpResponseBase): Observable<AssetProfileTypeV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssetProfileTypeV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    insert(model: AssetProfileTypeInsertV1Model): Observable<InsertResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/asset-profile-type/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsertResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsertResponseV1Model>;
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<InsertResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsertResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(model: AssetProfileTypeUpdateV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/asset-profile-type/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AssetProfileTypeODClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfAssetProfileTypeV1Model> {
        let url_ = this.baseUrl + "/api/AssetProfileTypeOD?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfAssetProfileTypeV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfAssetProfileTypeV1Model>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfAssetProfileTypeV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfAssetProfileTypeV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get2(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfAssetProfileTypeV1Model> {
        let url_ = this.baseUrl + "/api/AssetProfileTypeOD/$count?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfAssetProfileTypeV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfAssetProfileTypeV1Model>;
        }));
    }

    protected processGet2(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfAssetProfileTypeV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfAssetProfileTypeV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AssetClassClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAll(): Observable<AssetClassV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/asset-class/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetClassV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetClassV1Model[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<AssetClassV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssetClassV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getById(assetClassId: number): Observable<AssetClassV1Model> {
        let url_ = this.baseUrl + "/api/v1/asset-class/{assetClassId}";
        if (assetClassId === undefined || assetClassId === null)
            throw new Error("The parameter 'assetClassId' must be defined.");
        url_ = url_.replace("{assetClassId}", encodeURIComponent("" + assetClassId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetClassV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetClassV1Model>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<AssetClassV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AssetClassV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    insert(model: AssetClassInsertV1Model): Observable<InsertResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/asset-class/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsertResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsertResponseV1Model>;
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<InsertResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsertResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(model: AssetClassUpdateV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/asset-class/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getProfiles(): Observable<AssetProfileV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/asset-class/profiles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProfiles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProfiles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AssetProfileV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AssetProfileV1Model[]>;
        }));
    }

    protected processGetProfiles(response: HttpResponseBase): Observable<AssetProfileV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AssetProfileV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AssetClassODClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfAssetClassV1Model> {
        let url_ = this.baseUrl + "/api/AssetClassOD?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfAssetClassV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfAssetClassV1Model>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfAssetClassV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfAssetClassV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get2(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfAssetClassV1Model> {
        let url_ = this.baseUrl + "/api/AssetClassOD/$count?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfAssetClassV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfAssetClassV1Model>;
        }));
    }

    protected processGet2(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfAssetClassV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfAssetClassV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AssetProfileClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAboveCeilingProfile(assetId: number): Observable<ProfileAboveCeilingV1Model> {
        let url_ = this.baseUrl + "/api/v1/assetProfile/GetAboveCeilingProfile/{assetId}";
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAboveCeilingProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAboveCeilingProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileAboveCeilingV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileAboveCeilingV1Model>;
        }));
    }

    protected processGetAboveCeilingProfile(response: HttpResponseBase): Observable<ProfileAboveCeilingV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfileAboveCeilingV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getBelowCeilingProfile(assetId: number): Observable<ProfileBelowCeilingV1Model> {
        let url_ = this.baseUrl + "/api/v1/assetProfile/GetBelowCeilingProfile/{assetId}";
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBelowCeilingProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBelowCeilingProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileBelowCeilingV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileBelowCeilingV1Model>;
        }));
    }

    protected processGetBelowCeilingProfile(response: HttpResponseBase): Observable<ProfileBelowCeilingV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfileBelowCeilingV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDamperProfile(assetId: number): Observable<ProfileDamperV1Model> {
        let url_ = this.baseUrl + "/api/v1/assetProfile/GetDamperProfile/{assetId}";
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDamperProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDamperProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileDamperV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileDamperV1Model>;
        }));
    }

    protected processGetDamperProfile(response: HttpResponseBase): Observable<ProfileDamperV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfileDamperV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getDoorProfile(assetId: number): Observable<ProfileDoorV1Model> {
        let url_ = this.baseUrl + "/api/v1/assetProfile/GetDoorProfile/{assetId}";
        if (assetId === undefined || assetId === null)
            throw new Error("The parameter 'assetId' must be defined.");
        url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetDoorProfile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetDoorProfile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProfileDoorV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProfileDoorV1Model>;
        }));
    }

    protected processGetDoorProfile(response: HttpResponseBase): Observable<ProfileDoorV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProfileDoorV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getSpecialConditions(profileTypeId: number): Observable<string[]> {
        let url_ = this.baseUrl + "/api/v1/assetProfile/GetSpecialConditions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(profileTypeId);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSpecialConditions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSpecialConditions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetSpecialConditions(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AccountClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    getAll(): Observable<AccountV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/account/GetAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountV1Model[]>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<AccountV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccountV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getById(accountID: number): Observable<AccountV1Model> {
        let url_ = this.baseUrl + "/api/v1/account/{accountID}";
        if (accountID === undefined || accountID === null)
            throw new Error("The parameter 'accountID' must be defined.");
        url_ = url_.replace("{accountID}", encodeURIComponent("" + accountID));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetById(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetById(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountV1Model>;
        }));
    }

    protected processGetById(response: HttpResponseBase): Observable<AccountV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getByAccountCode(accountCode: string): Observable<AccountV1Model> {
        let url_ = this.baseUrl + "/api/v1/account/GetByAccountCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(accountCode);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByAccountCode(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByAccountCode(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountV1Model>;
        }));
    }

    protected processGetByAccountCode(response: HttpResponseBase): Observable<AccountV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    getUserAll(): Observable<AccountV1Model[]> {
        let url_ = this.baseUrl + "/api/v1/account/GetUserAll";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUserAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUserAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountV1Model[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountV1Model[]>;
        }));
    }

    protected processGetUserAll(response: HttpResponseBase): Observable<AccountV1Model[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(AccountV1Model.fromJS(item));
            }
            else {
                result200 = <any>null;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    insert(model: AccountInsertV1Model): Observable<InsertResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/account/Insert";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<InsertResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<InsertResponseV1Model>;
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<InsertResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = InsertResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    update(model: AccountUpdateV1Model): Observable<UpdateResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/account/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateResponseV1Model>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    delete(accountId: number): Observable<CommonResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/account/Delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(accountId);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonResponseV1Model>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<CommonResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommonResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    updateLogo(model: AccountLogoUploadV1Model): Observable<string> {
        let url_ = this.baseUrl + "/api/v1/account/UpdateLogo";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string>;
        }));
    }

    protected processUpdateLogo(response: HttpResponseBase): Observable<string> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    deleteLogo(fileGuid: string | null | undefined): Observable<CommonResponseV1Model> {
        let url_ = this.baseUrl + "/api/v1/account/DeleteLogo?";
        if (fileGuid !== undefined && fileGuid !== null)
            url_ += "fileGuid=" + encodeURIComponent("" + fileGuid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteLogo(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteLogo(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CommonResponseV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CommonResponseV1Model>;
        }));
    }

    protected processDeleteLogo(response: HttpResponseBase): Observable<CommonResponseV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CommonResponseV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    changeAccount(accountCode: string): Observable<AuthSecContext> {
        let url_ = this.baseUrl + "/api/v1/account/ChangeAccount/{accountCode}";
        if (accountCode === undefined || accountCode === null)
            throw new Error("The parameter 'accountCode' must be defined.");
        url_ = url_.replace("{accountCode}", encodeURIComponent("" + accountCode));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processChangeAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processChangeAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AuthSecContext>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AuthSecContext>;
        }));
    }

    protected processChangeAccount(response: HttpResponseBase): Observable<AuthSecContext> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AuthSecContext.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

@Injectable({
    providedIn: 'root'
})
export class AccountODClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    get(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfAccountV1Model> {
        let url_ = this.baseUrl + "/api/AccountOD?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfAccountV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfAccountV1Model>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfAccountV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfAccountV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    get2(api_version: string | null | undefined, select: string | null | undefined, expand: string | null | undefined, filter: string | null | undefined, orderby: string | null | undefined, top: number | undefined, skip: number | undefined, count: boolean | undefined): Observable<ODataValueOfIEnumerableOfAccountV1Model> {
        let url_ = this.baseUrl + "/api/AccountOD/$count?";
        if (api_version !== undefined && api_version !== null)
            url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
        if (select !== undefined && select !== null)
            url_ += "select=" + encodeURIComponent("" + select) + "&";
        if (expand !== undefined && expand !== null)
            url_ += "expand=" + encodeURIComponent("" + expand) + "&";
        if (filter !== undefined && filter !== null)
            url_ += "filter=" + encodeURIComponent("" + filter) + "&";
        if (orderby !== undefined && orderby !== null)
            url_ += "orderby=" + encodeURIComponent("" + orderby) + "&";
        if (top === null)
            throw new Error("The parameter 'top' cannot be null.");
        else if (top !== undefined)
            url_ += "top=" + encodeURIComponent("" + top) + "&";
        if (skip === null)
            throw new Error("The parameter 'skip' cannot be null.");
        else if (skip !== undefined)
            url_ += "skip=" + encodeURIComponent("" + skip) + "&";
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            withCredentials: true,
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ODataValueOfIEnumerableOfAccountV1Model>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ODataValueOfIEnumerableOfAccountV1Model>;
        }));
    }

    protected processGet2(response: HttpResponseBase): Observable<ODataValueOfIEnumerableOfAccountV1Model> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ODataValueOfIEnumerableOfAccountV1Model.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export class AuthSecContext implements IAuthSecContext {
    context?: SecurityContextV1Model | null;
    isAuthenticated?: boolean;
    token?: string | null;
    loginError?: boolean;
    errorMessage?: string | null;
    expires?: Date;
    isExpired?: boolean;
    mfastatus?: MFAStatus;

    constructor(data?: IAuthSecContext) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.context = _data["context"] ? SecurityContextV1Model.fromJS(_data["context"]) : <any>null;
            this.isAuthenticated = _data["isAuthenticated"] !== undefined ? _data["isAuthenticated"] : <any>null;
            this.token = _data["token"] !== undefined ? _data["token"] : <any>null;
            this.loginError = _data["loginError"] !== undefined ? _data["loginError"] : <any>null;
            this.errorMessage = _data["errorMessage"] !== undefined ? _data["errorMessage"] : <any>null;
            this.expires = _data["expires"] ? new Date(_data["expires"].toString()) : <any>null;
            this.isExpired = _data["isExpired"] !== undefined ? _data["isExpired"] : <any>null;
            this.mfastatus = _data["mfastatus"] !== undefined ? _data["mfastatus"] : <any>null;
        }
    }

    static fromJS(data: any): AuthSecContext {
        data = typeof data === 'object' ? data : {};
        let result = new AuthSecContext();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["context"] = this.context ? this.context.toJSON() : <any>null;
        data["isAuthenticated"] = this.isAuthenticated !== undefined ? this.isAuthenticated : <any>null;
        data["token"] = this.token !== undefined ? this.token : <any>null;
        data["loginError"] = this.loginError !== undefined ? this.loginError : <any>null;
        data["errorMessage"] = this.errorMessage !== undefined ? this.errorMessage : <any>null;
        data["expires"] = this.expires ? this.expires.toISOString() : <any>null;
        data["isExpired"] = this.isExpired !== undefined ? this.isExpired : <any>null;
        data["mfastatus"] = this.mfastatus !== undefined ? this.mfastatus : <any>null;
        return data;
    }
}

export interface IAuthSecContext {
    context?: SecurityContextV1Model | null;
    isAuthenticated?: boolean;
    token?: string | null;
    loginError?: boolean;
    errorMessage?: string | null;
    expires?: Date;
    isExpired?: boolean;
    mfastatus?: MFAStatus;
}

export class SecurityContextV1Model implements ISecurityContextV1Model {
    user?: UserSecV1Model | null;

    constructor(data?: ISecurityContextV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user = _data["user"] ? UserSecV1Model.fromJS(_data["user"]) : <any>null;
        }
    }

    static fromJS(data: any): SecurityContextV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new SecurityContextV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user"] = this.user ? this.user.toJSON() : <any>null;
        return data;
    }
}

export interface ISecurityContextV1Model {
    user?: UserSecV1Model | null;
}

export class UserSecV1Model implements IUserSecV1Model {
    currentUserId?: number;
    currentUserIdForAudit?: number;
    currentAccessGuid?: string | null;
    name?: string | null;
    email?: string | null;
    permissions?: APIPermissionModel[] | null;
    accountIds?: number[] | null;
    accountCodes?: string[] | null;
    currentAccountId?: number;
    currentAccountCode?: string | null;
    isGlobal?: boolean;
    lineColor?: string | null;

    constructor(data?: IUserSecV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentUserId = _data["currentUserId"] !== undefined ? _data["currentUserId"] : <any>null;
            this.currentUserIdForAudit = _data["currentUserIdForAudit"] !== undefined ? _data["currentUserIdForAudit"] : <any>null;
            this.currentAccessGuid = _data["currentAccessGuid"] !== undefined ? _data["currentAccessGuid"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(APIPermissionModel.fromJS(item));
            }
            else {
                this.permissions = <any>null;
            }
            if (Array.isArray(_data["accountIds"])) {
                this.accountIds = [] as any;
                for (let item of _data["accountIds"])
                    this.accountIds!.push(item);
            }
            else {
                this.accountIds = <any>null;
            }
            if (Array.isArray(_data["accountCodes"])) {
                this.accountCodes = [] as any;
                for (let item of _data["accountCodes"])
                    this.accountCodes!.push(item);
            }
            else {
                this.accountCodes = <any>null;
            }
            this.currentAccountId = _data["currentAccountId"] !== undefined ? _data["currentAccountId"] : <any>null;
            this.currentAccountCode = _data["currentAccountCode"] !== undefined ? _data["currentAccountCode"] : <any>null;
            this.isGlobal = _data["isGlobal"] !== undefined ? _data["isGlobal"] : <any>null;
            this.lineColor = _data["lineColor"] !== undefined ? _data["lineColor"] : <any>null;
        }
    }

    static fromJS(data: any): UserSecV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new UserSecV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentUserId"] = this.currentUserId !== undefined ? this.currentUserId : <any>null;
        data["currentUserIdForAudit"] = this.currentUserIdForAudit !== undefined ? this.currentUserIdForAudit : <any>null;
        data["currentAccessGuid"] = this.currentAccessGuid !== undefined ? this.currentAccessGuid : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item.toJSON());
        }
        if (Array.isArray(this.accountIds)) {
            data["accountIds"] = [];
            for (let item of this.accountIds)
                data["accountIds"].push(item);
        }
        if (Array.isArray(this.accountCodes)) {
            data["accountCodes"] = [];
            for (let item of this.accountCodes)
                data["accountCodes"].push(item);
        }
        data["currentAccountId"] = this.currentAccountId !== undefined ? this.currentAccountId : <any>null;
        data["currentAccountCode"] = this.currentAccountCode !== undefined ? this.currentAccountCode : <any>null;
        data["isGlobal"] = this.isGlobal !== undefined ? this.isGlobal : <any>null;
        data["lineColor"] = this.lineColor !== undefined ? this.lineColor : <any>null;
        return data;
    }
}

export interface IUserSecV1Model {
    currentUserId?: number;
    currentUserIdForAudit?: number;
    currentAccessGuid?: string | null;
    name?: string | null;
    email?: string | null;
    permissions?: APIPermissionModel[] | null;
    accountIds?: number[] | null;
    accountCodes?: string[] | null;
    currentAccountId?: number;
    currentAccountCode?: string | null;
    isGlobal?: boolean;
    lineColor?: string | null;
}

export class APIPermissionModel implements IAPIPermissionModel {
    apiPermissionId?: number;
    apiPermission?: string | null;

    constructor(data?: IAPIPermissionModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.apiPermissionId = _data["apiPermissionId"] !== undefined ? _data["apiPermissionId"] : <any>null;
            this.apiPermission = _data["apiPermission"] !== undefined ? _data["apiPermission"] : <any>null;
        }
    }

    static fromJS(data: any): APIPermissionModel {
        data = typeof data === 'object' ? data : {};
        let result = new APIPermissionModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["apiPermissionId"] = this.apiPermissionId !== undefined ? this.apiPermissionId : <any>null;
        data["apiPermission"] = this.apiPermission !== undefined ? this.apiPermission : <any>null;
        return data;
    }
}

export interface IAPIPermissionModel {
    apiPermissionId?: number;
    apiPermission?: string | null;
}

export enum MFAStatus {
    SetupRequired = 1,
    NeedsAuthenticated = 2,
    Authenticated = 3,
}

export class AuthParam implements IAuthParam {
    clientid?: string | null;
    clientsecret?: string | null;
    username?: string | null;
    password?: string | null;
    scope?: string | null;
    accessGuid?: string | null;

    constructor(data?: IAuthParam) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientid = _data["clientid"] !== undefined ? _data["clientid"] : <any>null;
            this.clientsecret = _data["clientsecret"] !== undefined ? _data["clientsecret"] : <any>null;
            this.username = _data["username"] !== undefined ? _data["username"] : <any>null;
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
            this.scope = _data["scope"] !== undefined ? _data["scope"] : <any>null;
            this.accessGuid = _data["accessGuid"] !== undefined ? _data["accessGuid"] : <any>null;
        }
    }

    static fromJS(data: any): AuthParam {
        data = typeof data === 'object' ? data : {};
        let result = new AuthParam();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientid"] = this.clientid !== undefined ? this.clientid : <any>null;
        data["clientsecret"] = this.clientsecret !== undefined ? this.clientsecret : <any>null;
        data["username"] = this.username !== undefined ? this.username : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        data["scope"] = this.scope !== undefined ? this.scope : <any>null;
        data["accessGuid"] = this.accessGuid !== undefined ? this.accessGuid : <any>null;
        return data;
    }
}

export interface IAuthParam {
    clientid?: string | null;
    clientsecret?: string | null;
    username?: string | null;
    password?: string | null;
    scope?: string | null;
    accessGuid?: string | null;
}

export class AuthMFASetup implements IAuthMFASetup {
    secret?: string | null;
    code?: string | null;

    constructor(data?: IAuthMFASetup) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.secret = _data["secret"] !== undefined ? _data["secret"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
        }
    }

    static fromJS(data: any): AuthMFASetup {
        data = typeof data === 'object' ? data : {};
        let result = new AuthMFASetup();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["secret"] = this.secret !== undefined ? this.secret : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        return data;
    }
}

export interface IAuthMFASetup {
    secret?: string | null;
    code?: string | null;
}

export class AuthSecContextInt implements IAuthSecContextInt {
    context?: AuthSecContext | null;

    constructor(data?: IAuthSecContextInt) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.context = _data["context"] ? AuthSecContext.fromJS(_data["context"]) : <any>null;
        }
    }

    static fromJS(data: any): AuthSecContextInt {
        data = typeof data === 'object' ? data : {};
        let result = new AuthSecContextInt();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["context"] = this.context ? this.context.toJSON() : <any>null;
        return data;
    }
}

export interface IAuthSecContextInt {
    context?: AuthSecContext | null;
}

export class RoleV1Model implements IRoleV1Model {
    roleId?: number;
    role?: string | null;
    isGlobal?: boolean;
    permissionCount?: number | null;

    constructor(data?: IRoleV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"] !== undefined ? _data["roleId"] : <any>null;
            this.role = _data["role"] !== undefined ? _data["role"] : <any>null;
            this.isGlobal = _data["isGlobal"] !== undefined ? _data["isGlobal"] : <any>null;
            this.permissionCount = _data["permissionCount"] !== undefined ? _data["permissionCount"] : <any>null;
        }
    }

    static fromJS(data: any): RoleV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new RoleV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId !== undefined ? this.roleId : <any>null;
        data["role"] = this.role !== undefined ? this.role : <any>null;
        data["isGlobal"] = this.isGlobal !== undefined ? this.isGlobal : <any>null;
        data["permissionCount"] = this.permissionCount !== undefined ? this.permissionCount : <any>null;
        return data;
    }
}

export interface IRoleV1Model {
    roleId?: number;
    role?: string | null;
    isGlobal?: boolean;
    permissionCount?: number | null;
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export class ODataValueOfIEnumerableOfUserV1Model implements IODataValueOfIEnumerableOfUserV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: UserV1Model[] | null;

    constructor(data?: IODataValueOfIEnumerableOfUserV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(UserV1Model.fromJS(item));
            }
            else {
                this.value = <any>null;
            }
        }
    }

    static fromJS(data: any): ODataValueOfIEnumerableOfUserV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new ODataValueOfIEnumerableOfUserV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export interface IODataValueOfIEnumerableOfUserV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: UserV1Model[] | null;
}

export class UserV1Model implements IUserV1Model {
    userId?: number;
    firstName?: string | null;
    lastName?: string | null;
    name?: string | null;
    jobTitle?: string | null;
    country?: string | null;
    address?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    phone?: string | null;
    email?: string | null;
    createdDate?: Date;
    createdByUserId?: number;
    updatedDate?: Date;
    updatedByUserId?: number | null;
    notes?: string | null;
    isActive?: boolean;
    roles?: RoleM1V1Model[] | null;
    lastLogin?: Date | null;
    resetCode?: string | null;
    resetDate?: Date | null;
    lastAccountId?: number;
    lineColor?: string | null;
    isGlobal?: boolean;
    accountId?: number;

    constructor(data?: IUserV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.jobTitle = _data["jobTitle"] !== undefined ? _data["jobTitle"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.address = _data["address"] !== undefined ? _data["address"] : <any>null;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.createdByUserId = _data["createdByUserId"] !== undefined ? _data["createdByUserId"] : <any>null;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>null;
            this.updatedByUserId = _data["updatedByUserId"] !== undefined ? _data["updatedByUserId"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(RoleM1V1Model.fromJS(item));
            }
            else {
                this.roles = <any>null;
            }
            this.lastLogin = _data["lastLogin"] ? new Date(_data["lastLogin"].toString()) : <any>null;
            this.resetCode = _data["resetCode"] !== undefined ? _data["resetCode"] : <any>null;
            this.resetDate = _data["resetDate"] ? new Date(_data["resetDate"].toString()) : <any>null;
            this.lastAccountId = _data["lastAccountId"] !== undefined ? _data["lastAccountId"] : <any>null;
            this.lineColor = _data["lineColor"] !== undefined ? _data["lineColor"] : <any>null;
            this.isGlobal = _data["isGlobal"] !== undefined ? _data["isGlobal"] : <any>null;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : <any>null;
        }
    }

    static fromJS(data: any): UserV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new UserV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["jobTitle"] = this.jobTitle !== undefined ? this.jobTitle : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["address"] = this.address !== undefined ? this.address : <any>null;
        data["address2"] = this.address2 !== undefined ? this.address2 : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["zip"] = this.zip !== undefined ? this.zip : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["createdByUserId"] = this.createdByUserId !== undefined ? this.createdByUserId : <any>null;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>null;
        data["updatedByUserId"] = this.updatedByUserId !== undefined ? this.updatedByUserId : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item.toJSON());
        }
        data["lastLogin"] = this.lastLogin ? this.lastLogin.toISOString() : <any>null;
        data["resetCode"] = this.resetCode !== undefined ? this.resetCode : <any>null;
        data["resetDate"] = this.resetDate ? this.resetDate.toISOString() : <any>null;
        data["lastAccountId"] = this.lastAccountId !== undefined ? this.lastAccountId : <any>null;
        data["lineColor"] = this.lineColor !== undefined ? this.lineColor : <any>null;
        data["isGlobal"] = this.isGlobal !== undefined ? this.isGlobal : <any>null;
        data["accountId"] = this.accountId !== undefined ? this.accountId : <any>null;
        return data;
    }
}

export interface IUserV1Model {
    userId?: number;
    firstName?: string | null;
    lastName?: string | null;
    name?: string | null;
    jobTitle?: string | null;
    country?: string | null;
    address?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    phone?: string | null;
    email?: string | null;
    createdDate?: Date;
    createdByUserId?: number;
    updatedDate?: Date;
    updatedByUserId?: number | null;
    notes?: string | null;
    isActive?: boolean;
    roles?: RoleM1V1Model[] | null;
    lastLogin?: Date | null;
    resetCode?: string | null;
    resetDate?: Date | null;
    lastAccountId?: number;
    lineColor?: string | null;
    isGlobal?: boolean;
    accountId?: number;
}

export class RoleM1V1Model implements IRoleM1V1Model {
    roleId?: number;
    role?: string | null;
    isGlobal?: boolean;

    constructor(data?: IRoleM1V1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.roleId = _data["roleId"] !== undefined ? _data["roleId"] : <any>null;
            this.role = _data["role"] !== undefined ? _data["role"] : <any>null;
            this.isGlobal = _data["isGlobal"] !== undefined ? _data["isGlobal"] : <any>null;
        }
    }

    static fromJS(data: any): RoleM1V1Model {
        data = typeof data === 'object' ? data : {};
        let result = new RoleM1V1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["roleId"] = this.roleId !== undefined ? this.roleId : <any>null;
        data["role"] = this.role !== undefined ? this.role : <any>null;
        data["isGlobal"] = this.isGlobal !== undefined ? this.isGlobal : <any>null;
        return data;
    }
}

export interface IRoleM1V1Model {
    roleId?: number;
    role?: string | null;
    isGlobal?: boolean;
}

export class UpdateResponseV1Model implements IUpdateResponseV1Model {
    totalRowsUpdated?: number;

    constructor(data?: IUpdateResponseV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalRowsUpdated = _data["totalRowsUpdated"] !== undefined ? _data["totalRowsUpdated"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateResponseV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateResponseV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalRowsUpdated"] = this.totalRowsUpdated !== undefined ? this.totalRowsUpdated : <any>null;
        return data;
    }
}

export interface IUpdateResponseV1Model {
    totalRowsUpdated?: number;
}

export class ResetPasswordV1Model implements IResetPasswordV1Model {
    email?: string | null;
    password?: string | null;
    code?: string | null;

    constructor(data?: IResetPasswordV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
            this.code = _data["code"] !== undefined ? _data["code"] : <any>null;
        }
    }

    static fromJS(data: any): ResetPasswordV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new ResetPasswordV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        data["code"] = this.code !== undefined ? this.code : <any>null;
        return data;
    }
}

export interface IResetPasswordV1Model {
    email?: string | null;
    password?: string | null;
    code?: string | null;
}

export class CommonResponseV1Model implements ICommonResponseV1Model {
    success?: boolean;
    message?: string | null;

    constructor(data?: ICommonResponseV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.success = _data["success"] !== undefined ? _data["success"] : <any>null;
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
        }
    }

    static fromJS(data: any): CommonResponseV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new CommonResponseV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["success"] = this.success !== undefined ? this.success : <any>null;
        data["message"] = this.message !== undefined ? this.message : <any>null;
        return data;
    }
}

export interface ICommonResponseV1Model {
    success?: boolean;
    message?: string | null;
}

export class InsertResponseV1Model extends CommonResponseV1Model implements IInsertResponseV1Model {
    identityId?: number;
    identityIds?: number[] | null;

    constructor(data?: IInsertResponseV1Model) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.identityId = _data["identityId"] !== undefined ? _data["identityId"] : <any>null;
            if (Array.isArray(_data["identityIds"])) {
                this.identityIds = [] as any;
                for (let item of _data["identityIds"])
                    this.identityIds!.push(item);
            }
            else {
                this.identityIds = <any>null;
            }
        }
    }

    static override fromJS(data: any): InsertResponseV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new InsertResponseV1Model();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["identityId"] = this.identityId !== undefined ? this.identityId : <any>null;
        if (Array.isArray(this.identityIds)) {
            data["identityIds"] = [];
            for (let item of this.identityIds)
                data["identityIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IInsertResponseV1Model extends ICommonResponseV1Model {
    identityId?: number;
    identityIds?: number[] | null;
}

export class UserInsertV1Model implements IUserInsertV1Model {
    firstName?: string | null;
    lastName?: string | null;
    jobTitle?: string | null;
    country?: string | null;
    address?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    phone?: string | null;
    email?: string | null;
    notes?: string | null;
    isActive?: boolean;
    lineColor?: string | null;
    password?: string | null;
    roles?: number[] | null;

    constructor(data?: IUserInsertV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.jobTitle = _data["jobTitle"] !== undefined ? _data["jobTitle"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.address = _data["address"] !== undefined ? _data["address"] : <any>null;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.lineColor = _data["lineColor"] !== undefined ? _data["lineColor"] : <any>null;
            this.password = _data["password"] !== undefined ? _data["password"] : <any>null;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            else {
                this.roles = <any>null;
            }
        }
    }

    static fromJS(data: any): UserInsertV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new UserInsertV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["jobTitle"] = this.jobTitle !== undefined ? this.jobTitle : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["address"] = this.address !== undefined ? this.address : <any>null;
        data["address2"] = this.address2 !== undefined ? this.address2 : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["zip"] = this.zip !== undefined ? this.zip : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["lineColor"] = this.lineColor !== undefined ? this.lineColor : <any>null;
        data["password"] = this.password !== undefined ? this.password : <any>null;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface IUserInsertV1Model {
    firstName?: string | null;
    lastName?: string | null;
    jobTitle?: string | null;
    country?: string | null;
    address?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    phone?: string | null;
    email?: string | null;
    notes?: string | null;
    isActive?: boolean;
    lineColor?: string | null;
    password?: string | null;
    roles?: number[] | null;
}

export class UserAccountV1Model implements IUserAccountV1Model {
    accountId?: number;
    accountName?: string | null;
    userId?: number;

    constructor(data?: IUserAccountV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : <any>null;
            this.accountName = _data["accountName"] !== undefined ? _data["accountName"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
        }
    }

    static fromJS(data: any): UserAccountV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new UserAccountV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId !== undefined ? this.accountId : <any>null;
        data["accountName"] = this.accountName !== undefined ? this.accountName : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        return data;
    }
}

export interface IUserAccountV1Model {
    accountId?: number;
    accountName?: string | null;
    userId?: number;
}

export class UserUpdateV1Model implements IUserUpdateV1Model {
    userId?: number;
    firstName?: string | null;
    lastName?: string | null;
    jobTitle?: string | null;
    country?: string | null;
    address?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    phone?: string | null;
    email?: string | null;
    notes?: string | null;
    isActive?: boolean;
    lineColor?: string | null;
    roles?: number[] | null;

    constructor(data?: IUserUpdateV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : <any>null;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : <any>null;
            this.jobTitle = _data["jobTitle"] !== undefined ? _data["jobTitle"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.address = _data["address"] !== undefined ? _data["address"] : <any>null;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : <any>null;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : <any>null;
            this.email = _data["email"] !== undefined ? _data["email"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.lineColor = _data["lineColor"] !== undefined ? _data["lineColor"] : <any>null;
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(item);
            }
            else {
                this.roles = <any>null;
            }
        }
    }

    static fromJS(data: any): UserUpdateV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new UserUpdateV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["firstName"] = this.firstName !== undefined ? this.firstName : <any>null;
        data["lastName"] = this.lastName !== undefined ? this.lastName : <any>null;
        data["jobTitle"] = this.jobTitle !== undefined ? this.jobTitle : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["address"] = this.address !== undefined ? this.address : <any>null;
        data["address2"] = this.address2 !== undefined ? this.address2 : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["zip"] = this.zip !== undefined ? this.zip : <any>null;
        data["phone"] = this.phone !== undefined ? this.phone : <any>null;
        data["email"] = this.email !== undefined ? this.email : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["lineColor"] = this.lineColor !== undefined ? this.lineColor : <any>null;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item);
        }
        return data;
    }
}

export interface IUserUpdateV1Model {
    userId?: number;
    firstName?: string | null;
    lastName?: string | null;
    jobTitle?: string | null;
    country?: string | null;
    address?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    phone?: string | null;
    email?: string | null;
    notes?: string | null;
    isActive?: boolean;
    lineColor?: string | null;
    roles?: number[] | null;
}

export class UserSettingV1Model implements IUserSettingV1Model {
    settingId?: number | null;
    userId?: number | null;
    settingKey?: string | null;
    settingValue?: string | null;
    lastModifiedById?: number | null;
    lastModifiedDate?: Date | null;

    constructor(data?: IUserSettingV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.settingId = _data["settingId"] !== undefined ? _data["settingId"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.settingKey = _data["settingKey"] !== undefined ? _data["settingKey"] : <any>null;
            this.settingValue = _data["settingValue"] !== undefined ? _data["settingValue"] : <any>null;
            this.lastModifiedById = _data["lastModifiedById"] !== undefined ? _data["lastModifiedById"] : <any>null;
            this.lastModifiedDate = _data["lastModifiedDate"] ? new Date(_data["lastModifiedDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): UserSettingV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new UserSettingV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["settingId"] = this.settingId !== undefined ? this.settingId : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["settingKey"] = this.settingKey !== undefined ? this.settingKey : <any>null;
        data["settingValue"] = this.settingValue !== undefined ? this.settingValue : <any>null;
        data["lastModifiedById"] = this.lastModifiedById !== undefined ? this.lastModifiedById : <any>null;
        data["lastModifiedDate"] = this.lastModifiedDate ? this.lastModifiedDate.toISOString() : <any>null;
        return data;
    }
}

export interface IUserSettingV1Model {
    settingId?: number | null;
    userId?: number | null;
    settingKey?: string | null;
    settingValue?: string | null;
    lastModifiedById?: number | null;
    lastModifiedDate?: Date | null;
}

export class ErrorV1Model implements IErrorV1Model {
    requestUrl?: string | null;
    machineName?: string | null;
    eventTime?: Date;
    requestPath?: string | null;
    userHostAddress?: string | null;
    message?: string | null;
    exception?: string | null;
    exceptionCode?: string | null;
    exceptionMessage?: string | null;
    stackTrace?: string | null;
    sessionDump?: string | null;
    applicationName?: string | null;
    accountId?: number | null;
    userId?: number | null;

    constructor(data?: IErrorV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.requestUrl = _data["requestUrl"] !== undefined ? _data["requestUrl"] : <any>null;
            this.machineName = _data["machineName"] !== undefined ? _data["machineName"] : <any>null;
            this.eventTime = _data["eventTime"] ? new Date(_data["eventTime"].toString()) : <any>null;
            this.requestPath = _data["requestPath"] !== undefined ? _data["requestPath"] : <any>null;
            this.userHostAddress = _data["userHostAddress"] !== undefined ? _data["userHostAddress"] : <any>null;
            this.message = _data["message"] !== undefined ? _data["message"] : <any>null;
            this.exception = _data["exception"] !== undefined ? _data["exception"] : <any>null;
            this.exceptionCode = _data["exceptionCode"] !== undefined ? _data["exceptionCode"] : <any>null;
            this.exceptionMessage = _data["exceptionMessage"] !== undefined ? _data["exceptionMessage"] : <any>null;
            this.stackTrace = _data["stackTrace"] !== undefined ? _data["stackTrace"] : <any>null;
            this.sessionDump = _data["sessionDump"] !== undefined ? _data["sessionDump"] : <any>null;
            this.applicationName = _data["applicationName"] !== undefined ? _data["applicationName"] : <any>null;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
        }
    }

    static fromJS(data: any): ErrorV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new ErrorV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["requestUrl"] = this.requestUrl !== undefined ? this.requestUrl : <any>null;
        data["machineName"] = this.machineName !== undefined ? this.machineName : <any>null;
        data["eventTime"] = this.eventTime ? this.eventTime.toISOString() : <any>null;
        data["requestPath"] = this.requestPath !== undefined ? this.requestPath : <any>null;
        data["userHostAddress"] = this.userHostAddress !== undefined ? this.userHostAddress : <any>null;
        data["message"] = this.message !== undefined ? this.message : <any>null;
        data["exception"] = this.exception !== undefined ? this.exception : <any>null;
        data["exceptionCode"] = this.exceptionCode !== undefined ? this.exceptionCode : <any>null;
        data["exceptionMessage"] = this.exceptionMessage !== undefined ? this.exceptionMessage : <any>null;
        data["stackTrace"] = this.stackTrace !== undefined ? this.stackTrace : <any>null;
        data["sessionDump"] = this.sessionDump !== undefined ? this.sessionDump : <any>null;
        data["applicationName"] = this.applicationName !== undefined ? this.applicationName : <any>null;
        data["accountId"] = this.accountId !== undefined ? this.accountId : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        return data;
    }
}

export interface IErrorV1Model {
    requestUrl?: string | null;
    machineName?: string | null;
    eventTime?: Date;
    requestPath?: string | null;
    userHostAddress?: string | null;
    message?: string | null;
    exception?: string | null;
    exceptionCode?: string | null;
    exceptionMessage?: string | null;
    stackTrace?: string | null;
    sessionDump?: string | null;
    applicationName?: string | null;
    accountId?: number | null;
    userId?: number | null;
}

export class FieldLevelHelpV1Model implements IFieldLevelHelpV1Model {
    helpContentId?: number;
    contentDesc?: string | null;
    whereUsed?: string | null;
    contentText?: string | null;
    createdDate?: Date | null;

    constructor(data?: IFieldLevelHelpV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.helpContentId = _data["helpContentId"] !== undefined ? _data["helpContentId"] : <any>null;
            this.contentDesc = _data["contentDesc"] !== undefined ? _data["contentDesc"] : <any>null;
            this.whereUsed = _data["whereUsed"] !== undefined ? _data["whereUsed"] : <any>null;
            this.contentText = _data["contentText"] !== undefined ? _data["contentText"] : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): FieldLevelHelpV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new FieldLevelHelpV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["helpContentId"] = this.helpContentId !== undefined ? this.helpContentId : <any>null;
        data["contentDesc"] = this.contentDesc !== undefined ? this.contentDesc : <any>null;
        data["whereUsed"] = this.whereUsed !== undefined ? this.whereUsed : <any>null;
        data["contentText"] = this.contentText !== undefined ? this.contentText : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        return data;
    }
}

export interface IFieldLevelHelpV1Model {
    helpContentId?: number;
    contentDesc?: string | null;
    whereUsed?: string | null;
    contentText?: string | null;
    createdDate?: Date | null;
}

export class BlueprintV1Model implements IBlueprintV1Model {
    blueprintId!: number;
    floorId!: number;
    facilityId?: number;
    blueprintTypeId!: number;
    blueprintType!: string;
    fileName!: string;
    fileBase64!: string;
    fileGuid!: string;
    createdDate!: Date;
    createdByUserId!: number;
    updatedByUserId!: number;
    updatedDate!: Date;
    createdByUserName!: string;
    updatedByUserName!: string;
    contentType?: string | null;
    detailedName?: string | null;

    constructor(data?: IBlueprintV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.blueprintId = _data["blueprintId"] !== undefined ? _data["blueprintId"] : <any>null;
            this.floorId = _data["floorId"] !== undefined ? _data["floorId"] : <any>null;
            this.facilityId = _data["facilityId"] !== undefined ? _data["facilityId"] : <any>null;
            this.blueprintTypeId = _data["blueprintTypeId"] !== undefined ? _data["blueprintTypeId"] : <any>null;
            this.blueprintType = _data["blueprintType"] !== undefined ? _data["blueprintType"] : <any>null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
            this.fileBase64 = _data["fileBase64"] !== undefined ? _data["fileBase64"] : <any>null;
            this.fileGuid = _data["fileGuid"] !== undefined ? _data["fileGuid"] : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.createdByUserId = _data["createdByUserId"] !== undefined ? _data["createdByUserId"] : <any>null;
            this.updatedByUserId = _data["updatedByUserId"] !== undefined ? _data["updatedByUserId"] : <any>null;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>null;
            this.createdByUserName = _data["createdByUserName"] !== undefined ? _data["createdByUserName"] : <any>null;
            this.updatedByUserName = _data["updatedByUserName"] !== undefined ? _data["updatedByUserName"] : <any>null;
            this.contentType = _data["contentType"] !== undefined ? _data["contentType"] : <any>null;
            this.detailedName = _data["detailedName"] !== undefined ? _data["detailedName"] : <any>null;
        }
    }

    static fromJS(data: any): BlueprintV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new BlueprintV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["blueprintId"] = this.blueprintId !== undefined ? this.blueprintId : <any>null;
        data["floorId"] = this.floorId !== undefined ? this.floorId : <any>null;
        data["facilityId"] = this.facilityId !== undefined ? this.facilityId : <any>null;
        data["blueprintTypeId"] = this.blueprintTypeId !== undefined ? this.blueprintTypeId : <any>null;
        data["blueprintType"] = this.blueprintType !== undefined ? this.blueprintType : <any>null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        data["fileBase64"] = this.fileBase64 !== undefined ? this.fileBase64 : <any>null;
        data["fileGuid"] = this.fileGuid !== undefined ? this.fileGuid : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["createdByUserId"] = this.createdByUserId !== undefined ? this.createdByUserId : <any>null;
        data["updatedByUserId"] = this.updatedByUserId !== undefined ? this.updatedByUserId : <any>null;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>null;
        data["createdByUserName"] = this.createdByUserName !== undefined ? this.createdByUserName : <any>null;
        data["updatedByUserName"] = this.updatedByUserName !== undefined ? this.updatedByUserName : <any>null;
        data["contentType"] = this.contentType !== undefined ? this.contentType : <any>null;
        data["detailedName"] = this.detailedName !== undefined ? this.detailedName : <any>null;
        return data;
    }
}

export interface IBlueprintV1Model {
    blueprintId: number;
    floorId: number;
    facilityId?: number;
    blueprintTypeId: number;
    blueprintType: string;
    fileName: string;
    fileBase64: string;
    fileGuid: string;
    createdDate: Date;
    createdByUserId: number;
    updatedByUserId: number;
    updatedDate: Date;
    createdByUserName: string;
    updatedByUserName: string;
    contentType?: string | null;
    detailedName?: string | null;
}

export class FileV1Model implements IFileV1Model {
    fileName?: string | null;
    fileBase64?: string | null;
    fileGuid?: string | null;
    fileBytes?: string | null;
    contentType?: string | null;

    constructor(data?: IFileV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
            this.fileBase64 = _data["fileBase64"] !== undefined ? _data["fileBase64"] : <any>null;
            this.fileGuid = _data["fileGuid"] !== undefined ? _data["fileGuid"] : <any>null;
            this.fileBytes = _data["fileBytes"] !== undefined ? _data["fileBytes"] : <any>null;
            this.contentType = _data["contentType"] !== undefined ? _data["contentType"] : <any>null;
        }
    }

    static fromJS(data: any): FileV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new FileV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        data["fileBase64"] = this.fileBase64 !== undefined ? this.fileBase64 : <any>null;
        data["fileGuid"] = this.fileGuid !== undefined ? this.fileGuid : <any>null;
        data["fileBytes"] = this.fileBytes !== undefined ? this.fileBytes : <any>null;
        data["contentType"] = this.contentType !== undefined ? this.contentType : <any>null;
        return data;
    }
}

export interface IFileV1Model {
    fileName?: string | null;
    fileBase64?: string | null;
    fileGuid?: string | null;
    fileBytes?: string | null;
    contentType?: string | null;
}

export class BlueprintInsertV1Model extends FileV1Model implements IBlueprintInsertV1Model {
    floorId?: number;
    blueprintTypeId?: number;

    constructor(data?: IBlueprintInsertV1Model) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.floorId = _data["floorId"] !== undefined ? _data["floorId"] : <any>null;
            this.blueprintTypeId = _data["blueprintTypeId"] !== undefined ? _data["blueprintTypeId"] : <any>null;
        }
    }

    static override fromJS(data: any): BlueprintInsertV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new BlueprintInsertV1Model();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["floorId"] = this.floorId !== undefined ? this.floorId : <any>null;
        data["blueprintTypeId"] = this.blueprintTypeId !== undefined ? this.blueprintTypeId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IBlueprintInsertV1Model extends IFileV1Model {
    floorId?: number;
    blueprintTypeId?: number;
}

export class BlueprintUpdateV1Model implements IBlueprintUpdateV1Model {
    blueprintId?: number;
    floorId?: number;
    blueprintTypeId?: number;
    fileName?: string | null;
    fileGuid?: string | null;
    fileBase64?: string | null;

    constructor(data?: IBlueprintUpdateV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.blueprintId = _data["blueprintId"] !== undefined ? _data["blueprintId"] : <any>null;
            this.floorId = _data["floorId"] !== undefined ? _data["floorId"] : <any>null;
            this.blueprintTypeId = _data["blueprintTypeId"] !== undefined ? _data["blueprintTypeId"] : <any>null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
            this.fileGuid = _data["fileGuid"] !== undefined ? _data["fileGuid"] : <any>null;
            this.fileBase64 = _data["fileBase64"] !== undefined ? _data["fileBase64"] : <any>null;
        }
    }

    static fromJS(data: any): BlueprintUpdateV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new BlueprintUpdateV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["blueprintId"] = this.blueprintId !== undefined ? this.blueprintId : <any>null;
        data["floorId"] = this.floorId !== undefined ? this.floorId : <any>null;
        data["blueprintTypeId"] = this.blueprintTypeId !== undefined ? this.blueprintTypeId : <any>null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        data["fileGuid"] = this.fileGuid !== undefined ? this.fileGuid : <any>null;
        data["fileBase64"] = this.fileBase64 !== undefined ? this.fileBase64 : <any>null;
        return data;
    }
}

export interface IBlueprintUpdateV1Model {
    blueprintId?: number;
    floorId?: number;
    blueprintTypeId?: number;
    fileName?: string | null;
    fileGuid?: string | null;
    fileBase64?: string | null;
}

export class BlueprintExportV1Model implements IBlueprintExportV1Model {
    blueprintImage?: string | null;
    asOnePage?: boolean;
    facilityId?: number;
    floorName?: string | null;
    printView?: PrintView;
    assetLocationV1Models?: AssetLocationV1Model[] | null;
    assetLocationSearch?: AssetLocationSearchV1Model | null;
    calloutLocations?: CalloutV1Model[] | null;

    constructor(data?: IBlueprintExportV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.blueprintImage = _data["blueprintImage"] !== undefined ? _data["blueprintImage"] : <any>null;
            this.asOnePage = _data["asOnePage"] !== undefined ? _data["asOnePage"] : <any>null;
            this.facilityId = _data["facilityId"] !== undefined ? _data["facilityId"] : <any>null;
            this.floorName = _data["floorName"] !== undefined ? _data["floorName"] : <any>null;
            this.printView = _data["printView"] !== undefined ? _data["printView"] : <any>null;
            if (Array.isArray(_data["assetLocationV1Models"])) {
                this.assetLocationV1Models = [] as any;
                for (let item of _data["assetLocationV1Models"])
                    this.assetLocationV1Models!.push(AssetLocationV1Model.fromJS(item));
            }
            else {
                this.assetLocationV1Models = <any>null;
            }
            this.assetLocationSearch = _data["assetLocationSearch"] ? AssetLocationSearchV1Model.fromJS(_data["assetLocationSearch"]) : <any>null;
            if (Array.isArray(_data["calloutLocations"])) {
                this.calloutLocations = [] as any;
                for (let item of _data["calloutLocations"])
                    this.calloutLocations!.push(CalloutV1Model.fromJS(item));
            }
            else {
                this.calloutLocations = <any>null;
            }
        }
    }

    static fromJS(data: any): BlueprintExportV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new BlueprintExportV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["blueprintImage"] = this.blueprintImage !== undefined ? this.blueprintImage : <any>null;
        data["asOnePage"] = this.asOnePage !== undefined ? this.asOnePage : <any>null;
        data["facilityId"] = this.facilityId !== undefined ? this.facilityId : <any>null;
        data["floorName"] = this.floorName !== undefined ? this.floorName : <any>null;
        data["printView"] = this.printView !== undefined ? this.printView : <any>null;
        if (Array.isArray(this.assetLocationV1Models)) {
            data["assetLocationV1Models"] = [];
            for (let item of this.assetLocationV1Models)
                data["assetLocationV1Models"].push(item.toJSON());
        }
        data["assetLocationSearch"] = this.assetLocationSearch ? this.assetLocationSearch.toJSON() : <any>null;
        if (Array.isArray(this.calloutLocations)) {
            data["calloutLocations"] = [];
            for (let item of this.calloutLocations)
                data["calloutLocations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBlueprintExportV1Model {
    blueprintImage?: string | null;
    asOnePage?: boolean;
    facilityId?: number;
    floorName?: string | null;
    printView?: PrintView;
    assetLocationV1Models?: AssetLocationV1Model[] | null;
    assetLocationSearch?: AssetLocationSearchV1Model | null;
    calloutLocations?: CalloutV1Model[] | null;
}

export enum PrintView {
    NoPrintView = 0,
    ComplianceView = 1,
    MaintenanceView = 2,
    WorkOrderView = 3,
}

export class AssetLocationV1Model implements IAssetLocationV1Model {
    assetLocationId?: number;
    assetId?: number;
    assetName?: string | null;
    name?: string | null;
    blueprintId?: number;
    xCordinate?: number | null;
    yCordinate?: number | null;
    createdByUserId?: number;
    updatedByUserId?: number;
    createdDate?: Date;
    updatedDate?: Date;
    iconFileGuid?: string | null;
    blueprintLocationThumbnailGuid?: string | null;
    isActive?: boolean;
    complianceStatus?: string | null;
    pass_fail_repaired?: string | null;
    workOrderStatus?: number;

    constructor(data?: IAssetLocationV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetLocationId = _data["assetLocationId"] !== undefined ? _data["assetLocationId"] : <any>null;
            this.assetId = _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
            this.assetName = _data["assetName"] !== undefined ? _data["assetName"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.blueprintId = _data["blueprintId"] !== undefined ? _data["blueprintId"] : <any>null;
            this.xCordinate = _data["xCordinate"] !== undefined ? _data["xCordinate"] : <any>null;
            this.yCordinate = _data["yCordinate"] !== undefined ? _data["yCordinate"] : <any>null;
            this.createdByUserId = _data["createdByUserId"] !== undefined ? _data["createdByUserId"] : <any>null;
            this.updatedByUserId = _data["updatedByUserId"] !== undefined ? _data["updatedByUserId"] : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>null;
            this.iconFileGuid = _data["iconFileGuid"] !== undefined ? _data["iconFileGuid"] : <any>null;
            this.blueprintLocationThumbnailGuid = _data["blueprintLocationThumbnailGuid"] !== undefined ? _data["blueprintLocationThumbnailGuid"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.complianceStatus = _data["complianceStatus"] !== undefined ? _data["complianceStatus"] : <any>null;
            this.pass_fail_repaired = _data["pass_fail_repaired"] !== undefined ? _data["pass_fail_repaired"] : <any>null;
            this.workOrderStatus = _data["workOrderStatus"] !== undefined ? _data["workOrderStatus"] : <any>null;
        }
    }

    static fromJS(data: any): AssetLocationV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new AssetLocationV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetLocationId"] = this.assetLocationId !== undefined ? this.assetLocationId : <any>null;
        data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
        data["assetName"] = this.assetName !== undefined ? this.assetName : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["blueprintId"] = this.blueprintId !== undefined ? this.blueprintId : <any>null;
        data["xCordinate"] = this.xCordinate !== undefined ? this.xCordinate : <any>null;
        data["yCordinate"] = this.yCordinate !== undefined ? this.yCordinate : <any>null;
        data["createdByUserId"] = this.createdByUserId !== undefined ? this.createdByUserId : <any>null;
        data["updatedByUserId"] = this.updatedByUserId !== undefined ? this.updatedByUserId : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>null;
        data["iconFileGuid"] = this.iconFileGuid !== undefined ? this.iconFileGuid : <any>null;
        data["blueprintLocationThumbnailGuid"] = this.blueprintLocationThumbnailGuid !== undefined ? this.blueprintLocationThumbnailGuid : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["complianceStatus"] = this.complianceStatus !== undefined ? this.complianceStatus : <any>null;
        data["pass_fail_repaired"] = this.pass_fail_repaired !== undefined ? this.pass_fail_repaired : <any>null;
        data["workOrderStatus"] = this.workOrderStatus !== undefined ? this.workOrderStatus : <any>null;
        return data;
    }
}

export interface IAssetLocationV1Model {
    assetLocationId?: number;
    assetId?: number;
    assetName?: string | null;
    name?: string | null;
    blueprintId?: number;
    xCordinate?: number | null;
    yCordinate?: number | null;
    createdByUserId?: number;
    updatedByUserId?: number;
    createdDate?: Date;
    updatedDate?: Date;
    iconFileGuid?: string | null;
    blueprintLocationThumbnailGuid?: string | null;
    isActive?: boolean;
    complianceStatus?: string | null;
    pass_fail_repaired?: string | null;
    workOrderStatus?: number;
}

export class AssetLocationSearchV1Model implements IAssetLocationSearchV1Model {
    blueprintId?: number;
    assetClassIds?: number[] | null;
    ahuID?: string | null;
    specialCondition?: string | null;
    barrierRating?: string | null;
    assetName?: string | null;
    assetProfileTypeId?: number | null;
    openWorkOrder?: boolean | null;
    latestInspectionResult?: string | null;
    complianceStatus?: string | null;
    isActive?: boolean | null;

    constructor(data?: IAssetLocationSearchV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.blueprintId = _data["blueprintId"] !== undefined ? _data["blueprintId"] : <any>null;
            if (Array.isArray(_data["assetClassIds"])) {
                this.assetClassIds = [] as any;
                for (let item of _data["assetClassIds"])
                    this.assetClassIds!.push(item);
            }
            else {
                this.assetClassIds = <any>null;
            }
            this.ahuID = _data["ahuID"] !== undefined ? _data["ahuID"] : <any>null;
            this.specialCondition = _data["specialCondition"] !== undefined ? _data["specialCondition"] : <any>null;
            this.barrierRating = _data["barrierRating"] !== undefined ? _data["barrierRating"] : <any>null;
            this.assetName = _data["assetName"] !== undefined ? _data["assetName"] : <any>null;
            this.assetProfileTypeId = _data["assetProfileTypeId"] !== undefined ? _data["assetProfileTypeId"] : <any>null;
            this.openWorkOrder = _data["openWorkOrder"] !== undefined ? _data["openWorkOrder"] : <any>null;
            this.latestInspectionResult = _data["latestInspectionResult"] !== undefined ? _data["latestInspectionResult"] : <any>null;
            this.complianceStatus = _data["complianceStatus"] !== undefined ? _data["complianceStatus"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): AssetLocationSearchV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new AssetLocationSearchV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["blueprintId"] = this.blueprintId !== undefined ? this.blueprintId : <any>null;
        if (Array.isArray(this.assetClassIds)) {
            data["assetClassIds"] = [];
            for (let item of this.assetClassIds)
                data["assetClassIds"].push(item);
        }
        data["ahuID"] = this.ahuID !== undefined ? this.ahuID : <any>null;
        data["specialCondition"] = this.specialCondition !== undefined ? this.specialCondition : <any>null;
        data["barrierRating"] = this.barrierRating !== undefined ? this.barrierRating : <any>null;
        data["assetName"] = this.assetName !== undefined ? this.assetName : <any>null;
        data["assetProfileTypeId"] = this.assetProfileTypeId !== undefined ? this.assetProfileTypeId : <any>null;
        data["openWorkOrder"] = this.openWorkOrder !== undefined ? this.openWorkOrder : <any>null;
        data["latestInspectionResult"] = this.latestInspectionResult !== undefined ? this.latestInspectionResult : <any>null;
        data["complianceStatus"] = this.complianceStatus !== undefined ? this.complianceStatus : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data;
    }
}

export interface IAssetLocationSearchV1Model {
    blueprintId?: number;
    assetClassIds?: number[] | null;
    ahuID?: string | null;
    specialCondition?: string | null;
    barrierRating?: string | null;
    assetName?: string | null;
    assetProfileTypeId?: number | null;
    openWorkOrder?: boolean | null;
    latestInspectionResult?: string | null;
    complianceStatus?: string | null;
    isActive?: boolean | null;
}

export class CalloutV1Model implements ICalloutV1Model {
    calloutLocationId?: number;
    assetId?: number;
    blueprintId?: number;
    assetName?: string | null;
    xCoordinate?: number;
    yCoordinate?: number;
    width?: number;
    height?: number;
    inspectionResultColor?: string | null;
    workOrderStatusColor?: string | null;

    constructor(data?: ICalloutV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.calloutLocationId = _data["calloutLocationId"] !== undefined ? _data["calloutLocationId"] : <any>null;
            this.assetId = _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
            this.blueprintId = _data["blueprintId"] !== undefined ? _data["blueprintId"] : <any>null;
            this.assetName = _data["assetName"] !== undefined ? _data["assetName"] : <any>null;
            this.xCoordinate = _data["xCoordinate"] !== undefined ? _data["xCoordinate"] : <any>null;
            this.yCoordinate = _data["yCoordinate"] !== undefined ? _data["yCoordinate"] : <any>null;
            this.width = _data["width"] !== undefined ? _data["width"] : <any>null;
            this.height = _data["height"] !== undefined ? _data["height"] : <any>null;
            this.inspectionResultColor = _data["inspectionResultColor"] !== undefined ? _data["inspectionResultColor"] : <any>null;
            this.workOrderStatusColor = _data["workOrderStatusColor"] !== undefined ? _data["workOrderStatusColor"] : <any>null;
        }
    }

    static fromJS(data: any): CalloutV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new CalloutV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calloutLocationId"] = this.calloutLocationId !== undefined ? this.calloutLocationId : <any>null;
        data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
        data["blueprintId"] = this.blueprintId !== undefined ? this.blueprintId : <any>null;
        data["assetName"] = this.assetName !== undefined ? this.assetName : <any>null;
        data["xCoordinate"] = this.xCoordinate !== undefined ? this.xCoordinate : <any>null;
        data["yCoordinate"] = this.yCoordinate !== undefined ? this.yCoordinate : <any>null;
        data["width"] = this.width !== undefined ? this.width : <any>null;
        data["height"] = this.height !== undefined ? this.height : <any>null;
        data["inspectionResultColor"] = this.inspectionResultColor !== undefined ? this.inspectionResultColor : <any>null;
        data["workOrderStatusColor"] = this.workOrderStatusColor !== undefined ? this.workOrderStatusColor : <any>null;
        return data;
    }
}

export interface ICalloutV1Model {
    calloutLocationId?: number;
    assetId?: number;
    blueprintId?: number;
    assetName?: string | null;
    xCoordinate?: number;
    yCoordinate?: number;
    width?: number;
    height?: number;
    inspectionResultColor?: string | null;
    workOrderStatusColor?: string | null;
}

export class BlueprintTypeV1Model implements IBlueprintTypeV1Model {
    blueprintTypeId?: number;
    accountId?: number;
    blueprintType?: string | null;
    createdDate!: Date;
    createdByUserId!: number;
    updatedByUserId!: number;
    updatedDate!: Date;
    createdByUser?: string | null;
    updatedByUser?: string | null;

    constructor(data?: IBlueprintTypeV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.blueprintTypeId = _data["blueprintTypeId"] !== undefined ? _data["blueprintTypeId"] : <any>null;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : <any>null;
            this.blueprintType = _data["blueprintType"] !== undefined ? _data["blueprintType"] : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.createdByUserId = _data["createdByUserId"] !== undefined ? _data["createdByUserId"] : <any>null;
            this.updatedByUserId = _data["updatedByUserId"] !== undefined ? _data["updatedByUserId"] : <any>null;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>null;
            this.createdByUser = _data["createdByUser"] !== undefined ? _data["createdByUser"] : <any>null;
            this.updatedByUser = _data["updatedByUser"] !== undefined ? _data["updatedByUser"] : <any>null;
        }
    }

    static fromJS(data: any): BlueprintTypeV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new BlueprintTypeV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["blueprintTypeId"] = this.blueprintTypeId !== undefined ? this.blueprintTypeId : <any>null;
        data["accountId"] = this.accountId !== undefined ? this.accountId : <any>null;
        data["blueprintType"] = this.blueprintType !== undefined ? this.blueprintType : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["createdByUserId"] = this.createdByUserId !== undefined ? this.createdByUserId : <any>null;
        data["updatedByUserId"] = this.updatedByUserId !== undefined ? this.updatedByUserId : <any>null;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>null;
        data["createdByUser"] = this.createdByUser !== undefined ? this.createdByUser : <any>null;
        data["updatedByUser"] = this.updatedByUser !== undefined ? this.updatedByUser : <any>null;
        return data;
    }
}

export interface IBlueprintTypeV1Model {
    blueprintTypeId?: number;
    accountId?: number;
    blueprintType?: string | null;
    createdDate: Date;
    createdByUserId: number;
    updatedByUserId: number;
    updatedDate: Date;
    createdByUser?: string | null;
    updatedByUser?: string | null;
}

export class BlueprintTypeInsertV1Model implements IBlueprintTypeInsertV1Model {
    accountId?: number;
    blueprintType?: string | null;

    constructor(data?: IBlueprintTypeInsertV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : <any>null;
            this.blueprintType = _data["blueprintType"] !== undefined ? _data["blueprintType"] : <any>null;
        }
    }

    static fromJS(data: any): BlueprintTypeInsertV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new BlueprintTypeInsertV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId !== undefined ? this.accountId : <any>null;
        data["blueprintType"] = this.blueprintType !== undefined ? this.blueprintType : <any>null;
        return data;
    }
}

export interface IBlueprintTypeInsertV1Model {
    accountId?: number;
    blueprintType?: string | null;
}

export class BlueprintTypeUpdateV1Model implements IBlueprintTypeUpdateV1Model {
    blueprintTypeId?: number;
    accountId?: number;
    blueprintType?: string | null;

    constructor(data?: IBlueprintTypeUpdateV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.blueprintTypeId = _data["blueprintTypeId"] !== undefined ? _data["blueprintTypeId"] : <any>null;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : <any>null;
            this.blueprintType = _data["blueprintType"] !== undefined ? _data["blueprintType"] : <any>null;
        }
    }

    static fromJS(data: any): BlueprintTypeUpdateV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new BlueprintTypeUpdateV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["blueprintTypeId"] = this.blueprintTypeId !== undefined ? this.blueprintTypeId : <any>null;
        data["accountId"] = this.accountId !== undefined ? this.accountId : <any>null;
        data["blueprintType"] = this.blueprintType !== undefined ? this.blueprintType : <any>null;
        return data;
    }
}

export interface IBlueprintTypeUpdateV1Model {
    blueprintTypeId?: number;
    accountId?: number;
    blueprintType?: string | null;
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export class ODataValueOfIEnumerableOfBlueprintTypeV1Model implements IODataValueOfIEnumerableOfBlueprintTypeV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: BlueprintTypeV1Model[] | null;

    constructor(data?: IODataValueOfIEnumerableOfBlueprintTypeV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(BlueprintTypeV1Model.fromJS(item));
            }
            else {
                this.value = <any>null;
            }
        }
    }

    static fromJS(data: any): ODataValueOfIEnumerableOfBlueprintTypeV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new ODataValueOfIEnumerableOfBlueprintTypeV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export interface IODataValueOfIEnumerableOfBlueprintTypeV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: BlueprintTypeV1Model[] | null;
}

export class FacilityTypeV1Model implements IFacilityTypeV1Model {
    facilityTypeId!: number;
    name!: string;
    description?: string | null;
    examples?: string | null;
    createdByUserId!: number;
    createdDate!: Date;
    updatedByUserId!: number;
    updatedDate!: Date;
    accountId!: number;
    iconId!: number;
    iconFileGuid!: string;

    constructor(data?: IFacilityTypeV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.facilityTypeId = _data["facilityTypeId"] !== undefined ? _data["facilityTypeId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.examples = _data["examples"] !== undefined ? _data["examples"] : <any>null;
            this.createdByUserId = _data["createdByUserId"] !== undefined ? _data["createdByUserId"] : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.updatedByUserId = _data["updatedByUserId"] !== undefined ? _data["updatedByUserId"] : <any>null;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>null;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : <any>null;
            this.iconId = _data["iconId"] !== undefined ? _data["iconId"] : <any>null;
            this.iconFileGuid = _data["iconFileGuid"] !== undefined ? _data["iconFileGuid"] : <any>null;
        }
    }

    static fromJS(data: any): FacilityTypeV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new FacilityTypeV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facilityTypeId"] = this.facilityTypeId !== undefined ? this.facilityTypeId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["examples"] = this.examples !== undefined ? this.examples : <any>null;
        data["createdByUserId"] = this.createdByUserId !== undefined ? this.createdByUserId : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["updatedByUserId"] = this.updatedByUserId !== undefined ? this.updatedByUserId : <any>null;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>null;
        data["accountId"] = this.accountId !== undefined ? this.accountId : <any>null;
        data["iconId"] = this.iconId !== undefined ? this.iconId : <any>null;
        data["iconFileGuid"] = this.iconFileGuid !== undefined ? this.iconFileGuid : <any>null;
        return data;
    }
}

export interface IFacilityTypeV1Model {
    facilityTypeId: number;
    name: string;
    description?: string | null;
    examples?: string | null;
    createdByUserId: number;
    createdDate: Date;
    updatedByUserId: number;
    updatedDate: Date;
    accountId: number;
    iconId: number;
    iconFileGuid: string;
}

export class FacilityTypeInsertV1Model implements IFacilityTypeInsertV1Model {
    name?: string | null;
    description?: string | null;
    examples?: string | null;
    iconId?: number;

    constructor(data?: IFacilityTypeInsertV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.examples = _data["examples"] !== undefined ? _data["examples"] : <any>null;
            this.iconId = _data["iconId"] !== undefined ? _data["iconId"] : <any>null;
        }
    }

    static fromJS(data: any): FacilityTypeInsertV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new FacilityTypeInsertV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["examples"] = this.examples !== undefined ? this.examples : <any>null;
        data["iconId"] = this.iconId !== undefined ? this.iconId : <any>null;
        return data;
    }
}

export interface IFacilityTypeInsertV1Model {
    name?: string | null;
    description?: string | null;
    examples?: string | null;
    iconId?: number;
}

export class FacilityTypeUpdateV1Model implements IFacilityTypeUpdateV1Model {
    facilityTypeId?: number;
    name?: string | null;
    description?: string | null;
    examples?: string | null;
    iconId?: number;

    constructor(data?: IFacilityTypeUpdateV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.facilityTypeId = _data["facilityTypeId"] !== undefined ? _data["facilityTypeId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.description = _data["description"] !== undefined ? _data["description"] : <any>null;
            this.examples = _data["examples"] !== undefined ? _data["examples"] : <any>null;
            this.iconId = _data["iconId"] !== undefined ? _data["iconId"] : <any>null;
        }
    }

    static fromJS(data: any): FacilityTypeUpdateV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new FacilityTypeUpdateV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facilityTypeId"] = this.facilityTypeId !== undefined ? this.facilityTypeId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["description"] = this.description !== undefined ? this.description : <any>null;
        data["examples"] = this.examples !== undefined ? this.examples : <any>null;
        data["iconId"] = this.iconId !== undefined ? this.iconId : <any>null;
        return data;
    }
}

export interface IFacilityTypeUpdateV1Model {
    facilityTypeId?: number;
    name?: string | null;
    description?: string | null;
    examples?: string | null;
    iconId?: number;
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export class ODataValueOfIEnumerableOfFacilityTypeV1Model implements IODataValueOfIEnumerableOfFacilityTypeV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: FacilityTypeV1Model[] | null;

    constructor(data?: IODataValueOfIEnumerableOfFacilityTypeV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(FacilityTypeV1Model.fromJS(item));
            }
            else {
                this.value = <any>null;
            }
        }
    }

    static fromJS(data: any): ODataValueOfIEnumerableOfFacilityTypeV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new ODataValueOfIEnumerableOfFacilityTypeV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export interface IODataValueOfIEnumerableOfFacilityTypeV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: FacilityTypeV1Model[] | null;
}

export class WorkOrderV1Model implements IWorkOrderV1Model {
    workOrderId?: number;
    assetId?: number;
    workOrderNumber?: string | null;
    parentWorkOrderId?: number | null;
    inspectionWorkOrderId?: number | null;
    suggestedRepairWorkOrderId?: number | null;
    workOrderGroup?: number;
    workOrderTypeId?: number;
    workOrderType?: string | null;
    assetNumber?: string | null;
    assetName?: string | null;
    assetClassId?: number | null;
    assetClass?: string | null;
    assetProfileId?: number;
    campusId?: number;
    campus?: string | null;
    floorId?: number | null;
    floor?: string | null;
    facilityId?: number;
    facility?: string | null;
    facilityContact?: string | null;
    facilityAddress?: string | null;
    inspectorUserId?: number | null;
    inspectorUserName?: string | null;
    status?: number;
    reviewRequired?: boolean;
    inspectedDate?: Date | null;
    form?: string | null;
    formId?: number;
    accountId?: number;
    projectId?: number;
    enableRepairs?: boolean;
    project?: string | null;
    projectPhaseId?: number | null;
    projectPhase?: string | null;
    createdDate?: Date;
    createdByUserId?: number;
    updatedByUserId?: number;
    updatedDate?: Date;
    createdByUser?: string | null;
    updatedByUser?: string | null;

    constructor(data?: IWorkOrderV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workOrderId = _data["workOrderId"] !== undefined ? _data["workOrderId"] : <any>null;
            this.assetId = _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
            this.workOrderNumber = _data["workOrderNumber"] !== undefined ? _data["workOrderNumber"] : <any>null;
            this.parentWorkOrderId = _data["parentWorkOrderId"] !== undefined ? _data["parentWorkOrderId"] : <any>null;
            this.inspectionWorkOrderId = _data["inspectionWorkOrderId"] !== undefined ? _data["inspectionWorkOrderId"] : <any>null;
            this.suggestedRepairWorkOrderId = _data["suggestedRepairWorkOrderId"] !== undefined ? _data["suggestedRepairWorkOrderId"] : <any>null;
            this.workOrderGroup = _data["workOrderGroup"] !== undefined ? _data["workOrderGroup"] : <any>null;
            this.workOrderTypeId = _data["workOrderTypeId"] !== undefined ? _data["workOrderTypeId"] : <any>null;
            this.workOrderType = _data["workOrderType"] !== undefined ? _data["workOrderType"] : <any>null;
            this.assetNumber = _data["assetNumber"] !== undefined ? _data["assetNumber"] : <any>null;
            this.assetName = _data["assetName"] !== undefined ? _data["assetName"] : <any>null;
            this.assetClassId = _data["assetClassId"] !== undefined ? _data["assetClassId"] : <any>null;
            this.assetClass = _data["assetClass"] !== undefined ? _data["assetClass"] : <any>null;
            this.assetProfileId = _data["assetProfileId"] !== undefined ? _data["assetProfileId"] : <any>null;
            this.campusId = _data["campusId"] !== undefined ? _data["campusId"] : <any>null;
            this.campus = _data["campus"] !== undefined ? _data["campus"] : <any>null;
            this.floorId = _data["floorId"] !== undefined ? _data["floorId"] : <any>null;
            this.floor = _data["floor"] !== undefined ? _data["floor"] : <any>null;
            this.facilityId = _data["facilityId"] !== undefined ? _data["facilityId"] : <any>null;
            this.facility = _data["facility"] !== undefined ? _data["facility"] : <any>null;
            this.facilityContact = _data["facilityContact"] !== undefined ? _data["facilityContact"] : <any>null;
            this.facilityAddress = _data["facilityAddress"] !== undefined ? _data["facilityAddress"] : <any>null;
            this.inspectorUserId = _data["inspectorUserId"] !== undefined ? _data["inspectorUserId"] : <any>null;
            this.inspectorUserName = _data["inspectorUserName"] !== undefined ? _data["inspectorUserName"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.reviewRequired = _data["reviewRequired"] !== undefined ? _data["reviewRequired"] : <any>null;
            this.inspectedDate = _data["inspectedDate"] ? new Date(_data["inspectedDate"].toString()) : <any>null;
            this.form = _data["form"] !== undefined ? _data["form"] : <any>null;
            this.formId = _data["formId"] !== undefined ? _data["formId"] : <any>null;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : <any>null;
            this.projectId = _data["projectId"] !== undefined ? _data["projectId"] : <any>null;
            this.enableRepairs = _data["enableRepairs"] !== undefined ? _data["enableRepairs"] : <any>null;
            this.project = _data["project"] !== undefined ? _data["project"] : <any>null;
            this.projectPhaseId = _data["projectPhaseId"] !== undefined ? _data["projectPhaseId"] : <any>null;
            this.projectPhase = _data["projectPhase"] !== undefined ? _data["projectPhase"] : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.createdByUserId = _data["createdByUserId"] !== undefined ? _data["createdByUserId"] : <any>null;
            this.updatedByUserId = _data["updatedByUserId"] !== undefined ? _data["updatedByUserId"] : <any>null;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>null;
            this.createdByUser = _data["createdByUser"] !== undefined ? _data["createdByUser"] : <any>null;
            this.updatedByUser = _data["updatedByUser"] !== undefined ? _data["updatedByUser"] : <any>null;
        }
    }

    static fromJS(data: any): WorkOrderV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new WorkOrderV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workOrderId"] = this.workOrderId !== undefined ? this.workOrderId : <any>null;
        data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
        data["workOrderNumber"] = this.workOrderNumber !== undefined ? this.workOrderNumber : <any>null;
        data["parentWorkOrderId"] = this.parentWorkOrderId !== undefined ? this.parentWorkOrderId : <any>null;
        data["inspectionWorkOrderId"] = this.inspectionWorkOrderId !== undefined ? this.inspectionWorkOrderId : <any>null;
        data["suggestedRepairWorkOrderId"] = this.suggestedRepairWorkOrderId !== undefined ? this.suggestedRepairWorkOrderId : <any>null;
        data["workOrderGroup"] = this.workOrderGroup !== undefined ? this.workOrderGroup : <any>null;
        data["workOrderTypeId"] = this.workOrderTypeId !== undefined ? this.workOrderTypeId : <any>null;
        data["workOrderType"] = this.workOrderType !== undefined ? this.workOrderType : <any>null;
        data["assetNumber"] = this.assetNumber !== undefined ? this.assetNumber : <any>null;
        data["assetName"] = this.assetName !== undefined ? this.assetName : <any>null;
        data["assetClassId"] = this.assetClassId !== undefined ? this.assetClassId : <any>null;
        data["assetClass"] = this.assetClass !== undefined ? this.assetClass : <any>null;
        data["assetProfileId"] = this.assetProfileId !== undefined ? this.assetProfileId : <any>null;
        data["campusId"] = this.campusId !== undefined ? this.campusId : <any>null;
        data["campus"] = this.campus !== undefined ? this.campus : <any>null;
        data["floorId"] = this.floorId !== undefined ? this.floorId : <any>null;
        data["floor"] = this.floor !== undefined ? this.floor : <any>null;
        data["facilityId"] = this.facilityId !== undefined ? this.facilityId : <any>null;
        data["facility"] = this.facility !== undefined ? this.facility : <any>null;
        data["facilityContact"] = this.facilityContact !== undefined ? this.facilityContact : <any>null;
        data["facilityAddress"] = this.facilityAddress !== undefined ? this.facilityAddress : <any>null;
        data["inspectorUserId"] = this.inspectorUserId !== undefined ? this.inspectorUserId : <any>null;
        data["inspectorUserName"] = this.inspectorUserName !== undefined ? this.inspectorUserName : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["reviewRequired"] = this.reviewRequired !== undefined ? this.reviewRequired : <any>null;
        data["inspectedDate"] = this.inspectedDate ? this.inspectedDate.toISOString() : <any>null;
        data["form"] = this.form !== undefined ? this.form : <any>null;
        data["formId"] = this.formId !== undefined ? this.formId : <any>null;
        data["accountId"] = this.accountId !== undefined ? this.accountId : <any>null;
        data["projectId"] = this.projectId !== undefined ? this.projectId : <any>null;
        data["enableRepairs"] = this.enableRepairs !== undefined ? this.enableRepairs : <any>null;
        data["project"] = this.project !== undefined ? this.project : <any>null;
        data["projectPhaseId"] = this.projectPhaseId !== undefined ? this.projectPhaseId : <any>null;
        data["projectPhase"] = this.projectPhase !== undefined ? this.projectPhase : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["createdByUserId"] = this.createdByUserId !== undefined ? this.createdByUserId : <any>null;
        data["updatedByUserId"] = this.updatedByUserId !== undefined ? this.updatedByUserId : <any>null;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>null;
        data["createdByUser"] = this.createdByUser !== undefined ? this.createdByUser : <any>null;
        data["updatedByUser"] = this.updatedByUser !== undefined ? this.updatedByUser : <any>null;
        return data;
    }
}

export interface IWorkOrderV1Model {
    workOrderId?: number;
    assetId?: number;
    workOrderNumber?: string | null;
    parentWorkOrderId?: number | null;
    inspectionWorkOrderId?: number | null;
    suggestedRepairWorkOrderId?: number | null;
    workOrderGroup?: number;
    workOrderTypeId?: number;
    workOrderType?: string | null;
    assetNumber?: string | null;
    assetName?: string | null;
    assetClassId?: number | null;
    assetClass?: string | null;
    assetProfileId?: number;
    campusId?: number;
    campus?: string | null;
    floorId?: number | null;
    floor?: string | null;
    facilityId?: number;
    facility?: string | null;
    facilityContact?: string | null;
    facilityAddress?: string | null;
    inspectorUserId?: number | null;
    inspectorUserName?: string | null;
    status?: number;
    reviewRequired?: boolean;
    inspectedDate?: Date | null;
    form?: string | null;
    formId?: number;
    accountId?: number;
    projectId?: number;
    enableRepairs?: boolean;
    project?: string | null;
    projectPhaseId?: number | null;
    projectPhase?: string | null;
    createdDate?: Date;
    createdByUserId?: number;
    updatedByUserId?: number;
    updatedDate?: Date;
    createdByUser?: string | null;
    updatedByUser?: string | null;
}

export class WorkOrderSearchV1Model implements IWorkOrderSearchV1Model {
    facilityId?: number;
    formId?: number;
    startDate?: string | null;
    endDate?: string | null;
    inspectorUserId?: number | null;
    onlyCompleted?: boolean;
    exportFileType?: ExportFileType;

    constructor(data?: IWorkOrderSearchV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.facilityId = _data["facilityId"] !== undefined ? _data["facilityId"] : <any>null;
            this.formId = _data["formId"] !== undefined ? _data["formId"] : <any>null;
            this.startDate = _data["startDate"] !== undefined ? _data["startDate"] : <any>null;
            this.endDate = _data["endDate"] !== undefined ? _data["endDate"] : <any>null;
            this.inspectorUserId = _data["inspectorUserId"] !== undefined ? _data["inspectorUserId"] : <any>null;
            this.onlyCompleted = _data["onlyCompleted"] !== undefined ? _data["onlyCompleted"] : <any>null;
            this.exportFileType = _data["exportFileType"] !== undefined ? _data["exportFileType"] : <any>null;
        }
    }

    static fromJS(data: any): WorkOrderSearchV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new WorkOrderSearchV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facilityId"] = this.facilityId !== undefined ? this.facilityId : <any>null;
        data["formId"] = this.formId !== undefined ? this.formId : <any>null;
        data["startDate"] = this.startDate !== undefined ? this.startDate : <any>null;
        data["endDate"] = this.endDate !== undefined ? this.endDate : <any>null;
        data["inspectorUserId"] = this.inspectorUserId !== undefined ? this.inspectorUserId : <any>null;
        data["onlyCompleted"] = this.onlyCompleted !== undefined ? this.onlyCompleted : <any>null;
        data["exportFileType"] = this.exportFileType !== undefined ? this.exportFileType : <any>null;
        return data;
    }
}

export interface IWorkOrderSearchV1Model {
    facilityId?: number;
    formId?: number;
    startDate?: string | null;
    endDate?: string | null;
    inspectorUserId?: number | null;
    onlyCompleted?: boolean;
    exportFileType?: ExportFileType;
}

export enum ExportFileType {
    Excel = 1,
    PDF = 2,
}

export class WorkOrderInsertV1Model implements IWorkOrderInsertV1Model {
    rowIndex?: number | null;
    workOrderNumber?: string | null;
    assetId?: number;
    assetNumber?: string | null;
    inspectorUserId?: number | null;
    inspectedDate?: Date | null;
    parentWorkOrderId?: number | null;
    inspectionWorkOrderId?: number | null;
    suggestedRepairWorkOrderId?: number | null;
    workOrderTypeId?: number;
    projectId?: number;
    facilityContact?: string | null;
    status?: number;

    constructor(data?: IWorkOrderInsertV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rowIndex = _data["rowIndex"] !== undefined ? _data["rowIndex"] : <any>null;
            this.workOrderNumber = _data["workOrderNumber"] !== undefined ? _data["workOrderNumber"] : <any>null;
            this.assetId = _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
            this.assetNumber = _data["assetNumber"] !== undefined ? _data["assetNumber"] : <any>null;
            this.inspectorUserId = _data["inspectorUserId"] !== undefined ? _data["inspectorUserId"] : <any>null;
            this.inspectedDate = _data["inspectedDate"] ? new Date(_data["inspectedDate"].toString()) : <any>null;
            this.parentWorkOrderId = _data["parentWorkOrderId"] !== undefined ? _data["parentWorkOrderId"] : <any>null;
            this.inspectionWorkOrderId = _data["inspectionWorkOrderId"] !== undefined ? _data["inspectionWorkOrderId"] : <any>null;
            this.suggestedRepairWorkOrderId = _data["suggestedRepairWorkOrderId"] !== undefined ? _data["suggestedRepairWorkOrderId"] : <any>null;
            this.workOrderTypeId = _data["workOrderTypeId"] !== undefined ? _data["workOrderTypeId"] : <any>null;
            this.projectId = _data["projectId"] !== undefined ? _data["projectId"] : <any>null;
            this.facilityContact = _data["facilityContact"] !== undefined ? _data["facilityContact"] : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
        }
    }

    static fromJS(data: any): WorkOrderInsertV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new WorkOrderInsertV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rowIndex"] = this.rowIndex !== undefined ? this.rowIndex : <any>null;
        data["workOrderNumber"] = this.workOrderNumber !== undefined ? this.workOrderNumber : <any>null;
        data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
        data["assetNumber"] = this.assetNumber !== undefined ? this.assetNumber : <any>null;
        data["inspectorUserId"] = this.inspectorUserId !== undefined ? this.inspectorUserId : <any>null;
        data["inspectedDate"] = this.inspectedDate ? this.inspectedDate.toISOString() : <any>null;
        data["parentWorkOrderId"] = this.parentWorkOrderId !== undefined ? this.parentWorkOrderId : <any>null;
        data["inspectionWorkOrderId"] = this.inspectionWorkOrderId !== undefined ? this.inspectionWorkOrderId : <any>null;
        data["suggestedRepairWorkOrderId"] = this.suggestedRepairWorkOrderId !== undefined ? this.suggestedRepairWorkOrderId : <any>null;
        data["workOrderTypeId"] = this.workOrderTypeId !== undefined ? this.workOrderTypeId : <any>null;
        data["projectId"] = this.projectId !== undefined ? this.projectId : <any>null;
        data["facilityContact"] = this.facilityContact !== undefined ? this.facilityContact : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        return data;
    }
}

export interface IWorkOrderInsertV1Model {
    rowIndex?: number | null;
    workOrderNumber?: string | null;
    assetId?: number;
    assetNumber?: string | null;
    inspectorUserId?: number | null;
    inspectedDate?: Date | null;
    parentWorkOrderId?: number | null;
    inspectionWorkOrderId?: number | null;
    suggestedRepairWorkOrderId?: number | null;
    workOrderTypeId?: number;
    projectId?: number;
    facilityContact?: string | null;
    status?: number;
}

export class WorkOrderAssetInsertV1Model implements IWorkOrderAssetInsertV1Model {
    workOrder?: WorkOrderInsertV1Model | null;
    asset?: AssetInsertV1Model | null;

    constructor(data?: IWorkOrderAssetInsertV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workOrder = _data["workOrder"] ? WorkOrderInsertV1Model.fromJS(_data["workOrder"]) : <any>null;
            this.asset = _data["asset"] ? AssetInsertV1Model.fromJS(_data["asset"]) : <any>null;
        }
    }

    static fromJS(data: any): WorkOrderAssetInsertV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new WorkOrderAssetInsertV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workOrder"] = this.workOrder ? this.workOrder.toJSON() : <any>null;
        data["asset"] = this.asset ? this.asset.toJSON() : <any>null;
        return data;
    }
}

export interface IWorkOrderAssetInsertV1Model {
    workOrder?: WorkOrderInsertV1Model | null;
    asset?: AssetInsertV1Model | null;
}

export class AssetInsertV1Model implements IAssetInsertV1Model {
    floorId?: number;
    facilityId?: number;
    assetNumber?: string | null;
    assetClassId?: number;
    assetProfileId?: number;
    assetProfileValues?: any | null;
    correspondingAssetIds?: number[] | null;

    constructor(data?: IAssetInsertV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.floorId = _data["floorId"] !== undefined ? _data["floorId"] : <any>null;
            this.facilityId = _data["facilityId"] !== undefined ? _data["facilityId"] : <any>null;
            this.assetNumber = _data["assetNumber"] !== undefined ? _data["assetNumber"] : <any>null;
            this.assetClassId = _data["assetClassId"] !== undefined ? _data["assetClassId"] : <any>null;
            this.assetProfileId = _data["assetProfileId"] !== undefined ? _data["assetProfileId"] : <any>null;
            this.assetProfileValues = _data["assetProfileValues"] !== undefined ? _data["assetProfileValues"] : <any>null;
            if (Array.isArray(_data["correspondingAssetIds"])) {
                this.correspondingAssetIds = [] as any;
                for (let item of _data["correspondingAssetIds"])
                    this.correspondingAssetIds!.push(item);
            }
            else {
                this.correspondingAssetIds = <any>null;
            }
        }
    }

    static fromJS(data: any): AssetInsertV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new AssetInsertV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["floorId"] = this.floorId !== undefined ? this.floorId : <any>null;
        data["facilityId"] = this.facilityId !== undefined ? this.facilityId : <any>null;
        data["assetNumber"] = this.assetNumber !== undefined ? this.assetNumber : <any>null;
        data["assetClassId"] = this.assetClassId !== undefined ? this.assetClassId : <any>null;
        data["assetProfileId"] = this.assetProfileId !== undefined ? this.assetProfileId : <any>null;
        data["assetProfileValues"] = this.assetProfileValues !== undefined ? this.assetProfileValues : <any>null;
        if (Array.isArray(this.correspondingAssetIds)) {
            data["correspondingAssetIds"] = [];
            for (let item of this.correspondingAssetIds)
                data["correspondingAssetIds"].push(item);
        }
        return data;
    }
}

export interface IAssetInsertV1Model {
    floorId?: number;
    facilityId?: number;
    assetNumber?: string | null;
    assetClassId?: number;
    assetProfileId?: number;
    assetProfileValues?: any | null;
    correspondingAssetIds?: number[] | null;
}

export class WorkOrderUpdateV1Model implements IWorkOrderUpdateV1Model {
    workOrderId!: number;
    workOrderNumber?: string | null;
    assetId?: number;
    inspectorUserId?: number | null;
    inspectedDate?: Date | null;
    status?: number;
    projectId?: number | null;
    projectPhaseId?: number | null;

    constructor(data?: IWorkOrderUpdateV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workOrderId = _data["workOrderId"] !== undefined ? _data["workOrderId"] : <any>null;
            this.workOrderNumber = _data["workOrderNumber"] !== undefined ? _data["workOrderNumber"] : <any>null;
            this.assetId = _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
            this.inspectorUserId = _data["inspectorUserId"] !== undefined ? _data["inspectorUserId"] : <any>null;
            this.inspectedDate = _data["inspectedDate"] ? new Date(_data["inspectedDate"].toString()) : <any>null;
            this.status = _data["status"] !== undefined ? _data["status"] : <any>null;
            this.projectId = _data["projectId"] !== undefined ? _data["projectId"] : <any>null;
            this.projectPhaseId = _data["projectPhaseId"] !== undefined ? _data["projectPhaseId"] : <any>null;
        }
    }

    static fromJS(data: any): WorkOrderUpdateV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new WorkOrderUpdateV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workOrderId"] = this.workOrderId !== undefined ? this.workOrderId : <any>null;
        data["workOrderNumber"] = this.workOrderNumber !== undefined ? this.workOrderNumber : <any>null;
        data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
        data["inspectorUserId"] = this.inspectorUserId !== undefined ? this.inspectorUserId : <any>null;
        data["inspectedDate"] = this.inspectedDate ? this.inspectedDate.toISOString() : <any>null;
        data["status"] = this.status !== undefined ? this.status : <any>null;
        data["projectId"] = this.projectId !== undefined ? this.projectId : <any>null;
        data["projectPhaseId"] = this.projectPhaseId !== undefined ? this.projectPhaseId : <any>null;
        return data;
    }
}

export interface IWorkOrderUpdateV1Model {
    workOrderId: number;
    workOrderNumber?: string | null;
    assetId?: number;
    inspectorUserId?: number | null;
    inspectedDate?: Date | null;
    status?: number;
    projectId?: number | null;
    projectPhaseId?: number | null;
}

export class WorkOrderUpdateStatusV1Model implements IWorkOrderUpdateStatusV1Model {
    workOrderId?: number;
    workOrderStatusId?: number;

    constructor(data?: IWorkOrderUpdateStatusV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workOrderId = _data["workOrderId"] !== undefined ? _data["workOrderId"] : <any>null;
            this.workOrderStatusId = _data["workOrderStatusId"] !== undefined ? _data["workOrderStatusId"] : <any>null;
        }
    }

    static fromJS(data: any): WorkOrderUpdateStatusV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new WorkOrderUpdateStatusV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workOrderId"] = this.workOrderId !== undefined ? this.workOrderId : <any>null;
        data["workOrderStatusId"] = this.workOrderStatusId !== undefined ? this.workOrderStatusId : <any>null;
        return data;
    }
}

export interface IWorkOrderUpdateStatusV1Model {
    workOrderId?: number;
    workOrderStatusId?: number;
}

export class WorkOrderBulkUpdateV1Model implements IWorkOrderBulkUpdateV1Model {
    workOrderIds?: number[] | null;
    inspectorUserId?: number;

    constructor(data?: IWorkOrderBulkUpdateV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["workOrderIds"])) {
                this.workOrderIds = [] as any;
                for (let item of _data["workOrderIds"])
                    this.workOrderIds!.push(item);
            }
            else {
                this.workOrderIds = <any>null;
            }
            this.inspectorUserId = _data["inspectorUserId"] !== undefined ? _data["inspectorUserId"] : <any>null;
        }
    }

    static fromJS(data: any): WorkOrderBulkUpdateV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new WorkOrderBulkUpdateV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.workOrderIds)) {
            data["workOrderIds"] = [];
            for (let item of this.workOrderIds)
                data["workOrderIds"].push(item);
        }
        data["inspectorUserId"] = this.inspectorUserId !== undefined ? this.inspectorUserId : <any>null;
        return data;
    }
}

export interface IWorkOrderBulkUpdateV1Model {
    workOrderIds?: number[] | null;
    inspectorUserId?: number;
}

export class WorkOrderBulkCreateV1Model implements IWorkOrderBulkCreateV1Model {
    projectId?: number;
    wordOrderTypeId?: number;
    assetIds?: number[] | null;

    constructor(data?: IWorkOrderBulkCreateV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"] !== undefined ? _data["projectId"] : <any>null;
            this.wordOrderTypeId = _data["wordOrderTypeId"] !== undefined ? _data["wordOrderTypeId"] : <any>null;
            if (Array.isArray(_data["assetIds"])) {
                this.assetIds = [] as any;
                for (let item of _data["assetIds"])
                    this.assetIds!.push(item);
            }
            else {
                this.assetIds = <any>null;
            }
        }
    }

    static fromJS(data: any): WorkOrderBulkCreateV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new WorkOrderBulkCreateV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId !== undefined ? this.projectId : <any>null;
        data["wordOrderTypeId"] = this.wordOrderTypeId !== undefined ? this.wordOrderTypeId : <any>null;
        if (Array.isArray(this.assetIds)) {
            data["assetIds"] = [];
            for (let item of this.assetIds)
                data["assetIds"].push(item);
        }
        return data;
    }
}

export interface IWorkOrderBulkCreateV1Model {
    projectId?: number;
    wordOrderTypeId?: number;
    assetIds?: number[] | null;
}

export class WorkOrderImportM1V1Model extends FileV1Model implements IWorkOrderImportM1V1Model {
    facilityId?: number | null;
    campusId?: number;
    assetProfile?: AssetProfile;
    timeZone?: string | null;

    constructor(data?: IWorkOrderImportM1V1Model) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.facilityId = _data["facilityId"] !== undefined ? _data["facilityId"] : <any>null;
            this.campusId = _data["campusId"] !== undefined ? _data["campusId"] : <any>null;
            this.assetProfile = _data["assetProfile"] !== undefined ? _data["assetProfile"] : <any>null;
            this.timeZone = _data["timeZone"] !== undefined ? _data["timeZone"] : <any>null;
        }
    }

    static override fromJS(data: any): WorkOrderImportM1V1Model {
        data = typeof data === 'object' ? data : {};
        let result = new WorkOrderImportM1V1Model();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facilityId"] = this.facilityId !== undefined ? this.facilityId : <any>null;
        data["campusId"] = this.campusId !== undefined ? this.campusId : <any>null;
        data["assetProfile"] = this.assetProfile !== undefined ? this.assetProfile : <any>null;
        data["timeZone"] = this.timeZone !== undefined ? this.timeZone : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IWorkOrderImportM1V1Model extends IFileV1Model {
    facilityId?: number | null;
    campusId?: number;
    assetProfile?: AssetProfile;
    timeZone?: string | null;
}

export enum AssetProfile {
    Door = 1,
    Damper = 2,
    AboveCeiling = 3,
    BelowCeiling = 4,
}

export class WorkOrderImportFileV1Model implements IWorkOrderImportFileV1Model {
    fileBase64?: string | null;
    fileName?: string | null;
    contentType?: string | null;

    constructor(data?: IWorkOrderImportFileV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileBase64 = _data["fileBase64"] !== undefined ? _data["fileBase64"] : <any>null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
            this.contentType = _data["contentType"] !== undefined ? _data["contentType"] : <any>null;
        }
    }

    static fromJS(data: any): WorkOrderImportFileV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new WorkOrderImportFileV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileBase64"] = this.fileBase64 !== undefined ? this.fileBase64 : <any>null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        data["contentType"] = this.contentType !== undefined ? this.contentType : <any>null;
        return data;
    }
}

export interface IWorkOrderImportFileV1Model {
    fileBase64?: string | null;
    fileName?: string | null;
    contentType?: string | null;
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export class ODataValueOfIEnumerableOfWorkOrderV1Model implements IODataValueOfIEnumerableOfWorkOrderV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: WorkOrderV1Model[] | null;

    constructor(data?: IODataValueOfIEnumerableOfWorkOrderV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(WorkOrderV1Model.fromJS(item));
            }
            else {
                this.value = <any>null;
            }
        }
    }

    static fromJS(data: any): ODataValueOfIEnumerableOfWorkOrderV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new ODataValueOfIEnumerableOfWorkOrderV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export interface IODataValueOfIEnumerableOfWorkOrderV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: WorkOrderV1Model[] | null;
}

export class ProjectInsertV1Model implements IProjectInsertV1Model {
    facilityId!: number;
    name!: string;
    group?: string | null;
    isActive?: boolean;
    floorIds?: number[] | null;

    constructor(data?: IProjectInsertV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.facilityId = _data["facilityId"] !== undefined ? _data["facilityId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.group = _data["group"] !== undefined ? _data["group"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            if (Array.isArray(_data["floorIds"])) {
                this.floorIds = [] as any;
                for (let item of _data["floorIds"])
                    this.floorIds!.push(item);
            }
            else {
                this.floorIds = <any>null;
            }
        }
    }

    static fromJS(data: any): ProjectInsertV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectInsertV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facilityId"] = this.facilityId !== undefined ? this.facilityId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["group"] = this.group !== undefined ? this.group : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        if (Array.isArray(this.floorIds)) {
            data["floorIds"] = [];
            for (let item of this.floorIds)
                data["floorIds"].push(item);
        }
        return data;
    }
}

export interface IProjectInsertV1Model {
    facilityId: number;
    name: string;
    group?: string | null;
    isActive?: boolean;
    floorIds?: number[] | null;
}

export class ProjectUpdateV1Model implements IProjectUpdateV1Model {
    projectId!: number;
    facilityId!: number;
    name!: string;
    isActive?: boolean;
    group?: string | null;
    floorIds?: number[] | null;

    constructor(data?: IProjectUpdateV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"] !== undefined ? _data["projectId"] : <any>null;
            this.facilityId = _data["facilityId"] !== undefined ? _data["facilityId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.group = _data["group"] !== undefined ? _data["group"] : <any>null;
            if (Array.isArray(_data["floorIds"])) {
                this.floorIds = [] as any;
                for (let item of _data["floorIds"])
                    this.floorIds!.push(item);
            }
            else {
                this.floorIds = <any>null;
            }
        }
    }

    static fromJS(data: any): ProjectUpdateV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectUpdateV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId !== undefined ? this.projectId : <any>null;
        data["facilityId"] = this.facilityId !== undefined ? this.facilityId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["group"] = this.group !== undefined ? this.group : <any>null;
        if (Array.isArray(this.floorIds)) {
            data["floorIds"] = [];
            for (let item of this.floorIds)
                data["floorIds"].push(item);
        }
        return data;
    }
}

export interface IProjectUpdateV1Model {
    projectId: number;
    facilityId: number;
    name: string;
    isActive?: boolean;
    group?: string | null;
    floorIds?: number[] | null;
}

export class ProjectV1Model implements IProjectV1Model {
    projectId!: number;
    facilityId!: number;
    facilityHeaderColor?: string | null;
    campusId?: number;
    name!: string;
    facility?: string | null;
    isActive!: boolean;
    group?: string | null;
    createdByUserId!: number;
    createdByUser!: string;
    updatedByUser!: string;
    updatedByUserId!: number;
    createdDate!: Date;
    updatedDate?: Date;
    accountId?: number;
    totalWO?: number;
    openWOCount?: number;
    completedWOCount?: number;
    canceledWOCount?: number;

    constructor(data?: IProjectV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"] !== undefined ? _data["projectId"] : <any>null;
            this.facilityId = _data["facilityId"] !== undefined ? _data["facilityId"] : <any>null;
            this.facilityHeaderColor = _data["facilityHeaderColor"] !== undefined ? _data["facilityHeaderColor"] : <any>null;
            this.campusId = _data["campusId"] !== undefined ? _data["campusId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.facility = _data["facility"] !== undefined ? _data["facility"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.group = _data["group"] !== undefined ? _data["group"] : <any>null;
            this.createdByUserId = _data["createdByUserId"] !== undefined ? _data["createdByUserId"] : <any>null;
            this.createdByUser = _data["createdByUser"] !== undefined ? _data["createdByUser"] : <any>null;
            this.updatedByUser = _data["updatedByUser"] !== undefined ? _data["updatedByUser"] : <any>null;
            this.updatedByUserId = _data["updatedByUserId"] !== undefined ? _data["updatedByUserId"] : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>null;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : <any>null;
            this.totalWO = _data["totalWO"] !== undefined ? _data["totalWO"] : <any>null;
            this.openWOCount = _data["openWOCount"] !== undefined ? _data["openWOCount"] : <any>null;
            this.completedWOCount = _data["completedWOCount"] !== undefined ? _data["completedWOCount"] : <any>null;
            this.canceledWOCount = _data["canceledWOCount"] !== undefined ? _data["canceledWOCount"] : <any>null;
        }
    }

    static fromJS(data: any): ProjectV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId !== undefined ? this.projectId : <any>null;
        data["facilityId"] = this.facilityId !== undefined ? this.facilityId : <any>null;
        data["facilityHeaderColor"] = this.facilityHeaderColor !== undefined ? this.facilityHeaderColor : <any>null;
        data["campusId"] = this.campusId !== undefined ? this.campusId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["facility"] = this.facility !== undefined ? this.facility : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["group"] = this.group !== undefined ? this.group : <any>null;
        data["createdByUserId"] = this.createdByUserId !== undefined ? this.createdByUserId : <any>null;
        data["createdByUser"] = this.createdByUser !== undefined ? this.createdByUser : <any>null;
        data["updatedByUser"] = this.updatedByUser !== undefined ? this.updatedByUser : <any>null;
        data["updatedByUserId"] = this.updatedByUserId !== undefined ? this.updatedByUserId : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>null;
        data["accountId"] = this.accountId !== undefined ? this.accountId : <any>null;
        data["totalWO"] = this.totalWO !== undefined ? this.totalWO : <any>null;
        data["openWOCount"] = this.openWOCount !== undefined ? this.openWOCount : <any>null;
        data["completedWOCount"] = this.completedWOCount !== undefined ? this.completedWOCount : <any>null;
        data["canceledWOCount"] = this.canceledWOCount !== undefined ? this.canceledWOCount : <any>null;
        return data;
    }
}

export interface IProjectV1Model {
    projectId: number;
    facilityId: number;
    facilityHeaderColor?: string | null;
    campusId?: number;
    name: string;
    facility?: string | null;
    isActive: boolean;
    group?: string | null;
    createdByUserId: number;
    createdByUser: string;
    updatedByUser: string;
    updatedByUserId: number;
    createdDate: Date;
    updatedDate?: Date;
    accountId?: number;
    totalWO?: number;
    openWOCount?: number;
    completedWOCount?: number;
    canceledWOCount?: number;
}

export class ProjectSummarySearchV1Model implements IProjectSummarySearchV1Model {
    facilityId?: number | null;

    constructor(data?: IProjectSummarySearchV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.facilityId = _data["facilityId"] !== undefined ? _data["facilityId"] : <any>null;
        }
    }

    static fromJS(data: any): ProjectSummarySearchV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectSummarySearchV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facilityId"] = this.facilityId !== undefined ? this.facilityId : <any>null;
        return data;
    }
}

export interface IProjectSummarySearchV1Model {
    facilityId?: number | null;
}

export class ProjectWithFloorsV1Model implements IProjectWithFloorsV1Model {
    projectId!: number;
    name!: string;
    isActive!: boolean;
    group?: string | null;
    createdByUserId!: number;
    createdByUser!: string;
    updatedByUser!: string;
    updatedByUserId!: number;
    createdDate!: Date;
    updatedDate?: Date;
    floors?: FloorV1Model[] | null;

    constructor(data?: IProjectWithFloorsV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"] !== undefined ? _data["projectId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.group = _data["group"] !== undefined ? _data["group"] : <any>null;
            this.createdByUserId = _data["createdByUserId"] !== undefined ? _data["createdByUserId"] : <any>null;
            this.createdByUser = _data["createdByUser"] !== undefined ? _data["createdByUser"] : <any>null;
            this.updatedByUser = _data["updatedByUser"] !== undefined ? _data["updatedByUser"] : <any>null;
            this.updatedByUserId = _data["updatedByUserId"] !== undefined ? _data["updatedByUserId"] : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>null;
            if (Array.isArray(_data["floors"])) {
                this.floors = [] as any;
                for (let item of _data["floors"])
                    this.floors!.push(FloorV1Model.fromJS(item));
            }
            else {
                this.floors = <any>null;
            }
        }
    }

    static fromJS(data: any): ProjectWithFloorsV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectWithFloorsV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId !== undefined ? this.projectId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["group"] = this.group !== undefined ? this.group : <any>null;
        data["createdByUserId"] = this.createdByUserId !== undefined ? this.createdByUserId : <any>null;
        data["createdByUser"] = this.createdByUser !== undefined ? this.createdByUser : <any>null;
        data["updatedByUser"] = this.updatedByUser !== undefined ? this.updatedByUser : <any>null;
        data["updatedByUserId"] = this.updatedByUserId !== undefined ? this.updatedByUserId : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>null;
        if (Array.isArray(this.floors)) {
            data["floors"] = [];
            for (let item of this.floors)
                data["floors"].push(item.toJSON());
        }
        return data;
    }
}

export interface IProjectWithFloorsV1Model {
    projectId: number;
    name: string;
    isActive: boolean;
    group?: string | null;
    createdByUserId: number;
    createdByUser: string;
    updatedByUser: string;
    updatedByUserId: number;
    createdDate: Date;
    updatedDate?: Date;
    floors?: FloorV1Model[] | null;
}

export class FloorV1Model implements IFloorV1Model {
    floorId!: number;
    facilityId!: number;
    floor!: string;
    shortName!: string;
    latitude?: number;
    longitude?: number;
    createdByUserId!: number;
    createdDate!: Date;
    updatedByUserId!: number;
    updatedDate!: Date;
    accountId?: number;

    constructor(data?: IFloorV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.floorId = _data["floorId"] !== undefined ? _data["floorId"] : <any>null;
            this.facilityId = _data["facilityId"] !== undefined ? _data["facilityId"] : <any>null;
            this.floor = _data["floor"] !== undefined ? _data["floor"] : <any>null;
            this.shortName = _data["shortName"] !== undefined ? _data["shortName"] : <any>null;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : <any>null;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : <any>null;
            this.createdByUserId = _data["createdByUserId"] !== undefined ? _data["createdByUserId"] : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.updatedByUserId = _data["updatedByUserId"] !== undefined ? _data["updatedByUserId"] : <any>null;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>null;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : <any>null;
        }
    }

    static fromJS(data: any): FloorV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new FloorV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["floorId"] = this.floorId !== undefined ? this.floorId : <any>null;
        data["facilityId"] = this.facilityId !== undefined ? this.facilityId : <any>null;
        data["floor"] = this.floor !== undefined ? this.floor : <any>null;
        data["shortName"] = this.shortName !== undefined ? this.shortName : <any>null;
        data["latitude"] = this.latitude !== undefined ? this.latitude : <any>null;
        data["longitude"] = this.longitude !== undefined ? this.longitude : <any>null;
        data["createdByUserId"] = this.createdByUserId !== undefined ? this.createdByUserId : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["updatedByUserId"] = this.updatedByUserId !== undefined ? this.updatedByUserId : <any>null;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>null;
        data["accountId"] = this.accountId !== undefined ? this.accountId : <any>null;
        return data;
    }
}

export interface IFloorV1Model {
    floorId: number;
    facilityId: number;
    floor: string;
    shortName: string;
    latitude?: number;
    longitude?: number;
    createdByUserId: number;
    createdDate: Date;
    updatedByUserId: number;
    updatedDate: Date;
    accountId?: number;
}

export class ProjectBlueprintLineInsertV1Model implements IProjectBlueprintLineInsertV1Model {
    projectId?: number;
    blueprintId?: number;
    startX?: number;
    startY?: number;
    endX?: number;
    endY?: number;
    note?: string | null;

    constructor(data?: IProjectBlueprintLineInsertV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"] !== undefined ? _data["projectId"] : <any>null;
            this.blueprintId = _data["blueprintId"] !== undefined ? _data["blueprintId"] : <any>null;
            this.startX = _data["startX"] !== undefined ? _data["startX"] : <any>null;
            this.startY = _data["startY"] !== undefined ? _data["startY"] : <any>null;
            this.endX = _data["endX"] !== undefined ? _data["endX"] : <any>null;
            this.endY = _data["endY"] !== undefined ? _data["endY"] : <any>null;
            this.note = _data["note"] !== undefined ? _data["note"] : <any>null;
        }
    }

    static fromJS(data: any): ProjectBlueprintLineInsertV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectBlueprintLineInsertV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId !== undefined ? this.projectId : <any>null;
        data["blueprintId"] = this.blueprintId !== undefined ? this.blueprintId : <any>null;
        data["startX"] = this.startX !== undefined ? this.startX : <any>null;
        data["startY"] = this.startY !== undefined ? this.startY : <any>null;
        data["endX"] = this.endX !== undefined ? this.endX : <any>null;
        data["endY"] = this.endY !== undefined ? this.endY : <any>null;
        data["note"] = this.note !== undefined ? this.note : <any>null;
        return data;
    }
}

export interface IProjectBlueprintLineInsertV1Model {
    projectId?: number;
    blueprintId?: number;
    startX?: number;
    startY?: number;
    endX?: number;
    endY?: number;
    note?: string | null;
}

export class ProjectBlueprintLineV1Model implements IProjectBlueprintLineV1Model {
    projectBlueprintLineId!: number;
    projectBlueprintId!: number;
    userId!: number;
    userName!: string;
    userLineColor?: string | null;
    startX!: number;
    startY!: number;
    endX!: number;
    endY!: number;
    note?: string | null;
    createdByUserId!: number;
    updatedByUserId!: number;
    createdDate!: Date;
    updatedDate!: Date;

    constructor(data?: IProjectBlueprintLineV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectBlueprintLineId = _data["projectBlueprintLineId"] !== undefined ? _data["projectBlueprintLineId"] : <any>null;
            this.projectBlueprintId = _data["projectBlueprintId"] !== undefined ? _data["projectBlueprintId"] : <any>null;
            this.userId = _data["userId"] !== undefined ? _data["userId"] : <any>null;
            this.userName = _data["userName"] !== undefined ? _data["userName"] : <any>null;
            this.userLineColor = _data["userLineColor"] !== undefined ? _data["userLineColor"] : <any>null;
            this.startX = _data["startX"] !== undefined ? _data["startX"] : <any>null;
            this.startY = _data["startY"] !== undefined ? _data["startY"] : <any>null;
            this.endX = _data["endX"] !== undefined ? _data["endX"] : <any>null;
            this.endY = _data["endY"] !== undefined ? _data["endY"] : <any>null;
            this.note = _data["note"] !== undefined ? _data["note"] : <any>null;
            this.createdByUserId = _data["createdByUserId"] !== undefined ? _data["createdByUserId"] : <any>null;
            this.updatedByUserId = _data["updatedByUserId"] !== undefined ? _data["updatedByUserId"] : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): ProjectBlueprintLineV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectBlueprintLineV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectBlueprintLineId"] = this.projectBlueprintLineId !== undefined ? this.projectBlueprintLineId : <any>null;
        data["projectBlueprintId"] = this.projectBlueprintId !== undefined ? this.projectBlueprintId : <any>null;
        data["userId"] = this.userId !== undefined ? this.userId : <any>null;
        data["userName"] = this.userName !== undefined ? this.userName : <any>null;
        data["userLineColor"] = this.userLineColor !== undefined ? this.userLineColor : <any>null;
        data["startX"] = this.startX !== undefined ? this.startX : <any>null;
        data["startY"] = this.startY !== undefined ? this.startY : <any>null;
        data["endX"] = this.endX !== undefined ? this.endX : <any>null;
        data["endY"] = this.endY !== undefined ? this.endY : <any>null;
        data["note"] = this.note !== undefined ? this.note : <any>null;
        data["createdByUserId"] = this.createdByUserId !== undefined ? this.createdByUserId : <any>null;
        data["updatedByUserId"] = this.updatedByUserId !== undefined ? this.updatedByUserId : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>null;
        return data;
    }
}

export interface IProjectBlueprintLineV1Model {
    projectBlueprintLineId: number;
    projectBlueprintId: number;
    userId: number;
    userName: string;
    userLineColor?: string | null;
    startX: number;
    startY: number;
    endX: number;
    endY: number;
    note?: string | null;
    createdByUserId: number;
    updatedByUserId: number;
    createdDate: Date;
    updatedDate: Date;
}

export class ProjectBlueprintLineSearchV1Model implements IProjectBlueprintLineSearchV1Model {
    projectId?: number;
    blueprintId?: number;

    constructor(data?: IProjectBlueprintLineSearchV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"] !== undefined ? _data["projectId"] : <any>null;
            this.blueprintId = _data["blueprintId"] !== undefined ? _data["blueprintId"] : <any>null;
        }
    }

    static fromJS(data: any): ProjectBlueprintLineSearchV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectBlueprintLineSearchV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId !== undefined ? this.projectId : <any>null;
        data["blueprintId"] = this.blueprintId !== undefined ? this.blueprintId : <any>null;
        return data;
    }
}

export interface IProjectBlueprintLineSearchV1Model {
    projectId?: number;
    blueprintId?: number;
}

export class ProjectBlueprintLineUpdateV1Model implements IProjectBlueprintLineUpdateV1Model {
    projectBlueprintLineId?: number;
    note?: string | null;

    constructor(data?: IProjectBlueprintLineUpdateV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectBlueprintLineId = _data["projectBlueprintLineId"] !== undefined ? _data["projectBlueprintLineId"] : <any>null;
            this.note = _data["note"] !== undefined ? _data["note"] : <any>null;
        }
    }

    static fromJS(data: any): ProjectBlueprintLineUpdateV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectBlueprintLineUpdateV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectBlueprintLineId"] = this.projectBlueprintLineId !== undefined ? this.projectBlueprintLineId : <any>null;
        data["note"] = this.note !== undefined ? this.note : <any>null;
        return data;
    }
}

export interface IProjectBlueprintLineUpdateV1Model {
    projectBlueprintLineId?: number;
    note?: string | null;
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export class ODataValueOfIEnumerableOfProjectV1Model implements IODataValueOfIEnumerableOfProjectV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: ProjectV1Model[] | null;

    constructor(data?: IODataValueOfIEnumerableOfProjectV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(ProjectV1Model.fromJS(item));
            }
            else {
                this.value = <any>null;
            }
        }
    }

    static fromJS(data: any): ODataValueOfIEnumerableOfProjectV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new ODataValueOfIEnumerableOfProjectV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export interface IODataValueOfIEnumerableOfProjectV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: ProjectV1Model[] | null;
}

export class ProjectPhaseV1Model implements IProjectPhaseV1Model {
    projectPhaseId?: number;
    projectId?: number;
    phase?: string | null;
    phaseType?: string | null;
    phaseTypeId?: number;

    constructor(data?: IProjectPhaseV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectPhaseId = _data["projectPhaseId"] !== undefined ? _data["projectPhaseId"] : <any>null;
            this.projectId = _data["projectId"] !== undefined ? _data["projectId"] : <any>null;
            this.phase = _data["phase"] !== undefined ? _data["phase"] : <any>null;
            this.phaseType = _data["phaseType"] !== undefined ? _data["phaseType"] : <any>null;
            this.phaseTypeId = _data["phaseTypeId"] !== undefined ? _data["phaseTypeId"] : <any>null;
        }
    }

    static fromJS(data: any): ProjectPhaseV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectPhaseV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectPhaseId"] = this.projectPhaseId !== undefined ? this.projectPhaseId : <any>null;
        data["projectId"] = this.projectId !== undefined ? this.projectId : <any>null;
        data["phase"] = this.phase !== undefined ? this.phase : <any>null;
        data["phaseType"] = this.phaseType !== undefined ? this.phaseType : <any>null;
        data["phaseTypeId"] = this.phaseTypeId !== undefined ? this.phaseTypeId : <any>null;
        return data;
    }
}

export interface IProjectPhaseV1Model {
    projectPhaseId?: number;
    projectId?: number;
    phase?: string | null;
    phaseType?: string | null;
    phaseTypeId?: number;
}

export class ProjectPhaseInsertV1Model implements IProjectPhaseInsertV1Model {
    projectId?: number;
    phase?: string | null;
    phaseTypeId?: number;

    constructor(data?: IProjectPhaseInsertV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"] !== undefined ? _data["projectId"] : <any>null;
            this.phase = _data["phase"] !== undefined ? _data["phase"] : <any>null;
            this.phaseTypeId = _data["phaseTypeId"] !== undefined ? _data["phaseTypeId"] : <any>null;
        }
    }

    static fromJS(data: any): ProjectPhaseInsertV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectPhaseInsertV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId !== undefined ? this.projectId : <any>null;
        data["phase"] = this.phase !== undefined ? this.phase : <any>null;
        data["phaseTypeId"] = this.phaseTypeId !== undefined ? this.phaseTypeId : <any>null;
        return data;
    }
}

export interface IProjectPhaseInsertV1Model {
    projectId?: number;
    phase?: string | null;
    phaseTypeId?: number;
}

export class ProjectPhaseUpdateV1Model implements IProjectPhaseUpdateV1Model {
    projectPhaseId?: number;
    phase?: string | null;
    phaseTypeId?: number;

    constructor(data?: IProjectPhaseUpdateV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectPhaseId = _data["projectPhaseId"] !== undefined ? _data["projectPhaseId"] : <any>null;
            this.phase = _data["phase"] !== undefined ? _data["phase"] : <any>null;
            this.phaseTypeId = _data["phaseTypeId"] !== undefined ? _data["phaseTypeId"] : <any>null;
        }
    }

    static fromJS(data: any): ProjectPhaseUpdateV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectPhaseUpdateV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectPhaseId"] = this.projectPhaseId !== undefined ? this.projectPhaseId : <any>null;
        data["phase"] = this.phase !== undefined ? this.phase : <any>null;
        data["phaseTypeId"] = this.phaseTypeId !== undefined ? this.phaseTypeId : <any>null;
        return data;
    }
}

export interface IProjectPhaseUpdateV1Model {
    projectPhaseId?: number;
    phase?: string | null;
    phaseTypeId?: number;
}

export class OfflineDataSyncV1Model implements IOfflineDataSyncV1Model {
    facility?: FacilityV1Model | null;
    floors?: FloorV1Model[] | null;
    blueprints?: BlueprintV1Model[] | null;
    assets?: AssetV1Model[] | null;
    assetItemCounts?: AssetItemCountV1Model[] | null;
    assetClasses?: AssetClassV1Model[] | null;
    assetProfileTypes?: AssetProfileTypeV1Model[] | null;
    assetProfiles?: AssetProfileV1Model[] | null;
    assetWarranties?: AssetWarrantyV1Model[] | null;
    assetDrawings?: AssetDrawingV1Model[] | null;

    constructor(data?: IOfflineDataSyncV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.facility = _data["facility"] ? FacilityV1Model.fromJS(_data["facility"]) : <any>null;
            if (Array.isArray(_data["floors"])) {
                this.floors = [] as any;
                for (let item of _data["floors"])
                    this.floors!.push(FloorV1Model.fromJS(item));
            }
            else {
                this.floors = <any>null;
            }
            if (Array.isArray(_data["blueprints"])) {
                this.blueprints = [] as any;
                for (let item of _data["blueprints"])
                    this.blueprints!.push(BlueprintV1Model.fromJS(item));
            }
            else {
                this.blueprints = <any>null;
            }
            if (Array.isArray(_data["assets"])) {
                this.assets = [] as any;
                for (let item of _data["assets"])
                    this.assets!.push(AssetV1Model.fromJS(item));
            }
            else {
                this.assets = <any>null;
            }
            if (Array.isArray(_data["assetItemCounts"])) {
                this.assetItemCounts = [] as any;
                for (let item of _data["assetItemCounts"])
                    this.assetItemCounts!.push(AssetItemCountV1Model.fromJS(item));
            }
            else {
                this.assetItemCounts = <any>null;
            }
            if (Array.isArray(_data["assetClasses"])) {
                this.assetClasses = [] as any;
                for (let item of _data["assetClasses"])
                    this.assetClasses!.push(AssetClassV1Model.fromJS(item));
            }
            else {
                this.assetClasses = <any>null;
            }
            if (Array.isArray(_data["assetProfileTypes"])) {
                this.assetProfileTypes = [] as any;
                for (let item of _data["assetProfileTypes"])
                    this.assetProfileTypes!.push(AssetProfileTypeV1Model.fromJS(item));
            }
            else {
                this.assetProfileTypes = <any>null;
            }
            if (Array.isArray(_data["assetProfiles"])) {
                this.assetProfiles = [] as any;
                for (let item of _data["assetProfiles"])
                    this.assetProfiles!.push(AssetProfileV1Model.fromJS(item));
            }
            else {
                this.assetProfiles = <any>null;
            }
            if (Array.isArray(_data["assetWarranties"])) {
                this.assetWarranties = [] as any;
                for (let item of _data["assetWarranties"])
                    this.assetWarranties!.push(AssetWarrantyV1Model.fromJS(item));
            }
            else {
                this.assetWarranties = <any>null;
            }
            if (Array.isArray(_data["assetDrawings"])) {
                this.assetDrawings = [] as any;
                for (let item of _data["assetDrawings"])
                    this.assetDrawings!.push(AssetDrawingV1Model.fromJS(item));
            }
            else {
                this.assetDrawings = <any>null;
            }
        }
    }

    static fromJS(data: any): OfflineDataSyncV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new OfflineDataSyncV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facility"] = this.facility ? this.facility.toJSON() : <any>null;
        if (Array.isArray(this.floors)) {
            data["floors"] = [];
            for (let item of this.floors)
                data["floors"].push(item.toJSON());
        }
        if (Array.isArray(this.blueprints)) {
            data["blueprints"] = [];
            for (let item of this.blueprints)
                data["blueprints"].push(item.toJSON());
        }
        if (Array.isArray(this.assets)) {
            data["assets"] = [];
            for (let item of this.assets)
                data["assets"].push(item.toJSON());
        }
        if (Array.isArray(this.assetItemCounts)) {
            data["assetItemCounts"] = [];
            for (let item of this.assetItemCounts)
                data["assetItemCounts"].push(item.toJSON());
        }
        if (Array.isArray(this.assetClasses)) {
            data["assetClasses"] = [];
            for (let item of this.assetClasses)
                data["assetClasses"].push(item.toJSON());
        }
        if (Array.isArray(this.assetProfileTypes)) {
            data["assetProfileTypes"] = [];
            for (let item of this.assetProfileTypes)
                data["assetProfileTypes"].push(item.toJSON());
        }
        if (Array.isArray(this.assetProfiles)) {
            data["assetProfiles"] = [];
            for (let item of this.assetProfiles)
                data["assetProfiles"].push(item.toJSON());
        }
        if (Array.isArray(this.assetWarranties)) {
            data["assetWarranties"] = [];
            for (let item of this.assetWarranties)
                data["assetWarranties"].push(item.toJSON());
        }
        if (Array.isArray(this.assetDrawings)) {
            data["assetDrawings"] = [];
            for (let item of this.assetDrawings)
                data["assetDrawings"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOfflineDataSyncV1Model {
    facility?: FacilityV1Model | null;
    floors?: FloorV1Model[] | null;
    blueprints?: BlueprintV1Model[] | null;
    assets?: AssetV1Model[] | null;
    assetItemCounts?: AssetItemCountV1Model[] | null;
    assetClasses?: AssetClassV1Model[] | null;
    assetProfileTypes?: AssetProfileTypeV1Model[] | null;
    assetProfiles?: AssetProfileV1Model[] | null;
    assetWarranties?: AssetWarrantyV1Model[] | null;
    assetDrawings?: AssetDrawingV1Model[] | null;
}

export class FacilityV1Model implements IFacilityV1Model {
    facilityId!: number;
    facilityTypeId!: number;
    facilityTypeName!: string;
    facilityTypeIconId?: number;
    facilityTypeIconFileGuid?: string | null;
    campusId!: number;
    campusName?: string | null;
    facilityHeaderColor?: string | null;
    name!: string;
    shortName?: string | null;
    latitude?: number;
    longitude?: number;
    address?: string | null;
    city?: string | null;
    country?: string | null;
    state?: string | null;
    zip?: string | null;
    facilityContact?: string | null;
    createdByUserId!: number;
    createdDate!: Date;
    updatedByUserId!: number;
    updatedDate!: Date;
    accountId?: number;
    isDefault!: boolean;

    constructor(data?: IFacilityV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.facilityId = _data["facilityId"] !== undefined ? _data["facilityId"] : <any>null;
            this.facilityTypeId = _data["facilityTypeId"] !== undefined ? _data["facilityTypeId"] : <any>null;
            this.facilityTypeName = _data["facilityTypeName"] !== undefined ? _data["facilityTypeName"] : <any>null;
            this.facilityTypeIconId = _data["facilityTypeIconId"] !== undefined ? _data["facilityTypeIconId"] : <any>null;
            this.facilityTypeIconFileGuid = _data["facilityTypeIconFileGuid"] !== undefined ? _data["facilityTypeIconFileGuid"] : <any>null;
            this.campusId = _data["campusId"] !== undefined ? _data["campusId"] : <any>null;
            this.campusName = _data["campusName"] !== undefined ? _data["campusName"] : <any>null;
            this.facilityHeaderColor = _data["facilityHeaderColor"] !== undefined ? _data["facilityHeaderColor"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.shortName = _data["shortName"] !== undefined ? _data["shortName"] : <any>null;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : <any>null;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : <any>null;
            this.address = _data["address"] !== undefined ? _data["address"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : <any>null;
            this.facilityContact = _data["facilityContact"] !== undefined ? _data["facilityContact"] : <any>null;
            this.createdByUserId = _data["createdByUserId"] !== undefined ? _data["createdByUserId"] : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.updatedByUserId = _data["updatedByUserId"] !== undefined ? _data["updatedByUserId"] : <any>null;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>null;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : <any>null;
            this.isDefault = _data["isDefault"] !== undefined ? _data["isDefault"] : <any>null;
        }
    }

    static fromJS(data: any): FacilityV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new FacilityV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facilityId"] = this.facilityId !== undefined ? this.facilityId : <any>null;
        data["facilityTypeId"] = this.facilityTypeId !== undefined ? this.facilityTypeId : <any>null;
        data["facilityTypeName"] = this.facilityTypeName !== undefined ? this.facilityTypeName : <any>null;
        data["facilityTypeIconId"] = this.facilityTypeIconId !== undefined ? this.facilityTypeIconId : <any>null;
        data["facilityTypeIconFileGuid"] = this.facilityTypeIconFileGuid !== undefined ? this.facilityTypeIconFileGuid : <any>null;
        data["campusId"] = this.campusId !== undefined ? this.campusId : <any>null;
        data["campusName"] = this.campusName !== undefined ? this.campusName : <any>null;
        data["facilityHeaderColor"] = this.facilityHeaderColor !== undefined ? this.facilityHeaderColor : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["shortName"] = this.shortName !== undefined ? this.shortName : <any>null;
        data["latitude"] = this.latitude !== undefined ? this.latitude : <any>null;
        data["longitude"] = this.longitude !== undefined ? this.longitude : <any>null;
        data["address"] = this.address !== undefined ? this.address : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["zip"] = this.zip !== undefined ? this.zip : <any>null;
        data["facilityContact"] = this.facilityContact !== undefined ? this.facilityContact : <any>null;
        data["createdByUserId"] = this.createdByUserId !== undefined ? this.createdByUserId : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["updatedByUserId"] = this.updatedByUserId !== undefined ? this.updatedByUserId : <any>null;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>null;
        data["accountId"] = this.accountId !== undefined ? this.accountId : <any>null;
        data["isDefault"] = this.isDefault !== undefined ? this.isDefault : <any>null;
        return data;
    }
}

export interface IFacilityV1Model {
    facilityId: number;
    facilityTypeId: number;
    facilityTypeName: string;
    facilityTypeIconId?: number;
    facilityTypeIconFileGuid?: string | null;
    campusId: number;
    campusName?: string | null;
    facilityHeaderColor?: string | null;
    name: string;
    shortName?: string | null;
    latitude?: number;
    longitude?: number;
    address?: string | null;
    city?: string | null;
    country?: string | null;
    state?: string | null;
    zip?: string | null;
    facilityContact?: string | null;
    createdByUserId: number;
    createdDate: Date;
    updatedByUserId: number;
    updatedDate: Date;
    accountId?: number;
    isDefault: boolean;
}

export class AssetV1Model implements IAssetV1Model {
    assetId!: number;
    campusId?: number;
    name!: string;
    assetNumber!: string;
    assetStatus!: string;
    assetClassId!: number;
    assetProfileId!: number;
    assetClass?: string | null;
    iconId?: number | null;
    iconFileGuid?: string | null;
    iconFileName?: string | null;
    floorId?: number | null;
    floor?: string | null;
    qrCodeGuid?: string | null;
    notes?: string | null;
    createdByUserId?: number;
    createdDate!: Date;
    createdByUser!: string;
    updatedByUserId!: number;
    updatedDate!: Date;
    updatedByUser!: string;
    facilityId!: number;
    facility!: string;
    isActive?: boolean;
    accountId?: number;
    blueprintLocationThumbnailGuid?: string | null;

    constructor(data?: IAssetV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetId = _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
            this.campusId = _data["campusId"] !== undefined ? _data["campusId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.assetNumber = _data["assetNumber"] !== undefined ? _data["assetNumber"] : <any>null;
            this.assetStatus = _data["assetStatus"] !== undefined ? _data["assetStatus"] : <any>null;
            this.assetClassId = _data["assetClassId"] !== undefined ? _data["assetClassId"] : <any>null;
            this.assetProfileId = _data["assetProfileId"] !== undefined ? _data["assetProfileId"] : <any>null;
            this.assetClass = _data["assetClass"] !== undefined ? _data["assetClass"] : <any>null;
            this.iconId = _data["iconId"] !== undefined ? _data["iconId"] : <any>null;
            this.iconFileGuid = _data["iconFileGuid"] !== undefined ? _data["iconFileGuid"] : <any>null;
            this.iconFileName = _data["iconFileName"] !== undefined ? _data["iconFileName"] : <any>null;
            this.floorId = _data["floorId"] !== undefined ? _data["floorId"] : <any>null;
            this.floor = _data["floor"] !== undefined ? _data["floor"] : <any>null;
            this.qrCodeGuid = _data["qrCodeGuid"] !== undefined ? _data["qrCodeGuid"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
            this.createdByUserId = _data["createdByUserId"] !== undefined ? _data["createdByUserId"] : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.createdByUser = _data["createdByUser"] !== undefined ? _data["createdByUser"] : <any>null;
            this.updatedByUserId = _data["updatedByUserId"] !== undefined ? _data["updatedByUserId"] : <any>null;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>null;
            this.updatedByUser = _data["updatedByUser"] !== undefined ? _data["updatedByUser"] : <any>null;
            this.facilityId = _data["facilityId"] !== undefined ? _data["facilityId"] : <any>null;
            this.facility = _data["facility"] !== undefined ? _data["facility"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : <any>null;
            this.blueprintLocationThumbnailGuid = _data["blueprintLocationThumbnailGuid"] !== undefined ? _data["blueprintLocationThumbnailGuid"] : <any>null;
        }
    }

    static fromJS(data: any): AssetV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new AssetV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
        data["campusId"] = this.campusId !== undefined ? this.campusId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["assetNumber"] = this.assetNumber !== undefined ? this.assetNumber : <any>null;
        data["assetStatus"] = this.assetStatus !== undefined ? this.assetStatus : <any>null;
        data["assetClassId"] = this.assetClassId !== undefined ? this.assetClassId : <any>null;
        data["assetProfileId"] = this.assetProfileId !== undefined ? this.assetProfileId : <any>null;
        data["assetClass"] = this.assetClass !== undefined ? this.assetClass : <any>null;
        data["iconId"] = this.iconId !== undefined ? this.iconId : <any>null;
        data["iconFileGuid"] = this.iconFileGuid !== undefined ? this.iconFileGuid : <any>null;
        data["iconFileName"] = this.iconFileName !== undefined ? this.iconFileName : <any>null;
        data["floorId"] = this.floorId !== undefined ? this.floorId : <any>null;
        data["floor"] = this.floor !== undefined ? this.floor : <any>null;
        data["qrCodeGuid"] = this.qrCodeGuid !== undefined ? this.qrCodeGuid : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        data["createdByUserId"] = this.createdByUserId !== undefined ? this.createdByUserId : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["createdByUser"] = this.createdByUser !== undefined ? this.createdByUser : <any>null;
        data["updatedByUserId"] = this.updatedByUserId !== undefined ? this.updatedByUserId : <any>null;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>null;
        data["updatedByUser"] = this.updatedByUser !== undefined ? this.updatedByUser : <any>null;
        data["facilityId"] = this.facilityId !== undefined ? this.facilityId : <any>null;
        data["facility"] = this.facility !== undefined ? this.facility : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["accountId"] = this.accountId !== undefined ? this.accountId : <any>null;
        data["blueprintLocationThumbnailGuid"] = this.blueprintLocationThumbnailGuid !== undefined ? this.blueprintLocationThumbnailGuid : <any>null;
        return data;
    }
}

export interface IAssetV1Model {
    assetId: number;
    campusId?: number;
    name: string;
    assetNumber: string;
    assetStatus: string;
    assetClassId: number;
    assetProfileId: number;
    assetClass?: string | null;
    iconId?: number | null;
    iconFileGuid?: string | null;
    iconFileName?: string | null;
    floorId?: number | null;
    floor?: string | null;
    qrCodeGuid?: string | null;
    notes?: string | null;
    createdByUserId?: number;
    createdDate: Date;
    createdByUser: string;
    updatedByUserId: number;
    updatedDate: Date;
    updatedByUser: string;
    facilityId: number;
    facility: string;
    isActive?: boolean;
    accountId?: number;
    blueprintLocationThumbnailGuid?: string | null;
}

export class AssetItemCountV1Model implements IAssetItemCountV1Model {
    assetId?: number;
    documentCount?: number;
    lastDocumentUpdatedDate?: Date | null;
    drawingCount?: number;
    lastDrawingUpdatedDate?: Date | null;
    photoCount?: number;
    lastPhotoUpdatedDate?: Date | null;
    videoCount?: number;
    lastVideoUpdatedDate?: Date | null;
    warrantyCount?: number;
    lastWarrantyUpdatedDate?: Date | null;
    workOrderCount?: number;
    lastWorkOrderUpdatedDate?: Date | null;
    assetCount?: number;
    lastAssetUpdatedDate?: Date | null;

    constructor(data?: IAssetItemCountV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetId = _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
            this.documentCount = _data["documentCount"] !== undefined ? _data["documentCount"] : <any>null;
            this.lastDocumentUpdatedDate = _data["lastDocumentUpdatedDate"] ? new Date(_data["lastDocumentUpdatedDate"].toString()) : <any>null;
            this.drawingCount = _data["drawingCount"] !== undefined ? _data["drawingCount"] : <any>null;
            this.lastDrawingUpdatedDate = _data["lastDrawingUpdatedDate"] ? new Date(_data["lastDrawingUpdatedDate"].toString()) : <any>null;
            this.photoCount = _data["photoCount"] !== undefined ? _data["photoCount"] : <any>null;
            this.lastPhotoUpdatedDate = _data["lastPhotoUpdatedDate"] ? new Date(_data["lastPhotoUpdatedDate"].toString()) : <any>null;
            this.videoCount = _data["videoCount"] !== undefined ? _data["videoCount"] : <any>null;
            this.lastVideoUpdatedDate = _data["lastVideoUpdatedDate"] ? new Date(_data["lastVideoUpdatedDate"].toString()) : <any>null;
            this.warrantyCount = _data["warrantyCount"] !== undefined ? _data["warrantyCount"] : <any>null;
            this.lastWarrantyUpdatedDate = _data["lastWarrantyUpdatedDate"] ? new Date(_data["lastWarrantyUpdatedDate"].toString()) : <any>null;
            this.workOrderCount = _data["workOrderCount"] !== undefined ? _data["workOrderCount"] : <any>null;
            this.lastWorkOrderUpdatedDate = _data["lastWorkOrderUpdatedDate"] ? new Date(_data["lastWorkOrderUpdatedDate"].toString()) : <any>null;
            this.assetCount = _data["assetCount"] !== undefined ? _data["assetCount"] : <any>null;
            this.lastAssetUpdatedDate = _data["lastAssetUpdatedDate"] ? new Date(_data["lastAssetUpdatedDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): AssetItemCountV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new AssetItemCountV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
        data["documentCount"] = this.documentCount !== undefined ? this.documentCount : <any>null;
        data["lastDocumentUpdatedDate"] = this.lastDocumentUpdatedDate ? this.lastDocumentUpdatedDate.toISOString() : <any>null;
        data["drawingCount"] = this.drawingCount !== undefined ? this.drawingCount : <any>null;
        data["lastDrawingUpdatedDate"] = this.lastDrawingUpdatedDate ? this.lastDrawingUpdatedDate.toISOString() : <any>null;
        data["photoCount"] = this.photoCount !== undefined ? this.photoCount : <any>null;
        data["lastPhotoUpdatedDate"] = this.lastPhotoUpdatedDate ? this.lastPhotoUpdatedDate.toISOString() : <any>null;
        data["videoCount"] = this.videoCount !== undefined ? this.videoCount : <any>null;
        data["lastVideoUpdatedDate"] = this.lastVideoUpdatedDate ? this.lastVideoUpdatedDate.toISOString() : <any>null;
        data["warrantyCount"] = this.warrantyCount !== undefined ? this.warrantyCount : <any>null;
        data["lastWarrantyUpdatedDate"] = this.lastWarrantyUpdatedDate ? this.lastWarrantyUpdatedDate.toISOString() : <any>null;
        data["workOrderCount"] = this.workOrderCount !== undefined ? this.workOrderCount : <any>null;
        data["lastWorkOrderUpdatedDate"] = this.lastWorkOrderUpdatedDate ? this.lastWorkOrderUpdatedDate.toISOString() : <any>null;
        data["assetCount"] = this.assetCount !== undefined ? this.assetCount : <any>null;
        data["lastAssetUpdatedDate"] = this.lastAssetUpdatedDate ? this.lastAssetUpdatedDate.toISOString() : <any>null;
        return data;
    }
}

export interface IAssetItemCountV1Model {
    assetId?: number;
    documentCount?: number;
    lastDocumentUpdatedDate?: Date | null;
    drawingCount?: number;
    lastDrawingUpdatedDate?: Date | null;
    photoCount?: number;
    lastPhotoUpdatedDate?: Date | null;
    videoCount?: number;
    lastVideoUpdatedDate?: Date | null;
    warrantyCount?: number;
    lastWarrantyUpdatedDate?: Date | null;
    workOrderCount?: number;
    lastWorkOrderUpdatedDate?: Date | null;
    assetCount?: number;
    lastAssetUpdatedDate?: Date | null;
}

export class AssetClassV1Model implements IAssetClassV1Model {
    assetClassId!: number;
    accountId?: number;
    assetClass?: string | null;
    inspectionFormId?: number;
    inspectionForm?: string | null;
    suggestedRepairFormId?: number;
    suggestedRepairForm?: string | null;
    repairFormId?: number;
    repairForm?: string | null;
    iconId?: number | null;
    iconFileGuid?: string | null;
    assetProfileId?: number;
    assetProfile?: string | null;
    createdDate!: Date;
    createdByUserId!: number;
    updatedByUserId!: number;
    updatedDate!: Date;
    createdByUser?: string | null;
    updatedByUser?: string | null;

    constructor(data?: IAssetClassV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetClassId = _data["assetClassId"] !== undefined ? _data["assetClassId"] : <any>null;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : <any>null;
            this.assetClass = _data["assetClass"] !== undefined ? _data["assetClass"] : <any>null;
            this.inspectionFormId = _data["inspectionFormId"] !== undefined ? _data["inspectionFormId"] : <any>null;
            this.inspectionForm = _data["inspectionForm"] !== undefined ? _data["inspectionForm"] : <any>null;
            this.suggestedRepairFormId = _data["suggestedRepairFormId"] !== undefined ? _data["suggestedRepairFormId"] : <any>null;
            this.suggestedRepairForm = _data["suggestedRepairForm"] !== undefined ? _data["suggestedRepairForm"] : <any>null;
            this.repairFormId = _data["repairFormId"] !== undefined ? _data["repairFormId"] : <any>null;
            this.repairForm = _data["repairForm"] !== undefined ? _data["repairForm"] : <any>null;
            this.iconId = _data["iconId"] !== undefined ? _data["iconId"] : <any>null;
            this.iconFileGuid = _data["iconFileGuid"] !== undefined ? _data["iconFileGuid"] : <any>null;
            this.assetProfileId = _data["assetProfileId"] !== undefined ? _data["assetProfileId"] : <any>null;
            this.assetProfile = _data["assetProfile"] !== undefined ? _data["assetProfile"] : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.createdByUserId = _data["createdByUserId"] !== undefined ? _data["createdByUserId"] : <any>null;
            this.updatedByUserId = _data["updatedByUserId"] !== undefined ? _data["updatedByUserId"] : <any>null;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>null;
            this.createdByUser = _data["createdByUser"] !== undefined ? _data["createdByUser"] : <any>null;
            this.updatedByUser = _data["updatedByUser"] !== undefined ? _data["updatedByUser"] : <any>null;
        }
    }

    static fromJS(data: any): AssetClassV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new AssetClassV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetClassId"] = this.assetClassId !== undefined ? this.assetClassId : <any>null;
        data["accountId"] = this.accountId !== undefined ? this.accountId : <any>null;
        data["assetClass"] = this.assetClass !== undefined ? this.assetClass : <any>null;
        data["inspectionFormId"] = this.inspectionFormId !== undefined ? this.inspectionFormId : <any>null;
        data["inspectionForm"] = this.inspectionForm !== undefined ? this.inspectionForm : <any>null;
        data["suggestedRepairFormId"] = this.suggestedRepairFormId !== undefined ? this.suggestedRepairFormId : <any>null;
        data["suggestedRepairForm"] = this.suggestedRepairForm !== undefined ? this.suggestedRepairForm : <any>null;
        data["repairFormId"] = this.repairFormId !== undefined ? this.repairFormId : <any>null;
        data["repairForm"] = this.repairForm !== undefined ? this.repairForm : <any>null;
        data["iconId"] = this.iconId !== undefined ? this.iconId : <any>null;
        data["iconFileGuid"] = this.iconFileGuid !== undefined ? this.iconFileGuid : <any>null;
        data["assetProfileId"] = this.assetProfileId !== undefined ? this.assetProfileId : <any>null;
        data["assetProfile"] = this.assetProfile !== undefined ? this.assetProfile : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["createdByUserId"] = this.createdByUserId !== undefined ? this.createdByUserId : <any>null;
        data["updatedByUserId"] = this.updatedByUserId !== undefined ? this.updatedByUserId : <any>null;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>null;
        data["createdByUser"] = this.createdByUser !== undefined ? this.createdByUser : <any>null;
        data["updatedByUser"] = this.updatedByUser !== undefined ? this.updatedByUser : <any>null;
        return data;
    }
}

export interface IAssetClassV1Model {
    assetClassId: number;
    accountId?: number;
    assetClass?: string | null;
    inspectionFormId?: number;
    inspectionForm?: string | null;
    suggestedRepairFormId?: number;
    suggestedRepairForm?: string | null;
    repairFormId?: number;
    repairForm?: string | null;
    iconId?: number | null;
    iconFileGuid?: string | null;
    assetProfileId?: number;
    assetProfile?: string | null;
    createdDate: Date;
    createdByUserId: number;
    updatedByUserId: number;
    updatedDate: Date;
    createdByUser?: string | null;
    updatedByUser?: string | null;
}

export class AssetProfileTypeV1Model implements IAssetProfileTypeV1Model {
    assetProfileTypeId!: number;
    assetProfileId!: number;
    assetProfileType!: string;
    shortName?: string | null;
    createdByUserId!: number;
    createdByUserName!: string;
    createdDate!: Date;
    updatedByUserId!: number;
    updatedByUserName!: string;
    updatedDate!: Date;

    constructor(data?: IAssetProfileTypeV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetProfileTypeId = _data["assetProfileTypeId"] !== undefined ? _data["assetProfileTypeId"] : <any>null;
            this.assetProfileId = _data["assetProfileId"] !== undefined ? _data["assetProfileId"] : <any>null;
            this.assetProfileType = _data["assetProfileType"] !== undefined ? _data["assetProfileType"] : <any>null;
            this.shortName = _data["shortName"] !== undefined ? _data["shortName"] : <any>null;
            this.createdByUserId = _data["createdByUserId"] !== undefined ? _data["createdByUserId"] : <any>null;
            this.createdByUserName = _data["createdByUserName"] !== undefined ? _data["createdByUserName"] : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.updatedByUserId = _data["updatedByUserId"] !== undefined ? _data["updatedByUserId"] : <any>null;
            this.updatedByUserName = _data["updatedByUserName"] !== undefined ? _data["updatedByUserName"] : <any>null;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): AssetProfileTypeV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new AssetProfileTypeV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetProfileTypeId"] = this.assetProfileTypeId !== undefined ? this.assetProfileTypeId : <any>null;
        data["assetProfileId"] = this.assetProfileId !== undefined ? this.assetProfileId : <any>null;
        data["assetProfileType"] = this.assetProfileType !== undefined ? this.assetProfileType : <any>null;
        data["shortName"] = this.shortName !== undefined ? this.shortName : <any>null;
        data["createdByUserId"] = this.createdByUserId !== undefined ? this.createdByUserId : <any>null;
        data["createdByUserName"] = this.createdByUserName !== undefined ? this.createdByUserName : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["updatedByUserId"] = this.updatedByUserId !== undefined ? this.updatedByUserId : <any>null;
        data["updatedByUserName"] = this.updatedByUserName !== undefined ? this.updatedByUserName : <any>null;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>null;
        return data;
    }
}

export interface IAssetProfileTypeV1Model {
    assetProfileTypeId: number;
    assetProfileId: number;
    assetProfileType: string;
    shortName?: string | null;
    createdByUserId: number;
    createdByUserName: string;
    createdDate: Date;
    updatedByUserId: number;
    updatedByUserName: string;
    updatedDate: Date;
}

export class AssetProfileV1Model implements IAssetProfileV1Model {
    assetProfileId!: number;
    assetProfile!: string;

    constructor(data?: IAssetProfileV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetProfileId = _data["assetProfileId"] !== undefined ? _data["assetProfileId"] : <any>null;
            this.assetProfile = _data["assetProfile"] !== undefined ? _data["assetProfile"] : <any>null;
        }
    }

    static fromJS(data: any): AssetProfileV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new AssetProfileV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetProfileId"] = this.assetProfileId !== undefined ? this.assetProfileId : <any>null;
        data["assetProfile"] = this.assetProfile !== undefined ? this.assetProfile : <any>null;
        return data;
    }
}

export interface IAssetProfileV1Model {
    assetProfileId: number;
    assetProfile: string;
}

export class AssetWarrantyV1Model extends FileV1Model implements IAssetWarrantyV1Model {
    assetWarrantyId?: number;
    assetId?: number;
    createdByUserId?: number;
    createdByUser?: string | null;
    updatedByUserId?: number;
    updatedByUser?: string | null;
    createdDate?: Date;
    updatedDate?: Date;

    constructor(data?: IAssetWarrantyV1Model) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.assetWarrantyId = _data["assetWarrantyId"] !== undefined ? _data["assetWarrantyId"] : <any>null;
            this.assetId = _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
            this.createdByUserId = _data["createdByUserId"] !== undefined ? _data["createdByUserId"] : <any>null;
            this.createdByUser = _data["createdByUser"] !== undefined ? _data["createdByUser"] : <any>null;
            this.updatedByUserId = _data["updatedByUserId"] !== undefined ? _data["updatedByUserId"] : <any>null;
            this.updatedByUser = _data["updatedByUser"] !== undefined ? _data["updatedByUser"] : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>null;
        }
    }

    static override fromJS(data: any): AssetWarrantyV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new AssetWarrantyV1Model();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetWarrantyId"] = this.assetWarrantyId !== undefined ? this.assetWarrantyId : <any>null;
        data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
        data["createdByUserId"] = this.createdByUserId !== undefined ? this.createdByUserId : <any>null;
        data["createdByUser"] = this.createdByUser !== undefined ? this.createdByUser : <any>null;
        data["updatedByUserId"] = this.updatedByUserId !== undefined ? this.updatedByUserId : <any>null;
        data["updatedByUser"] = this.updatedByUser !== undefined ? this.updatedByUser : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAssetWarrantyV1Model extends IFileV1Model {
    assetWarrantyId?: number;
    assetId?: number;
    createdByUserId?: number;
    createdByUser?: string | null;
    updatedByUserId?: number;
    updatedByUser?: string | null;
    createdDate?: Date;
    updatedDate?: Date;
}

export class AssetDrawingV1Model extends FileV1Model implements IAssetDrawingV1Model {
    assetDrawingId?: number;
    assetId?: number;
    createdByUserId?: number;
    createdByUser?: string | null;
    updatedByUserId?: number;
    updatedByUser?: string | null;
    createdDate?: Date;
    updatedDate?: Date;

    constructor(data?: IAssetDrawingV1Model) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.assetDrawingId = _data["assetDrawingId"] !== undefined ? _data["assetDrawingId"] : <any>null;
            this.assetId = _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
            this.createdByUserId = _data["createdByUserId"] !== undefined ? _data["createdByUserId"] : <any>null;
            this.createdByUser = _data["createdByUser"] !== undefined ? _data["createdByUser"] : <any>null;
            this.updatedByUserId = _data["updatedByUserId"] !== undefined ? _data["updatedByUserId"] : <any>null;
            this.updatedByUser = _data["updatedByUser"] !== undefined ? _data["updatedByUser"] : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>null;
        }
    }

    static override fromJS(data: any): AssetDrawingV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new AssetDrawingV1Model();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetDrawingId"] = this.assetDrawingId !== undefined ? this.assetDrawingId : <any>null;
        data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
        data["createdByUserId"] = this.createdByUserId !== undefined ? this.createdByUserId : <any>null;
        data["createdByUser"] = this.createdByUser !== undefined ? this.createdByUser : <any>null;
        data["updatedByUserId"] = this.updatedByUserId !== undefined ? this.updatedByUserId : <any>null;
        data["updatedByUser"] = this.updatedByUser !== undefined ? this.updatedByUser : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAssetDrawingV1Model extends IFileV1Model {
    assetDrawingId?: number;
    assetId?: number;
    createdByUserId?: number;
    createdByUser?: string | null;
    updatedByUserId?: number;
    updatedByUser?: string | null;
    createdDate?: Date;
    updatedDate?: Date;
}

export class OfflineSchemaSyncV1Model implements IOfflineSchemaSyncV1Model {
    tables?: OfflineSchemaTableV1Model[] | null;

    constructor(data?: IOfflineSchemaSyncV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["tables"])) {
                this.tables = [] as any;
                for (let item of _data["tables"])
                    this.tables!.push(OfflineSchemaTableV1Model.fromJS(item));
            }
            else {
                this.tables = <any>null;
            }
        }
    }

    static fromJS(data: any): OfflineSchemaSyncV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new OfflineSchemaSyncV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.tables)) {
            data["tables"] = [];
            for (let item of this.tables)
                data["tables"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOfflineSchemaSyncV1Model {
    tables?: OfflineSchemaTableV1Model[] | null;
}

export class OfflineSchemaTableV1Model implements IOfflineSchemaTableV1Model {
    tableName?: string | null;
    columns?: OfflineSchemaColumnV1Model[] | null;

    constructor(data?: IOfflineSchemaTableV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.tableName = _data["tableName"] !== undefined ? _data["tableName"] : <any>null;
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(OfflineSchemaColumnV1Model.fromJS(item));
            }
            else {
                this.columns = <any>null;
            }
        }
    }

    static fromJS(data: any): OfflineSchemaTableV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new OfflineSchemaTableV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["tableName"] = this.tableName !== undefined ? this.tableName : <any>null;
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        return data;
    }
}

export interface IOfflineSchemaTableV1Model {
    tableName?: string | null;
    columns?: OfflineSchemaColumnV1Model[] | null;
}

export class OfflineSchemaColumnV1Model implements IOfflineSchemaColumnV1Model {
    name?: string | null;
    type?: string | null;

    constructor(data?: IOfflineSchemaColumnV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
        }
    }

    static fromJS(data: any): OfflineSchemaColumnV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new OfflineSchemaColumnV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        return data;
    }
}

export interface IOfflineSchemaColumnV1Model {
    name?: string | null;
    type?: string | null;
}

export class IconV1Model implements IIconV1Model {
    iconId?: number;
    fileGuid?: string | null;
    fileName?: string | null;
    accountId?: number;
    name?: string | null;
    createdDate?: Date;
    createdByUserId?: number;
    createdByUserName?: string | null;
    updatedDate?: Date;
    updatedByUserId?: number;

    constructor(data?: IIconV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iconId = _data["iconId"] !== undefined ? _data["iconId"] : <any>null;
            this.fileGuid = _data["fileGuid"] !== undefined ? _data["fileGuid"] : <any>null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.createdByUserId = _data["createdByUserId"] !== undefined ? _data["createdByUserId"] : <any>null;
            this.createdByUserName = _data["createdByUserName"] !== undefined ? _data["createdByUserName"] : <any>null;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>null;
            this.updatedByUserId = _data["updatedByUserId"] !== undefined ? _data["updatedByUserId"] : <any>null;
        }
    }

    static fromJS(data: any): IconV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new IconV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iconId"] = this.iconId !== undefined ? this.iconId : <any>null;
        data["fileGuid"] = this.fileGuid !== undefined ? this.fileGuid : <any>null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        data["accountId"] = this.accountId !== undefined ? this.accountId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["createdByUserId"] = this.createdByUserId !== undefined ? this.createdByUserId : <any>null;
        data["createdByUserName"] = this.createdByUserName !== undefined ? this.createdByUserName : <any>null;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>null;
        data["updatedByUserId"] = this.updatedByUserId !== undefined ? this.updatedByUserId : <any>null;
        return data;
    }
}

export interface IIconV1Model {
    iconId?: number;
    fileGuid?: string | null;
    fileName?: string | null;
    accountId?: number;
    name?: string | null;
    createdDate?: Date;
    createdByUserId?: number;
    createdByUserName?: string | null;
    updatedDate?: Date;
    updatedByUserId?: number;
}

export class BaseSearchV1 implements IBaseSearchV1 {
    pageNumber?: number;
    pageSize?: number;
    sortField?: string | null;
    sortDirection?: string | null;

    constructor(data?: IBaseSearchV1) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pageNumber = _data["pageNumber"] !== undefined ? _data["pageNumber"] : <any>null;
            this.pageSize = _data["pageSize"] !== undefined ? _data["pageSize"] : <any>null;
            this.sortField = _data["sortField"] !== undefined ? _data["sortField"] : <any>null;
            this.sortDirection = _data["sortDirection"] !== undefined ? _data["sortDirection"] : <any>null;
        }
    }

    static fromJS(data: any): BaseSearchV1 {
        data = typeof data === 'object' ? data : {};
        let result = new BaseSearchV1();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pageNumber"] = this.pageNumber !== undefined ? this.pageNumber : <any>null;
        data["pageSize"] = this.pageSize !== undefined ? this.pageSize : <any>null;
        data["sortField"] = this.sortField !== undefined ? this.sortField : <any>null;
        data["sortDirection"] = this.sortDirection !== undefined ? this.sortDirection : <any>null;
        return data;
    }
}

export interface IBaseSearchV1 {
    pageNumber?: number;
    pageSize?: number;
    sortField?: string | null;
    sortDirection?: string | null;
}

export class IconSearchV1Model extends BaseSearchV1 implements IIconSearchV1Model {
    searchTerm?: string | null;

    constructor(data?: IIconSearchV1Model) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.searchTerm = _data["searchTerm"] !== undefined ? _data["searchTerm"] : <any>null;
        }
    }

    static override fromJS(data: any): IconSearchV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new IconSearchV1Model();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchTerm"] = this.searchTerm !== undefined ? this.searchTerm : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IIconSearchV1Model extends IBaseSearchV1 {
    searchTerm?: string | null;
}

export class IconUploadV1Model implements IIconUploadV1Model {
    name?: string | null;
    fileBase64?: string | null;
    fileName?: string | null;
    iconId?: number | null;
    fileGuid?: string | null;

    constructor(data?: IIconUploadV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.fileBase64 = _data["fileBase64"] !== undefined ? _data["fileBase64"] : <any>null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
            this.iconId = _data["iconId"] !== undefined ? _data["iconId"] : <any>null;
            this.fileGuid = _data["fileGuid"] !== undefined ? _data["fileGuid"] : <any>null;
        }
    }

    static fromJS(data: any): IconUploadV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new IconUploadV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["fileBase64"] = this.fileBase64 !== undefined ? this.fileBase64 : <any>null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        data["iconId"] = this.iconId !== undefined ? this.iconId : <any>null;
        data["fileGuid"] = this.fileGuid !== undefined ? this.fileGuid : <any>null;
        return data;
    }
}

export interface IIconUploadV1Model {
    name?: string | null;
    fileBase64?: string | null;
    fileName?: string | null;
    iconId?: number | null;
    fileGuid?: string | null;
}

export class IconUpdateV1Model implements IIconUpdateV1Model {
    iconId!: number;
    name!: string;
    fileGuid!: string;
    fileName!: string;

    constructor(data?: IIconUpdateV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.iconId = _data["iconId"] !== undefined ? _data["iconId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.fileGuid = _data["fileGuid"] !== undefined ? _data["fileGuid"] : <any>null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
        }
    }

    static fromJS(data: any): IconUpdateV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new IconUpdateV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["iconId"] = this.iconId !== undefined ? this.iconId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["fileGuid"] = this.fileGuid !== undefined ? this.fileGuid : <any>null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        return data;
    }
}

export interface IIconUpdateV1Model {
    iconId: number;
    name: string;
    fileGuid: string;
    fileName: string;
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export class ODataValueOfIEnumerableOfIconV1Model implements IODataValueOfIEnumerableOfIconV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: IconV1Model[] | null;

    constructor(data?: IODataValueOfIEnumerableOfIconV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(IconV1Model.fromJS(item));
            }
            else {
                this.value = <any>null;
            }
        }
    }

    static fromJS(data: any): ODataValueOfIEnumerableOfIconV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new ODataValueOfIEnumerableOfIconV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export interface IODataValueOfIEnumerableOfIconV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: IconV1Model[] | null;
}

export class GridColumnV1Model implements IGridColumnV1Model {
    headerText?: string | null;
    visible?: boolean;
    showInColumnChooser?: boolean;
    field?: string | null;
    type?: string | null;
    format?: string | null;
    allowSearching?: boolean;
    isPrimary?: boolean;
    editType?: string | null;
    allowEditing?: boolean;
    clipMode?: string | null;
    template?: string | null;
    columnWidth?: number;
    headerTemplate?: string | null;

    constructor(data?: IGridColumnV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.headerText = _data["headerText"] !== undefined ? _data["headerText"] : <any>null;
            this.visible = _data["visible"] !== undefined ? _data["visible"] : <any>null;
            this.showInColumnChooser = _data["showInColumnChooser"] !== undefined ? _data["showInColumnChooser"] : <any>null;
            this.field = _data["field"] !== undefined ? _data["field"] : <any>null;
            this.type = _data["type"] !== undefined ? _data["type"] : <any>null;
            this.format = _data["format"] !== undefined ? _data["format"] : <any>null;
            this.allowSearching = _data["allowSearching"] !== undefined ? _data["allowSearching"] : <any>null;
            this.isPrimary = _data["isPrimary"] !== undefined ? _data["isPrimary"] : <any>null;
            this.editType = _data["editType"] !== undefined ? _data["editType"] : <any>null;
            this.allowEditing = _data["allowEditing"] !== undefined ? _data["allowEditing"] : <any>null;
            this.clipMode = _data["clipMode"] !== undefined ? _data["clipMode"] : <any>null;
            this.template = _data["template"] !== undefined ? _data["template"] : <any>null;
            this.columnWidth = _data["columnWidth"] !== undefined ? _data["columnWidth"] : <any>null;
            this.headerTemplate = _data["headerTemplate"] !== undefined ? _data["headerTemplate"] : <any>null;
        }
    }

    static fromJS(data: any): GridColumnV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new GridColumnV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["headerText"] = this.headerText !== undefined ? this.headerText : <any>null;
        data["visible"] = this.visible !== undefined ? this.visible : <any>null;
        data["showInColumnChooser"] = this.showInColumnChooser !== undefined ? this.showInColumnChooser : <any>null;
        data["field"] = this.field !== undefined ? this.field : <any>null;
        data["type"] = this.type !== undefined ? this.type : <any>null;
        data["format"] = this.format !== undefined ? this.format : <any>null;
        data["allowSearching"] = this.allowSearching !== undefined ? this.allowSearching : <any>null;
        data["isPrimary"] = this.isPrimary !== undefined ? this.isPrimary : <any>null;
        data["editType"] = this.editType !== undefined ? this.editType : <any>null;
        data["allowEditing"] = this.allowEditing !== undefined ? this.allowEditing : <any>null;
        data["clipMode"] = this.clipMode !== undefined ? this.clipMode : <any>null;
        data["template"] = this.template !== undefined ? this.template : <any>null;
        data["columnWidth"] = this.columnWidth !== undefined ? this.columnWidth : <any>null;
        data["headerTemplate"] = this.headerTemplate !== undefined ? this.headerTemplate : <any>null;
        return data;
    }
}

export interface IGridColumnV1Model {
    headerText?: string | null;
    visible?: boolean;
    showInColumnChooser?: boolean;
    field?: string | null;
    type?: string | null;
    format?: string | null;
    allowSearching?: boolean;
    isPrimary?: boolean;
    editType?: string | null;
    allowEditing?: boolean;
    clipMode?: string | null;
    template?: string | null;
    columnWidth?: number;
    headerTemplate?: string | null;
}

export class FormCategoryV1Model implements IFormCategoryV1Model {
    categoryId!: number;
    category!: string;
    categoryDeficiencyTypes!: FormCategoryDeficiencyTypeV1Model[];

    constructor(data?: IFormCategoryV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.categoryDeficiencyTypes = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.categoryId = _data["categoryId"] !== undefined ? _data["categoryId"] : <any>null;
            this.category = _data["category"] !== undefined ? _data["category"] : <any>null;
            if (Array.isArray(_data["categoryDeficiencyTypes"])) {
                this.categoryDeficiencyTypes = [] as any;
                for (let item of _data["categoryDeficiencyTypes"])
                    this.categoryDeficiencyTypes!.push(FormCategoryDeficiencyTypeV1Model.fromJS(item));
            }
            else {
                this.categoryDeficiencyTypes = <any>null;
            }
        }
    }

    static fromJS(data: any): FormCategoryV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new FormCategoryV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["categoryId"] = this.categoryId !== undefined ? this.categoryId : <any>null;
        data["category"] = this.category !== undefined ? this.category : <any>null;
        if (Array.isArray(this.categoryDeficiencyTypes)) {
            data["categoryDeficiencyTypes"] = [];
            for (let item of this.categoryDeficiencyTypes)
                data["categoryDeficiencyTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFormCategoryV1Model {
    categoryId: number;
    category: string;
    categoryDeficiencyTypes: FormCategoryDeficiencyTypeV1Model[];
}

export class FormCategoryDeficiencyTypeV1Model implements IFormCategoryDeficiencyTypeV1Model {
    defTypeId?: number;
    deficiencyType?: string | null;
    categoryDeficiencyFinds?: FormCategoryDeficiencyFoundV1Model[] | null;

    constructor(data?: IFormCategoryDeficiencyTypeV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.defTypeId = _data["defTypeId"] !== undefined ? _data["defTypeId"] : <any>null;
            this.deficiencyType = _data["deficiencyType"] !== undefined ? _data["deficiencyType"] : <any>null;
            if (Array.isArray(_data["categoryDeficiencyFinds"])) {
                this.categoryDeficiencyFinds = [] as any;
                for (let item of _data["categoryDeficiencyFinds"])
                    this.categoryDeficiencyFinds!.push(FormCategoryDeficiencyFoundV1Model.fromJS(item));
            }
            else {
                this.categoryDeficiencyFinds = <any>null;
            }
        }
    }

    static fromJS(data: any): FormCategoryDeficiencyTypeV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new FormCategoryDeficiencyTypeV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defTypeId"] = this.defTypeId !== undefined ? this.defTypeId : <any>null;
        data["deficiencyType"] = this.deficiencyType !== undefined ? this.deficiencyType : <any>null;
        if (Array.isArray(this.categoryDeficiencyFinds)) {
            data["categoryDeficiencyFinds"] = [];
            for (let item of this.categoryDeficiencyFinds)
                data["categoryDeficiencyFinds"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFormCategoryDeficiencyTypeV1Model {
    defTypeId?: number;
    deficiencyType?: string | null;
    categoryDeficiencyFinds?: FormCategoryDeficiencyFoundV1Model[] | null;
}

export class FormCategoryDeficiencyFoundV1Model implements IFormCategoryDeficiencyFoundV1Model {
    defFoundId!: number;
    deficiencyFound!: string;

    constructor(data?: IFormCategoryDeficiencyFoundV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.defFoundId = _data["defFoundId"] !== undefined ? _data["defFoundId"] : <any>null;
            this.deficiencyFound = _data["deficiencyFound"] !== undefined ? _data["deficiencyFound"] : <any>null;
        }
    }

    static fromJS(data: any): FormCategoryDeficiencyFoundV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new FormCategoryDeficiencyFoundV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["defFoundId"] = this.defFoundId !== undefined ? this.defFoundId : <any>null;
        data["deficiencyFound"] = this.deficiencyFound !== undefined ? this.deficiencyFound : <any>null;
        return data;
    }
}

export interface IFormCategoryDeficiencyFoundV1Model {
    defFoundId: number;
    deficiencyFound: string;
}

export class FormV1Model implements IFormV1Model {
    formId!: number;
    form?: string | null;
    rows!: FormRowV1Model[];

    constructor(data?: IFormV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.rows = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formId = _data["formId"] !== undefined ? _data["formId"] : <any>null;
            this.form = _data["form"] !== undefined ? _data["form"] : <any>null;
            if (Array.isArray(_data["rows"])) {
                this.rows = [] as any;
                for (let item of _data["rows"])
                    this.rows!.push(FormRowV1Model.fromJS(item));
            }
            else {
                this.rows = <any>null;
            }
        }
    }

    static fromJS(data: any): FormV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new FormV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId !== undefined ? this.formId : <any>null;
        data["form"] = this.form !== undefined ? this.form : <any>null;
        if (Array.isArray(this.rows)) {
            data["rows"] = [];
            for (let item of this.rows)
                data["rows"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFormV1Model {
    formId: number;
    form?: string | null;
    rows: FormRowV1Model[];
}

export class FormRowV1Model implements IFormRowV1Model {
    formRowId?: number;
    formId!: number;
    css?: string | null;
    columns!: FormColumnV1Model[];

    constructor(data?: IFormRowV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.columns = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formRowId = _data["formRowId"] !== undefined ? _data["formRowId"] : <any>null;
            this.formId = _data["formId"] !== undefined ? _data["formId"] : <any>null;
            this.css = _data["css"] !== undefined ? _data["css"] : <any>null;
            if (Array.isArray(_data["columns"])) {
                this.columns = [] as any;
                for (let item of _data["columns"])
                    this.columns!.push(FormColumnV1Model.fromJS(item));
            }
            else {
                this.columns = <any>null;
            }
        }
    }

    static fromJS(data: any): FormRowV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new FormRowV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formRowId"] = this.formRowId !== undefined ? this.formRowId : <any>null;
        data["formId"] = this.formId !== undefined ? this.formId : <any>null;
        data["css"] = this.css !== undefined ? this.css : <any>null;
        if (Array.isArray(this.columns)) {
            data["columns"] = [];
            for (let item of this.columns)
                data["columns"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFormRowV1Model {
    formRowId?: number;
    formId: number;
    css?: string | null;
    columns: FormColumnV1Model[];
}

export class FormColumnV1Model implements IFormColumnV1Model {
    formColumnId!: number;
    formRowId!: number;
    columnSpan!: string;
    css?: string | null;
    fields!: FormFieldV1Model[];

    constructor(data?: IFormColumnV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.fields = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formColumnId = _data["formColumnId"] !== undefined ? _data["formColumnId"] : <any>null;
            this.formRowId = _data["formRowId"] !== undefined ? _data["formRowId"] : <any>null;
            this.columnSpan = _data["columnSpan"] !== undefined ? _data["columnSpan"] : <any>null;
            this.css = _data["css"] !== undefined ? _data["css"] : <any>null;
            if (Array.isArray(_data["fields"])) {
                this.fields = [] as any;
                for (let item of _data["fields"])
                    this.fields!.push(FormFieldV1Model.fromJS(item));
            }
            else {
                this.fields = <any>null;
            }
        }
    }

    static fromJS(data: any): FormColumnV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new FormColumnV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formColumnId"] = this.formColumnId !== undefined ? this.formColumnId : <any>null;
        data["formRowId"] = this.formRowId !== undefined ? this.formRowId : <any>null;
        data["columnSpan"] = this.columnSpan !== undefined ? this.columnSpan : <any>null;
        data["css"] = this.css !== undefined ? this.css : <any>null;
        if (Array.isArray(this.fields)) {
            data["fields"] = [];
            for (let item of this.fields)
                data["fields"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFormColumnV1Model {
    formColumnId: number;
    formRowId: number;
    columnSpan: string;
    css?: string | null;
    fields: FormFieldV1Model[];
}

export class FormFieldV1Model implements IFormFieldV1Model {
    formFieldId!: number;
    formId!: number;
    formRowId?: number;
    formColumnId!: number;
    fieldTypeId!: number;
    fieldName?: string | null;
    label!: string;
    sortOrder!: number;
    css?: string | null;
    options!: FormFieldOptionV1Model[];
    values!: FormFieldValueV1Model[];

    constructor(data?: IFormFieldV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
        if (!data) {
            this.options = [];
            this.values = [];
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formFieldId = _data["formFieldId"] !== undefined ? _data["formFieldId"] : <any>null;
            this.formId = _data["formId"] !== undefined ? _data["formId"] : <any>null;
            this.formRowId = _data["formRowId"] !== undefined ? _data["formRowId"] : <any>null;
            this.formColumnId = _data["formColumnId"] !== undefined ? _data["formColumnId"] : <any>null;
            this.fieldTypeId = _data["fieldTypeId"] !== undefined ? _data["fieldTypeId"] : <any>null;
            this.fieldName = _data["fieldName"] !== undefined ? _data["fieldName"] : <any>null;
            this.label = _data["label"] !== undefined ? _data["label"] : <any>null;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : <any>null;
            this.css = _data["css"] !== undefined ? _data["css"] : <any>null;
            if (Array.isArray(_data["options"])) {
                this.options = [] as any;
                for (let item of _data["options"])
                    this.options!.push(FormFieldOptionV1Model.fromJS(item));
            }
            else {
                this.options = <any>null;
            }
            if (Array.isArray(_data["values"])) {
                this.values = [] as any;
                for (let item of _data["values"])
                    this.values!.push(FormFieldValueV1Model.fromJS(item));
            }
            else {
                this.values = <any>null;
            }
        }
    }

    static fromJS(data: any): FormFieldV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new FormFieldV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formFieldId"] = this.formFieldId !== undefined ? this.formFieldId : <any>null;
        data["formId"] = this.formId !== undefined ? this.formId : <any>null;
        data["formRowId"] = this.formRowId !== undefined ? this.formRowId : <any>null;
        data["formColumnId"] = this.formColumnId !== undefined ? this.formColumnId : <any>null;
        data["fieldTypeId"] = this.fieldTypeId !== undefined ? this.fieldTypeId : <any>null;
        data["fieldName"] = this.fieldName !== undefined ? this.fieldName : <any>null;
        data["label"] = this.label !== undefined ? this.label : <any>null;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : <any>null;
        data["css"] = this.css !== undefined ? this.css : <any>null;
        if (Array.isArray(this.options)) {
            data["options"] = [];
            for (let item of this.options)
                data["options"].push(item.toJSON());
        }
        if (Array.isArray(this.values)) {
            data["values"] = [];
            for (let item of this.values)
                data["values"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFormFieldV1Model {
    formFieldId: number;
    formId: number;
    formRowId?: number;
    formColumnId: number;
    fieldTypeId: number;
    fieldName?: string | null;
    label: string;
    sortOrder: number;
    css?: string | null;
    options: FormFieldOptionV1Model[];
    values: FormFieldValueV1Model[];
}

export class FormFieldOptionV1Model implements IFormFieldOptionV1Model {
    formFieldOptionId!: number;
    formFieldId!: number;
    optionValue!: string;

    constructor(data?: IFormFieldOptionV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formFieldOptionId = _data["formFieldOptionId"] !== undefined ? _data["formFieldOptionId"] : <any>null;
            this.formFieldId = _data["formFieldId"] !== undefined ? _data["formFieldId"] : <any>null;
            this.optionValue = _data["optionValue"] !== undefined ? _data["optionValue"] : <any>null;
        }
    }

    static fromJS(data: any): FormFieldOptionV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new FormFieldOptionV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formFieldOptionId"] = this.formFieldOptionId !== undefined ? this.formFieldOptionId : <any>null;
        data["formFieldId"] = this.formFieldId !== undefined ? this.formFieldId : <any>null;
        data["optionValue"] = this.optionValue !== undefined ? this.optionValue : <any>null;
        return data;
    }
}

export interface IFormFieldOptionV1Model {
    formFieldOptionId: number;
    formFieldId: number;
    optionValue: string;
}

export class FormFieldValueV1Model implements IFormFieldValueV1Model {
    formFieldValueId?: number;
    formFieldId?: number;
    workOrderId?: number;
    fieldTypeId?: number;
    fieldName?: string | null;
    value?: string | null;

    constructor(data?: IFormFieldValueV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formFieldValueId = _data["formFieldValueId"] !== undefined ? _data["formFieldValueId"] : <any>null;
            this.formFieldId = _data["formFieldId"] !== undefined ? _data["formFieldId"] : <any>null;
            this.workOrderId = _data["workOrderId"] !== undefined ? _data["workOrderId"] : <any>null;
            this.fieldTypeId = _data["fieldTypeId"] !== undefined ? _data["fieldTypeId"] : <any>null;
            this.fieldName = _data["fieldName"] !== undefined ? _data["fieldName"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
        }
    }

    static fromJS(data: any): FormFieldValueV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new FormFieldValueV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formFieldValueId"] = this.formFieldValueId !== undefined ? this.formFieldValueId : <any>null;
        data["formFieldId"] = this.formFieldId !== undefined ? this.formFieldId : <any>null;
        data["workOrderId"] = this.workOrderId !== undefined ? this.workOrderId : <any>null;
        data["fieldTypeId"] = this.fieldTypeId !== undefined ? this.fieldTypeId : <any>null;
        data["fieldName"] = this.fieldName !== undefined ? this.fieldName : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        return data;
    }
}

export interface IFormFieldValueV1Model {
    formFieldValueId?: number;
    formFieldId?: number;
    workOrderId?: number;
    fieldTypeId?: number;
    fieldName?: string | null;
    value?: string | null;
}

export class FormFieldRuleV1Model implements IFormFieldRuleV1Model {
    formFieldRuleId!: number;
    targetFormFieldId!: number;
    validatedFormFieldId!: number;
    value!: string;
    ruleTypeId!: number;
    createdByUserId!: number;
    createdByUser?: string | null;
    createdDate!: Date;
    updatedByUserId!: number;
    updatedByUser?: string | null;
    updatedDate!: Date;

    constructor(data?: IFormFieldRuleV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formFieldRuleId = _data["formFieldRuleId"] !== undefined ? _data["formFieldRuleId"] : <any>null;
            this.targetFormFieldId = _data["targetFormFieldId"] !== undefined ? _data["targetFormFieldId"] : <any>null;
            this.validatedFormFieldId = _data["validatedFormFieldId"] !== undefined ? _data["validatedFormFieldId"] : <any>null;
            this.value = _data["value"] !== undefined ? _data["value"] : <any>null;
            this.ruleTypeId = _data["ruleTypeId"] !== undefined ? _data["ruleTypeId"] : <any>null;
            this.createdByUserId = _data["createdByUserId"] !== undefined ? _data["createdByUserId"] : <any>null;
            this.createdByUser = _data["createdByUser"] !== undefined ? _data["createdByUser"] : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.updatedByUserId = _data["updatedByUserId"] !== undefined ? _data["updatedByUserId"] : <any>null;
            this.updatedByUser = _data["updatedByUser"] !== undefined ? _data["updatedByUser"] : <any>null;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): FormFieldRuleV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new FormFieldRuleV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formFieldRuleId"] = this.formFieldRuleId !== undefined ? this.formFieldRuleId : <any>null;
        data["targetFormFieldId"] = this.targetFormFieldId !== undefined ? this.targetFormFieldId : <any>null;
        data["validatedFormFieldId"] = this.validatedFormFieldId !== undefined ? this.validatedFormFieldId : <any>null;
        data["value"] = this.value !== undefined ? this.value : <any>null;
        data["ruleTypeId"] = this.ruleTypeId !== undefined ? this.ruleTypeId : <any>null;
        data["createdByUserId"] = this.createdByUserId !== undefined ? this.createdByUserId : <any>null;
        data["createdByUser"] = this.createdByUser !== undefined ? this.createdByUser : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["updatedByUserId"] = this.updatedByUserId !== undefined ? this.updatedByUserId : <any>null;
        data["updatedByUser"] = this.updatedByUser !== undefined ? this.updatedByUser : <any>null;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>null;
        return data;
    }
}

export interface IFormFieldRuleV1Model {
    formFieldRuleId: number;
    targetFormFieldId: number;
    validatedFormFieldId: number;
    value: string;
    ruleTypeId: number;
    createdByUserId: number;
    createdByUser?: string | null;
    createdDate: Date;
    updatedByUserId: number;
    updatedByUser?: string | null;
    updatedDate: Date;
}

export class FormUpdateV1Model implements IFormUpdateV1Model {
    formId?: number;
    workOrderId?: number;
    formFieldsWithValues?: any | null;
    createSuggestedRepair?: boolean | null;
    workOrderStatusId?: number | null;

    constructor(data?: IFormUpdateV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.formId = _data["formId"] !== undefined ? _data["formId"] : <any>null;
            this.workOrderId = _data["workOrderId"] !== undefined ? _data["workOrderId"] : <any>null;
            this.formFieldsWithValues = _data["formFieldsWithValues"] !== undefined ? _data["formFieldsWithValues"] : <any>null;
            this.createSuggestedRepair = _data["createSuggestedRepair"] !== undefined ? _data["createSuggestedRepair"] : <any>null;
            this.workOrderStatusId = _data["workOrderStatusId"] !== undefined ? _data["workOrderStatusId"] : <any>null;
        }
    }

    static fromJS(data: any): FormUpdateV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new FormUpdateV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formId"] = this.formId !== undefined ? this.formId : <any>null;
        data["workOrderId"] = this.workOrderId !== undefined ? this.workOrderId : <any>null;
        data["formFieldsWithValues"] = this.formFieldsWithValues !== undefined ? this.formFieldsWithValues : <any>null;
        data["createSuggestedRepair"] = this.createSuggestedRepair !== undefined ? this.createSuggestedRepair : <any>null;
        data["workOrderStatusId"] = this.workOrderStatusId !== undefined ? this.workOrderStatusId : <any>null;
        return data;
    }
}

export interface IFormUpdateV1Model {
    formId?: number;
    workOrderId?: number;
    formFieldsWithValues?: any | null;
    createSuggestedRepair?: boolean | null;
    workOrderStatusId?: number | null;
}

export class FormUpdateAssetV1Model implements IFormUpdateAssetV1Model {
    assetId?: number;
    assetProfileValues?: any | null;
    newCorrespondingAssets?: string[] | null;

    constructor(data?: IFormUpdateAssetV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetId = _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
            this.assetProfileValues = _data["assetProfileValues"] !== undefined ? _data["assetProfileValues"] : <any>null;
            if (Array.isArray(_data["newCorrespondingAssets"])) {
                this.newCorrespondingAssets = [] as any;
                for (let item of _data["newCorrespondingAssets"])
                    this.newCorrespondingAssets!.push(item);
            }
            else {
                this.newCorrespondingAssets = <any>null;
            }
        }
    }

    static fromJS(data: any): FormUpdateAssetV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new FormUpdateAssetV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
        data["assetProfileValues"] = this.assetProfileValues !== undefined ? this.assetProfileValues : <any>null;
        if (Array.isArray(this.newCorrespondingAssets)) {
            data["newCorrespondingAssets"] = [];
            for (let item of this.newCorrespondingAssets)
                data["newCorrespondingAssets"].push(item);
        }
        return data;
    }
}

export interface IFormUpdateAssetV1Model {
    assetId?: number;
    assetProfileValues?: any | null;
    newCorrespondingAssets?: string[] | null;
}

export class FormFieldFileV1Model extends FileV1Model implements IFormFieldFileV1Model {
    formFieldId?: number;
    workOrderId?: number;

    constructor(data?: IFormFieldFileV1Model) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.formFieldId = _data["formFieldId"] !== undefined ? _data["formFieldId"] : <any>null;
            this.workOrderId = _data["workOrderId"] !== undefined ? _data["workOrderId"] : <any>null;
        }
    }

    static override fromJS(data: any): FormFieldFileV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new FormFieldFileV1Model();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["formFieldId"] = this.formFieldId !== undefined ? this.formFieldId : <any>null;
        data["workOrderId"] = this.workOrderId !== undefined ? this.workOrderId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IFormFieldFileV1Model extends IFileV1Model {
    formFieldId?: number;
    workOrderId?: number;
}

export class FloorSearchV1Model extends BaseSearchV1 implements IFloorSearchV1Model {
    searchTerm?: string | null;
    facilityId?: number;

    constructor(data?: IFloorSearchV1Model) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.searchTerm = _data["searchTerm"] !== undefined ? _data["searchTerm"] : <any>null;
            this.facilityId = _data["facilityId"] !== undefined ? _data["facilityId"] : <any>null;
        }
    }

    static override fromJS(data: any): FloorSearchV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new FloorSearchV1Model();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchTerm"] = this.searchTerm !== undefined ? this.searchTerm : <any>null;
        data["facilityId"] = this.facilityId !== undefined ? this.facilityId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IFloorSearchV1Model extends IBaseSearchV1 {
    searchTerm?: string | null;
    facilityId?: number;
}

export class FloorInsertV1Model implements IFloorInsertV1Model {
    facilityId!: number;
    floor!: string;
    shortName?: string | null;
    fileBase64?: string | null;
    fileName?: string | null;
    fileGuid?: string | null;

    constructor(data?: IFloorInsertV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.facilityId = _data["facilityId"] !== undefined ? _data["facilityId"] : <any>null;
            this.floor = _data["floor"] !== undefined ? _data["floor"] : <any>null;
            this.shortName = _data["shortName"] !== undefined ? _data["shortName"] : <any>null;
            this.fileBase64 = _data["fileBase64"] !== undefined ? _data["fileBase64"] : <any>null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
            this.fileGuid = _data["fileGuid"] !== undefined ? _data["fileGuid"] : <any>null;
        }
    }

    static fromJS(data: any): FloorInsertV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new FloorInsertV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facilityId"] = this.facilityId !== undefined ? this.facilityId : <any>null;
        data["floor"] = this.floor !== undefined ? this.floor : <any>null;
        data["shortName"] = this.shortName !== undefined ? this.shortName : <any>null;
        data["fileBase64"] = this.fileBase64 !== undefined ? this.fileBase64 : <any>null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        data["fileGuid"] = this.fileGuid !== undefined ? this.fileGuid : <any>null;
        return data;
    }
}

export interface IFloorInsertV1Model {
    facilityId: number;
    floor: string;
    shortName?: string | null;
    fileBase64?: string | null;
    fileName?: string | null;
    fileGuid?: string | null;
}

export class FloorUpdateV1Model implements IFloorUpdateV1Model {
    floorId!: number;
    facilityId!: number;
    floor!: string;
    shortName?: string | null;

    constructor(data?: IFloorUpdateV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.floorId = _data["floorId"] !== undefined ? _data["floorId"] : <any>null;
            this.facilityId = _data["facilityId"] !== undefined ? _data["facilityId"] : <any>null;
            this.floor = _data["floor"] !== undefined ? _data["floor"] : <any>null;
            this.shortName = _data["shortName"] !== undefined ? _data["shortName"] : <any>null;
        }
    }

    static fromJS(data: any): FloorUpdateV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new FloorUpdateV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["floorId"] = this.floorId !== undefined ? this.floorId : <any>null;
        data["facilityId"] = this.facilityId !== undefined ? this.facilityId : <any>null;
        data["floor"] = this.floor !== undefined ? this.floor : <any>null;
        data["shortName"] = this.shortName !== undefined ? this.shortName : <any>null;
        return data;
    }
}

export interface IFloorUpdateV1Model {
    floorId: number;
    facilityId: number;
    floor: string;
    shortName?: string | null;
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export class ODataValueOfIEnumerableOfFloorV1Model implements IODataValueOfIEnumerableOfFloorV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: FloorV1Model[] | null;

    constructor(data?: IODataValueOfIEnumerableOfFloorV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(FloorV1Model.fromJS(item));
            }
            else {
                this.value = <any>null;
            }
        }
    }

    static fromJS(data: any): ODataValueOfIEnumerableOfFloorV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new ODataValueOfIEnumerableOfFloorV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export interface IODataValueOfIEnumerableOfFloorV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: FloorV1Model[] | null;
}

export class FacilityMapInfoV1Model implements IFacilityMapInfoV1Model {
    facilities?: FacilityV1Model[] | null;
    mapMarkers?: CustomMapMarkerV1Model[] | null;

    constructor(data?: IFacilityMapInfoV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["facilities"])) {
                this.facilities = [] as any;
                for (let item of _data["facilities"])
                    this.facilities!.push(FacilityV1Model.fromJS(item));
            }
            else {
                this.facilities = <any>null;
            }
            if (Array.isArray(_data["mapMarkers"])) {
                this.mapMarkers = [] as any;
                for (let item of _data["mapMarkers"])
                    this.mapMarkers!.push(CustomMapMarkerV1Model.fromJS(item));
            }
            else {
                this.mapMarkers = <any>null;
            }
        }
    }

    static fromJS(data: any): FacilityMapInfoV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new FacilityMapInfoV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.facilities)) {
            data["facilities"] = [];
            for (let item of this.facilities)
                data["facilities"].push(item.toJSON());
        }
        if (Array.isArray(this.mapMarkers)) {
            data["mapMarkers"] = [];
            for (let item of this.mapMarkers)
                data["mapMarkers"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFacilityMapInfoV1Model {
    facilities?: FacilityV1Model[] | null;
    mapMarkers?: CustomMapMarkerV1Model[] | null;
}

export class CustomMapMarkerV1Model implements ICustomMapMarkerV1Model {
    latitude?: number;
    longitude?: number;
    title?: string | null;
    itemId?: number;
    address?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    country?: string | null;
    defaultFacilityIconFileGuid?: string | null;

    constructor(data?: ICustomMapMarkerV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : <any>null;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : <any>null;
            this.title = _data["title"] !== undefined ? _data["title"] : <any>null;
            this.itemId = _data["itemId"] !== undefined ? _data["itemId"] : <any>null;
            this.address = _data["address"] !== undefined ? _data["address"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.defaultFacilityIconFileGuid = _data["defaultFacilityIconFileGuid"] !== undefined ? _data["defaultFacilityIconFileGuid"] : <any>null;
        }
    }

    static fromJS(data: any): CustomMapMarkerV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new CustomMapMarkerV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["latitude"] = this.latitude !== undefined ? this.latitude : <any>null;
        data["longitude"] = this.longitude !== undefined ? this.longitude : <any>null;
        data["title"] = this.title !== undefined ? this.title : <any>null;
        data["itemId"] = this.itemId !== undefined ? this.itemId : <any>null;
        data["address"] = this.address !== undefined ? this.address : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["zip"] = this.zip !== undefined ? this.zip : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["defaultFacilityIconFileGuid"] = this.defaultFacilityIconFileGuid !== undefined ? this.defaultFacilityIconFileGuid : <any>null;
        return data;
    }
}

export interface ICustomMapMarkerV1Model {
    latitude?: number;
    longitude?: number;
    title?: string | null;
    itemId?: number;
    address?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    country?: string | null;
    defaultFacilityIconFileGuid?: string | null;
}

export class FacilitySearchV1Model extends BaseSearchV1 implements IFacilitySearchV1Model {
    searchTerm?: string | null;
    campusId?: number | null;
    facilityTypeIds?: number[] | null;

    constructor(data?: IFacilitySearchV1Model) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.searchTerm = _data["searchTerm"] !== undefined ? _data["searchTerm"] : <any>null;
            this.campusId = _data["campusId"] !== undefined ? _data["campusId"] : <any>null;
            if (Array.isArray(_data["facilityTypeIds"])) {
                this.facilityTypeIds = [] as any;
                for (let item of _data["facilityTypeIds"])
                    this.facilityTypeIds!.push(item);
            }
            else {
                this.facilityTypeIds = <any>null;
            }
        }
    }

    static override fromJS(data: any): FacilitySearchV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new FacilitySearchV1Model();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchTerm"] = this.searchTerm !== undefined ? this.searchTerm : <any>null;
        data["campusId"] = this.campusId !== undefined ? this.campusId : <any>null;
        if (Array.isArray(this.facilityTypeIds)) {
            data["facilityTypeIds"] = [];
            for (let item of this.facilityTypeIds)
                data["facilityTypeIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface IFacilitySearchV1Model extends IBaseSearchV1 {
    searchTerm?: string | null;
    campusId?: number | null;
    facilityTypeIds?: number[] | null;
}

export class FacilityInsertV1Model implements IFacilityInsertV1Model {
    campusId!: number;
    name!: string;
    shortName?: string | null;
    facilityTypeId!: number;
    facilityContact?: string | null;
    latitude?: number;
    longitude?: number;
    address?: string | null;
    city?: string | null;
    country!: string;
    state?: string | null;
    zip?: string | null;
    isDefault?: boolean;
    facilityHeaderColor?: string | null;

    constructor(data?: IFacilityInsertV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.campusId = _data["campusId"] !== undefined ? _data["campusId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.shortName = _data["shortName"] !== undefined ? _data["shortName"] : <any>null;
            this.facilityTypeId = _data["facilityTypeId"] !== undefined ? _data["facilityTypeId"] : <any>null;
            this.facilityContact = _data["facilityContact"] !== undefined ? _data["facilityContact"] : <any>null;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : <any>null;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : <any>null;
            this.address = _data["address"] !== undefined ? _data["address"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : <any>null;
            this.isDefault = _data["isDefault"] !== undefined ? _data["isDefault"] : <any>null;
            this.facilityHeaderColor = _data["facilityHeaderColor"] !== undefined ? _data["facilityHeaderColor"] : <any>null;
        }
    }

    static fromJS(data: any): FacilityInsertV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new FacilityInsertV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campusId"] = this.campusId !== undefined ? this.campusId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["shortName"] = this.shortName !== undefined ? this.shortName : <any>null;
        data["facilityTypeId"] = this.facilityTypeId !== undefined ? this.facilityTypeId : <any>null;
        data["facilityContact"] = this.facilityContact !== undefined ? this.facilityContact : <any>null;
        data["latitude"] = this.latitude !== undefined ? this.latitude : <any>null;
        data["longitude"] = this.longitude !== undefined ? this.longitude : <any>null;
        data["address"] = this.address !== undefined ? this.address : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["zip"] = this.zip !== undefined ? this.zip : <any>null;
        data["isDefault"] = this.isDefault !== undefined ? this.isDefault : <any>null;
        data["facilityHeaderColor"] = this.facilityHeaderColor !== undefined ? this.facilityHeaderColor : <any>null;
        return data;
    }
}

export interface IFacilityInsertV1Model {
    campusId: number;
    name: string;
    shortName?: string | null;
    facilityTypeId: number;
    facilityContact?: string | null;
    latitude?: number;
    longitude?: number;
    address?: string | null;
    city?: string | null;
    country: string;
    state?: string | null;
    zip?: string | null;
    isDefault?: boolean;
    facilityHeaderColor?: string | null;
}

export class FacilityUpdateV1Model implements IFacilityUpdateV1Model {
    facilityId!: number;
    campusId!: number;
    facilityTypeId!: number;
    facilityContact?: string | null;
    name!: string;
    shortName?: string | null;
    latitude?: number;
    longitude?: number;
    address?: string | null;
    city?: string | null;
    country!: string;
    state?: string | null;
    zip?: string | null;
    isDefault?: boolean;
    facilityHeaderColor?: string | null;

    constructor(data?: IFacilityUpdateV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.facilityId = _data["facilityId"] !== undefined ? _data["facilityId"] : <any>null;
            this.campusId = _data["campusId"] !== undefined ? _data["campusId"] : <any>null;
            this.facilityTypeId = _data["facilityTypeId"] !== undefined ? _data["facilityTypeId"] : <any>null;
            this.facilityContact = _data["facilityContact"] !== undefined ? _data["facilityContact"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.shortName = _data["shortName"] !== undefined ? _data["shortName"] : <any>null;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : <any>null;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : <any>null;
            this.address = _data["address"] !== undefined ? _data["address"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : <any>null;
            this.isDefault = _data["isDefault"] !== undefined ? _data["isDefault"] : <any>null;
            this.facilityHeaderColor = _data["facilityHeaderColor"] !== undefined ? _data["facilityHeaderColor"] : <any>null;
        }
    }

    static fromJS(data: any): FacilityUpdateV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new FacilityUpdateV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facilityId"] = this.facilityId !== undefined ? this.facilityId : <any>null;
        data["campusId"] = this.campusId !== undefined ? this.campusId : <any>null;
        data["facilityTypeId"] = this.facilityTypeId !== undefined ? this.facilityTypeId : <any>null;
        data["facilityContact"] = this.facilityContact !== undefined ? this.facilityContact : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["shortName"] = this.shortName !== undefined ? this.shortName : <any>null;
        data["latitude"] = this.latitude !== undefined ? this.latitude : <any>null;
        data["longitude"] = this.longitude !== undefined ? this.longitude : <any>null;
        data["address"] = this.address !== undefined ? this.address : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["zip"] = this.zip !== undefined ? this.zip : <any>null;
        data["isDefault"] = this.isDefault !== undefined ? this.isDefault : <any>null;
        data["facilityHeaderColor"] = this.facilityHeaderColor !== undefined ? this.facilityHeaderColor : <any>null;
        return data;
    }
}

export interface IFacilityUpdateV1Model {
    facilityId: number;
    campusId: number;
    facilityTypeId: number;
    facilityContact?: string | null;
    name: string;
    shortName?: string | null;
    latitude?: number;
    longitude?: number;
    address?: string | null;
    city?: string | null;
    country: string;
    state?: string | null;
    zip?: string | null;
    isDefault?: boolean;
    facilityHeaderColor?: string | null;
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export class ODataValueOfIEnumerableOfFacilityV1Model implements IODataValueOfIEnumerableOfFacilityV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: FacilityV1Model[] | null;

    constructor(data?: IODataValueOfIEnumerableOfFacilityV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(FacilityV1Model.fromJS(item));
            }
            else {
                this.value = <any>null;
            }
        }
    }

    static fromJS(data: any): ODataValueOfIEnumerableOfFacilityV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new ODataValueOfIEnumerableOfFacilityV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export interface IODataValueOfIEnumerableOfFacilityV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: FacilityV1Model[] | null;
}

export class CustomerAccountV1Model implements ICustomerAccountV1Model {
    customerAccountId?: number;
    accountId?: number;
    name?: string | null;
    isActive?: boolean;
    enableRepairs?: boolean;
    createdByUserId?: number;
    createdDate?: Date;
    updatedByUserId?: number;
    updatedDate?: Date;
    lastWorkOrderNumber?: number;

    constructor(data?: ICustomerAccountV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerAccountId = _data["customerAccountId"] !== undefined ? _data["customerAccountId"] : <any>null;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.enableRepairs = _data["enableRepairs"] !== undefined ? _data["enableRepairs"] : <any>null;
            this.createdByUserId = _data["createdByUserId"] !== undefined ? _data["createdByUserId"] : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.updatedByUserId = _data["updatedByUserId"] !== undefined ? _data["updatedByUserId"] : <any>null;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>null;
            this.lastWorkOrderNumber = _data["lastWorkOrderNumber"] !== undefined ? _data["lastWorkOrderNumber"] : <any>null;
        }
    }

    static fromJS(data: any): CustomerAccountV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAccountV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerAccountId"] = this.customerAccountId !== undefined ? this.customerAccountId : <any>null;
        data["accountId"] = this.accountId !== undefined ? this.accountId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["enableRepairs"] = this.enableRepairs !== undefined ? this.enableRepairs : <any>null;
        data["createdByUserId"] = this.createdByUserId !== undefined ? this.createdByUserId : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["updatedByUserId"] = this.updatedByUserId !== undefined ? this.updatedByUserId : <any>null;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>null;
        data["lastWorkOrderNumber"] = this.lastWorkOrderNumber !== undefined ? this.lastWorkOrderNumber : <any>null;
        return data;
    }
}

export interface ICustomerAccountV1Model {
    customerAccountId?: number;
    accountId?: number;
    name?: string | null;
    isActive?: boolean;
    enableRepairs?: boolean;
    createdByUserId?: number;
    createdDate?: Date;
    updatedByUserId?: number;
    updatedDate?: Date;
    lastWorkOrderNumber?: number;
}

export class CustomerAccountMapInfoV1Model implements ICustomerAccountMapInfoV1Model {
    customerAccounts?: CustomerAccountV1Model[] | null;
    mapMarkers?: CustomMapMarkerV1Model[] | null;

    constructor(data?: ICustomerAccountMapInfoV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["customerAccounts"])) {
                this.customerAccounts = [] as any;
                for (let item of _data["customerAccounts"])
                    this.customerAccounts!.push(CustomerAccountV1Model.fromJS(item));
            }
            else {
                this.customerAccounts = <any>null;
            }
            if (Array.isArray(_data["mapMarkers"])) {
                this.mapMarkers = [] as any;
                for (let item of _data["mapMarkers"])
                    this.mapMarkers!.push(CustomMapMarkerV1Model.fromJS(item));
            }
            else {
                this.mapMarkers = <any>null;
            }
        }
    }

    static fromJS(data: any): CustomerAccountMapInfoV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAccountMapInfoV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.customerAccounts)) {
            data["customerAccounts"] = [];
            for (let item of this.customerAccounts)
                data["customerAccounts"].push(item.toJSON());
        }
        if (Array.isArray(this.mapMarkers)) {
            data["mapMarkers"] = [];
            for (let item of this.mapMarkers)
                data["mapMarkers"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICustomerAccountMapInfoV1Model {
    customerAccounts?: CustomerAccountV1Model[] | null;
    mapMarkers?: CustomMapMarkerV1Model[] | null;
}

export class CustomerAccountSearchV1Model extends BaseSearchV1 implements ICustomerAccountSearchV1Model {
    searchTerm?: string | null;
    facilityTypeIds?: number[] | null;
    isActive?: boolean;

    constructor(data?: ICustomerAccountSearchV1Model) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.searchTerm = _data["searchTerm"] !== undefined ? _data["searchTerm"] : <any>null;
            if (Array.isArray(_data["facilityTypeIds"])) {
                this.facilityTypeIds = [] as any;
                for (let item of _data["facilityTypeIds"])
                    this.facilityTypeIds!.push(item);
            }
            else {
                this.facilityTypeIds = <any>null;
            }
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static override fromJS(data: any): CustomerAccountSearchV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAccountSearchV1Model();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchTerm"] = this.searchTerm !== undefined ? this.searchTerm : <any>null;
        if (Array.isArray(this.facilityTypeIds)) {
            data["facilityTypeIds"] = [];
            for (let item of this.facilityTypeIds)
                data["facilityTypeIds"].push(item);
        }
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface ICustomerAccountSearchV1Model extends IBaseSearchV1 {
    searchTerm?: string | null;
    facilityTypeIds?: number[] | null;
    isActive?: boolean;
}

export class CustomerAccountInsertV1Model implements ICustomerAccountInsertV1Model {
    name!: string;
    isActive?: boolean;
    enableRepairs?: boolean;
    campusName?: string | null;
    facilityTypeId?: number;
    facilityName?: string | null;
    facilityAddress?: string | null;
    facilityLatitude?: number;
    facilityLongitude?: number;
    facilityState?: string | null;
    facilityCountry?: string | null;
    facilityZip?: string | null;
    facilityCity?: string | null;

    constructor(data?: ICustomerAccountInsertV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.enableRepairs = _data["enableRepairs"] !== undefined ? _data["enableRepairs"] : <any>null;
            this.campusName = _data["campusName"] !== undefined ? _data["campusName"] : <any>null;
            this.facilityTypeId = _data["facilityTypeId"] !== undefined ? _data["facilityTypeId"] : <any>null;
            this.facilityName = _data["facilityName"] !== undefined ? _data["facilityName"] : <any>null;
            this.facilityAddress = _data["facilityAddress"] !== undefined ? _data["facilityAddress"] : <any>null;
            this.facilityLatitude = _data["facilityLatitude"] !== undefined ? _data["facilityLatitude"] : <any>null;
            this.facilityLongitude = _data["facilityLongitude"] !== undefined ? _data["facilityLongitude"] : <any>null;
            this.facilityState = _data["facilityState"] !== undefined ? _data["facilityState"] : <any>null;
            this.facilityCountry = _data["facilityCountry"] !== undefined ? _data["facilityCountry"] : <any>null;
            this.facilityZip = _data["facilityZip"] !== undefined ? _data["facilityZip"] : <any>null;
            this.facilityCity = _data["facilityCity"] !== undefined ? _data["facilityCity"] : <any>null;
        }
    }

    static fromJS(data: any): CustomerAccountInsertV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAccountInsertV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["enableRepairs"] = this.enableRepairs !== undefined ? this.enableRepairs : <any>null;
        data["campusName"] = this.campusName !== undefined ? this.campusName : <any>null;
        data["facilityTypeId"] = this.facilityTypeId !== undefined ? this.facilityTypeId : <any>null;
        data["facilityName"] = this.facilityName !== undefined ? this.facilityName : <any>null;
        data["facilityAddress"] = this.facilityAddress !== undefined ? this.facilityAddress : <any>null;
        data["facilityLatitude"] = this.facilityLatitude !== undefined ? this.facilityLatitude : <any>null;
        data["facilityLongitude"] = this.facilityLongitude !== undefined ? this.facilityLongitude : <any>null;
        data["facilityState"] = this.facilityState !== undefined ? this.facilityState : <any>null;
        data["facilityCountry"] = this.facilityCountry !== undefined ? this.facilityCountry : <any>null;
        data["facilityZip"] = this.facilityZip !== undefined ? this.facilityZip : <any>null;
        data["facilityCity"] = this.facilityCity !== undefined ? this.facilityCity : <any>null;
        return data;
    }
}

export interface ICustomerAccountInsertV1Model {
    name: string;
    isActive?: boolean;
    enableRepairs?: boolean;
    campusName?: string | null;
    facilityTypeId?: number;
    facilityName?: string | null;
    facilityAddress?: string | null;
    facilityLatitude?: number;
    facilityLongitude?: number;
    facilityState?: string | null;
    facilityCountry?: string | null;
    facilityZip?: string | null;
    facilityCity?: string | null;
}

export class CustomerAccountUpdateV1Model implements ICustomerAccountUpdateV1Model {
    customerAccountId!: number;
    name!: string;
    isActive?: boolean;
    enableRepairs?: boolean;

    constructor(data?: ICustomerAccountUpdateV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerAccountId = _data["customerAccountId"] !== undefined ? _data["customerAccountId"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.enableRepairs = _data["enableRepairs"] !== undefined ? _data["enableRepairs"] : <any>null;
        }
    }

    static fromJS(data: any): CustomerAccountUpdateV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new CustomerAccountUpdateV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerAccountId"] = this.customerAccountId !== undefined ? this.customerAccountId : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["enableRepairs"] = this.enableRepairs !== undefined ? this.enableRepairs : <any>null;
        return data;
    }
}

export interface ICustomerAccountUpdateV1Model {
    customerAccountId: number;
    name: string;
    isActive?: boolean;
    enableRepairs?: boolean;
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export class ODataValueOfIEnumerableOfCustomerAccountV1Model implements IODataValueOfIEnumerableOfCustomerAccountV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: CustomerAccountV1Model[] | null;

    constructor(data?: IODataValueOfIEnumerableOfCustomerAccountV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(CustomerAccountV1Model.fromJS(item));
            }
            else {
                this.value = <any>null;
            }
        }
    }

    static fromJS(data: any): ODataValueOfIEnumerableOfCustomerAccountV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new ODataValueOfIEnumerableOfCustomerAccountV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export interface IODataValueOfIEnumerableOfCustomerAccountV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: CustomerAccountV1Model[] | null;
}

export class CampusV1Model implements ICampusV1Model {
    campusId!: number;
    customerAccountId!: number;
    campus!: string;
    latitude?: number;
    longitude?: number;
    address?: string | null;
    city?: string | null;
    country?: string | null;
    state?: string | null;
    zip?: string | null;
    createdByUserId!: number;
    createdDate!: Date;
    updatedByUserId!: number;
    updatedDate!: Date;
    accountId?: number;
    defaultFacilityIconFileGuid?: string | null;

    constructor(data?: ICampusV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.campusId = _data["campusId"] !== undefined ? _data["campusId"] : <any>null;
            this.customerAccountId = _data["customerAccountId"] !== undefined ? _data["customerAccountId"] : <any>null;
            this.campus = _data["campus"] !== undefined ? _data["campus"] : <any>null;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : <any>null;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : <any>null;
            this.address = _data["address"] !== undefined ? _data["address"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : <any>null;
            this.createdByUserId = _data["createdByUserId"] !== undefined ? _data["createdByUserId"] : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.updatedByUserId = _data["updatedByUserId"] !== undefined ? _data["updatedByUserId"] : <any>null;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>null;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : <any>null;
            this.defaultFacilityIconFileGuid = _data["defaultFacilityIconFileGuid"] !== undefined ? _data["defaultFacilityIconFileGuid"] : <any>null;
        }
    }

    static fromJS(data: any): CampusV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new CampusV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campusId"] = this.campusId !== undefined ? this.campusId : <any>null;
        data["customerAccountId"] = this.customerAccountId !== undefined ? this.customerAccountId : <any>null;
        data["campus"] = this.campus !== undefined ? this.campus : <any>null;
        data["latitude"] = this.latitude !== undefined ? this.latitude : <any>null;
        data["longitude"] = this.longitude !== undefined ? this.longitude : <any>null;
        data["address"] = this.address !== undefined ? this.address : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["zip"] = this.zip !== undefined ? this.zip : <any>null;
        data["createdByUserId"] = this.createdByUserId !== undefined ? this.createdByUserId : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["updatedByUserId"] = this.updatedByUserId !== undefined ? this.updatedByUserId : <any>null;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>null;
        data["accountId"] = this.accountId !== undefined ? this.accountId : <any>null;
        data["defaultFacilityIconFileGuid"] = this.defaultFacilityIconFileGuid !== undefined ? this.defaultFacilityIconFileGuid : <any>null;
        return data;
    }
}

export interface ICampusV1Model {
    campusId: number;
    customerAccountId: number;
    campus: string;
    latitude?: number;
    longitude?: number;
    address?: string | null;
    city?: string | null;
    country?: string | null;
    state?: string | null;
    zip?: string | null;
    createdByUserId: number;
    createdDate: Date;
    updatedByUserId: number;
    updatedDate: Date;
    accountId?: number;
    defaultFacilityIconFileGuid?: string | null;
}

export class CampusMapInfoV1Model implements ICampusMapInfoV1Model {
    campuses?: CampusV1Model[] | null;
    mapMarkers?: CustomMapMarkerV1Model[] | null;

    constructor(data?: ICampusMapInfoV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["campuses"])) {
                this.campuses = [] as any;
                for (let item of _data["campuses"])
                    this.campuses!.push(CampusV1Model.fromJS(item));
            }
            else {
                this.campuses = <any>null;
            }
            if (Array.isArray(_data["mapMarkers"])) {
                this.mapMarkers = [] as any;
                for (let item of _data["mapMarkers"])
                    this.mapMarkers!.push(CustomMapMarkerV1Model.fromJS(item));
            }
            else {
                this.mapMarkers = <any>null;
            }
        }
    }

    static fromJS(data: any): CampusMapInfoV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new CampusMapInfoV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.campuses)) {
            data["campuses"] = [];
            for (let item of this.campuses)
                data["campuses"].push(item.toJSON());
        }
        if (Array.isArray(this.mapMarkers)) {
            data["mapMarkers"] = [];
            for (let item of this.mapMarkers)
                data["mapMarkers"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICampusMapInfoV1Model {
    campuses?: CampusV1Model[] | null;
    mapMarkers?: CustomMapMarkerV1Model[] | null;
}

export class CampusSearchV1Model extends BaseSearchV1 implements ICampusSearchV1Model {
    customerAccountId?: number;
    searchTerm?: string | null;
    facilityTypeIds?: number[] | null;

    constructor(data?: ICampusSearchV1Model) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.customerAccountId = _data["customerAccountId"] !== undefined ? _data["customerAccountId"] : <any>null;
            this.searchTerm = _data["searchTerm"] !== undefined ? _data["searchTerm"] : <any>null;
            if (Array.isArray(_data["facilityTypeIds"])) {
                this.facilityTypeIds = [] as any;
                for (let item of _data["facilityTypeIds"])
                    this.facilityTypeIds!.push(item);
            }
            else {
                this.facilityTypeIds = <any>null;
            }
        }
    }

    static override fromJS(data: any): CampusSearchV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new CampusSearchV1Model();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerAccountId"] = this.customerAccountId !== undefined ? this.customerAccountId : <any>null;
        data["searchTerm"] = this.searchTerm !== undefined ? this.searchTerm : <any>null;
        if (Array.isArray(this.facilityTypeIds)) {
            data["facilityTypeIds"] = [];
            for (let item of this.facilityTypeIds)
                data["facilityTypeIds"].push(item);
        }
        super.toJSON(data);
        return data;
    }
}

export interface ICampusSearchV1Model extends IBaseSearchV1 {
    customerAccountId?: number;
    searchTerm?: string | null;
    facilityTypeIds?: number[] | null;
}

export class CampusInsertV1Model implements ICampusInsertV1Model {
    customerAccountId!: number;
    campus!: string;
    latitude!: number;
    longitude!: number;
    address?: string | null;
    city?: string | null;
    country?: string | null;
    state?: string | null;
    zip?: string | null;

    constructor(data?: ICampusInsertV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.customerAccountId = _data["customerAccountId"] !== undefined ? _data["customerAccountId"] : <any>null;
            this.campus = _data["campus"] !== undefined ? _data["campus"] : <any>null;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : <any>null;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : <any>null;
            this.address = _data["address"] !== undefined ? _data["address"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : <any>null;
        }
    }

    static fromJS(data: any): CampusInsertV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new CampusInsertV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["customerAccountId"] = this.customerAccountId !== undefined ? this.customerAccountId : <any>null;
        data["campus"] = this.campus !== undefined ? this.campus : <any>null;
        data["latitude"] = this.latitude !== undefined ? this.latitude : <any>null;
        data["longitude"] = this.longitude !== undefined ? this.longitude : <any>null;
        data["address"] = this.address !== undefined ? this.address : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["zip"] = this.zip !== undefined ? this.zip : <any>null;
        return data;
    }
}

export interface ICampusInsertV1Model {
    customerAccountId: number;
    campus: string;
    latitude: number;
    longitude: number;
    address?: string | null;
    city?: string | null;
    country?: string | null;
    state?: string | null;
    zip?: string | null;
}

export class CampusUpdateV1Model implements ICampusUpdateV1Model {
    campusId!: number;
    campus!: string;
    latitude!: number;
    longitude!: number;
    address?: string | null;
    city?: string | null;
    country?: string | null;
    state?: string | null;
    zip?: string | null;

    constructor(data?: ICampusUpdateV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.campusId = _data["campusId"] !== undefined ? _data["campusId"] : <any>null;
            this.campus = _data["campus"] !== undefined ? _data["campus"] : <any>null;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : <any>null;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : <any>null;
            this.address = _data["address"] !== undefined ? _data["address"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : <any>null;
        }
    }

    static fromJS(data: any): CampusUpdateV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new CampusUpdateV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campusId"] = this.campusId !== undefined ? this.campusId : <any>null;
        data["campus"] = this.campus !== undefined ? this.campus : <any>null;
        data["latitude"] = this.latitude !== undefined ? this.latitude : <any>null;
        data["longitude"] = this.longitude !== undefined ? this.longitude : <any>null;
        data["address"] = this.address !== undefined ? this.address : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["zip"] = this.zip !== undefined ? this.zip : <any>null;
        return data;
    }
}

export interface ICampusUpdateV1Model {
    campusId: number;
    campus: string;
    latitude: number;
    longitude: number;
    address?: string | null;
    city?: string | null;
    country?: string | null;
    state?: string | null;
    zip?: string | null;
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export class ODataValueOfIEnumerableOfCampusV1Model implements IODataValueOfIEnumerableOfCampusV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: CampusV1Model[] | null;

    constructor(data?: IODataValueOfIEnumerableOfCampusV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(CampusV1Model.fromJS(item));
            }
            else {
                this.value = <any>null;
            }
        }
    }

    static fromJS(data: any): ODataValueOfIEnumerableOfCampusV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new ODataValueOfIEnumerableOfCampusV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export interface IODataValueOfIEnumerableOfCampusV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: CampusV1Model[] | null;
}

export class CalloutLocationInsertV1Model implements ICalloutLocationInsertV1Model {
    calloutLocationId?: number;
    assetId?: number;
    blueprintId?: number;
    xCoordinate?: number;
    yCoordinate?: number;

    constructor(data?: ICalloutLocationInsertV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.calloutLocationId = _data["calloutLocationId"] !== undefined ? _data["calloutLocationId"] : <any>null;
            this.assetId = _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
            this.blueprintId = _data["blueprintId"] !== undefined ? _data["blueprintId"] : <any>null;
            this.xCoordinate = _data["xCoordinate"] !== undefined ? _data["xCoordinate"] : <any>null;
            this.yCoordinate = _data["yCoordinate"] !== undefined ? _data["yCoordinate"] : <any>null;
        }
    }

    static fromJS(data: any): CalloutLocationInsertV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new CalloutLocationInsertV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calloutLocationId"] = this.calloutLocationId !== undefined ? this.calloutLocationId : <any>null;
        data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
        data["blueprintId"] = this.blueprintId !== undefined ? this.blueprintId : <any>null;
        data["xCoordinate"] = this.xCoordinate !== undefined ? this.xCoordinate : <any>null;
        data["yCoordinate"] = this.yCoordinate !== undefined ? this.yCoordinate : <any>null;
        return data;
    }
}

export interface ICalloutLocationInsertV1Model {
    calloutLocationId?: number;
    assetId?: number;
    blueprintId?: number;
    xCoordinate?: number;
    yCoordinate?: number;
}

export class CalloutLocationV1Model implements ICalloutLocationV1Model {
    calloutLocationId?: number;
    assetId?: number;
    blueprintId?: number;
    xCoordinate?: number;
    yCoordinate?: number;

    constructor(data?: ICalloutLocationV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.calloutLocationId = _data["calloutLocationId"] !== undefined ? _data["calloutLocationId"] : <any>null;
            this.assetId = _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
            this.blueprintId = _data["blueprintId"] !== undefined ? _data["blueprintId"] : <any>null;
            this.xCoordinate = _data["xCoordinate"] !== undefined ? _data["xCoordinate"] : <any>null;
            this.yCoordinate = _data["yCoordinate"] !== undefined ? _data["yCoordinate"] : <any>null;
        }
    }

    static fromJS(data: any): CalloutLocationV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new CalloutLocationV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["calloutLocationId"] = this.calloutLocationId !== undefined ? this.calloutLocationId : <any>null;
        data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
        data["blueprintId"] = this.blueprintId !== undefined ? this.blueprintId : <any>null;
        data["xCoordinate"] = this.xCoordinate !== undefined ? this.xCoordinate : <any>null;
        data["yCoordinate"] = this.yCoordinate !== undefined ? this.yCoordinate : <any>null;
        return data;
    }
}

export interface ICalloutLocationV1Model {
    calloutLocationId?: number;
    assetId?: number;
    blueprintId?: number;
    xCoordinate?: number;
    yCoordinate?: number;
}

export class CorrespondingAssetV1Model implements ICorrespondingAssetV1Model {
    assetId?: number;
    relatedAssetId?: number;

    constructor(data?: ICorrespondingAssetV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetId = _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
            this.relatedAssetId = _data["relatedAssetId"] !== undefined ? _data["relatedAssetId"] : <any>null;
        }
    }

    static fromJS(data: any): CorrespondingAssetV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new CorrespondingAssetV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
        data["relatedAssetId"] = this.relatedAssetId !== undefined ? this.relatedAssetId : <any>null;
        return data;
    }
}

export interface ICorrespondingAssetV1Model {
    assetId?: number;
    relatedAssetId?: number;
}

export class AssetSearchV1Model implements IAssetSearchV1Model {
    campusId?: number | null;
    facilityId?: number | null;
    assetClassId?: number | null;
    floorId?: number | null;
    blueprintId?: number | null;

    constructor(data?: IAssetSearchV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.campusId = _data["campusId"] !== undefined ? _data["campusId"] : <any>null;
            this.facilityId = _data["facilityId"] !== undefined ? _data["facilityId"] : <any>null;
            this.assetClassId = _data["assetClassId"] !== undefined ? _data["assetClassId"] : <any>null;
            this.floorId = _data["floorId"] !== undefined ? _data["floorId"] : <any>null;
            this.blueprintId = _data["blueprintId"] !== undefined ? _data["blueprintId"] : <any>null;
        }
    }

    static fromJS(data: any): AssetSearchV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new AssetSearchV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["campusId"] = this.campusId !== undefined ? this.campusId : <any>null;
        data["facilityId"] = this.facilityId !== undefined ? this.facilityId : <any>null;
        data["assetClassId"] = this.assetClassId !== undefined ? this.assetClassId : <any>null;
        data["floorId"] = this.floorId !== undefined ? this.floorId : <any>null;
        data["blueprintId"] = this.blueprintId !== undefined ? this.blueprintId : <any>null;
        return data;
    }
}

export interface IAssetSearchV1Model {
    campusId?: number | null;
    facilityId?: number | null;
    assetClassId?: number | null;
    floorId?: number | null;
    blueprintId?: number | null;
}

export class AssetInsertForBlueprintResponseV1Model implements IAssetInsertForBlueprintResponseV1Model {
    assetId?: number;
    iconFileGuid?: string | null;
    name?: string | null;

    constructor(data?: IAssetInsertForBlueprintResponseV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetId = _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
            this.iconFileGuid = _data["iconFileGuid"] !== undefined ? _data["iconFileGuid"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
        }
    }

    static fromJS(data: any): AssetInsertForBlueprintResponseV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new AssetInsertForBlueprintResponseV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
        data["iconFileGuid"] = this.iconFileGuid !== undefined ? this.iconFileGuid : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        return data;
    }
}

export interface IAssetInsertForBlueprintResponseV1Model {
    assetId?: number;
    iconFileGuid?: string | null;
    name?: string | null;
}

export class AssetUpdateV1Model implements IAssetUpdateV1Model {
    assetId?: number;
    floorId?: number;
    facilityId?: number;
    assetNumber?: string | null;
    notes?: string | null;
    assetClassId?: number;
    assetProfileId?: number;
    assetProfileValues?: any | null;
    isActive?: boolean;

    constructor(data?: IAssetUpdateV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetId = _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
            this.floorId = _data["floorId"] !== undefined ? _data["floorId"] : <any>null;
            this.facilityId = _data["facilityId"] !== undefined ? _data["facilityId"] : <any>null;
            this.assetNumber = _data["assetNumber"] !== undefined ? _data["assetNumber"] : <any>null;
            this.notes = _data["notes"] !== undefined ? _data["notes"] : <any>null;
            this.assetClassId = _data["assetClassId"] !== undefined ? _data["assetClassId"] : <any>null;
            this.assetProfileId = _data["assetProfileId"] !== undefined ? _data["assetProfileId"] : <any>null;
            this.assetProfileValues = _data["assetProfileValues"] !== undefined ? _data["assetProfileValues"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
        }
    }

    static fromJS(data: any): AssetUpdateV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new AssetUpdateV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
        data["floorId"] = this.floorId !== undefined ? this.floorId : <any>null;
        data["facilityId"] = this.facilityId !== undefined ? this.facilityId : <any>null;
        data["assetNumber"] = this.assetNumber !== undefined ? this.assetNumber : <any>null;
        data["notes"] = this.notes !== undefined ? this.notes : <any>null;
        data["assetClassId"] = this.assetClassId !== undefined ? this.assetClassId : <any>null;
        data["assetProfileId"] = this.assetProfileId !== undefined ? this.assetProfileId : <any>null;
        data["assetProfileValues"] = this.assetProfileValues !== undefined ? this.assetProfileValues : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        return data;
    }
}

export interface IAssetUpdateV1Model {
    assetId?: number;
    floorId?: number;
    facilityId?: number;
    assetNumber?: string | null;
    notes?: string | null;
    assetClassId?: number;
    assetProfileId?: number;
    assetProfileValues?: any | null;
    isActive?: boolean;
}

export class AssetNumberCheckV1Model implements IAssetNumberCheckV1Model {
    assetClassId?: number;
    floorId?: number;

    constructor(data?: IAssetNumberCheckV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetClassId = _data["assetClassId"] !== undefined ? _data["assetClassId"] : <any>null;
            this.floorId = _data["floorId"] !== undefined ? _data["floorId"] : <any>null;
        }
    }

    static fromJS(data: any): AssetNumberCheckV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new AssetNumberCheckV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetClassId"] = this.assetClassId !== undefined ? this.assetClassId : <any>null;
        data["floorId"] = this.floorId !== undefined ? this.floorId : <any>null;
        return data;
    }
}

export interface IAssetNumberCheckV1Model {
    assetClassId?: number;
    floorId?: number;
}

export class AssetImportM1V1Model extends FileV1Model implements IAssetImportM1V1Model {
    facilityId?: number;
    campusId?: number;
    assetProfile?: AssetProfile;

    constructor(data?: IAssetImportM1V1Model) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.facilityId = _data["facilityId"] !== undefined ? _data["facilityId"] : <any>null;
            this.campusId = _data["campusId"] !== undefined ? _data["campusId"] : <any>null;
            this.assetProfile = _data["assetProfile"] !== undefined ? _data["assetProfile"] : <any>null;
        }
    }

    static override fromJS(data: any): AssetImportM1V1Model {
        data = typeof data === 'object' ? data : {};
        let result = new AssetImportM1V1Model();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["facilityId"] = this.facilityId !== undefined ? this.facilityId : <any>null;
        data["campusId"] = this.campusId !== undefined ? this.campusId : <any>null;
        data["assetProfile"] = this.assetProfile !== undefined ? this.assetProfile : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAssetImportM1V1Model extends IFileV1Model {
    facilityId?: number;
    campusId?: number;
    assetProfile?: AssetProfile;
}

export class AssetImportFileV1Model implements IAssetImportFileV1Model {
    fileBase64?: string | null;
    fileName?: string | null;
    contentType?: string | null;

    constructor(data?: IAssetImportFileV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileBase64 = _data["fileBase64"] !== undefined ? _data["fileBase64"] : <any>null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
            this.contentType = _data["contentType"] !== undefined ? _data["contentType"] : <any>null;
        }
    }

    static fromJS(data: any): AssetImportFileV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new AssetImportFileV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileBase64"] = this.fileBase64 !== undefined ? this.fileBase64 : <any>null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        data["contentType"] = this.contentType !== undefined ? this.contentType : <any>null;
        return data;
    }
}

export interface IAssetImportFileV1Model {
    fileBase64?: string | null;
    fileName?: string | null;
    contentType?: string | null;
}

export class AssetDocumentV1Model extends FileV1Model implements IAssetDocumentV1Model {
    assetDocumentId?: number;
    assetId?: number;
    createdByUserId?: number;
    createdByUser?: string | null;
    updatedByUserId?: number;
    updatedByUser?: string | null;
    createdDate?: Date;
    updatedDate?: Date;

    constructor(data?: IAssetDocumentV1Model) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.assetDocumentId = _data["assetDocumentId"] !== undefined ? _data["assetDocumentId"] : <any>null;
            this.assetId = _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
            this.createdByUserId = _data["createdByUserId"] !== undefined ? _data["createdByUserId"] : <any>null;
            this.createdByUser = _data["createdByUser"] !== undefined ? _data["createdByUser"] : <any>null;
            this.updatedByUserId = _data["updatedByUserId"] !== undefined ? _data["updatedByUserId"] : <any>null;
            this.updatedByUser = _data["updatedByUser"] !== undefined ? _data["updatedByUser"] : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>null;
        }
    }

    static override fromJS(data: any): AssetDocumentV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new AssetDocumentV1Model();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetDocumentId"] = this.assetDocumentId !== undefined ? this.assetDocumentId : <any>null;
        data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
        data["createdByUserId"] = this.createdByUserId !== undefined ? this.createdByUserId : <any>null;
        data["createdByUser"] = this.createdByUser !== undefined ? this.createdByUser : <any>null;
        data["updatedByUserId"] = this.updatedByUserId !== undefined ? this.updatedByUserId : <any>null;
        data["updatedByUser"] = this.updatedByUser !== undefined ? this.updatedByUser : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAssetDocumentV1Model extends IFileV1Model {
    assetDocumentId?: number;
    assetId?: number;
    createdByUserId?: number;
    createdByUser?: string | null;
    updatedByUserId?: number;
    updatedByUser?: string | null;
    createdDate?: Date;
    updatedDate?: Date;
}

export class AssetDocumentInsertV1Model extends FileV1Model implements IAssetDocumentInsertV1Model {
    assetId?: number;

    constructor(data?: IAssetDocumentInsertV1Model) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.assetId = _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
        }
    }

    static override fromJS(data: any): AssetDocumentInsertV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new AssetDocumentInsertV1Model();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAssetDocumentInsertV1Model extends IFileV1Model {
    assetId?: number;
}

export class AssetDocumentUpdateV1Model extends FileV1Model implements IAssetDocumentUpdateV1Model {
    assetDocumentId?: number;
    assetId?: number;

    constructor(data?: IAssetDocumentUpdateV1Model) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.assetDocumentId = _data["assetDocumentId"] !== undefined ? _data["assetDocumentId"] : <any>null;
            this.assetId = _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
        }
    }

    static override fromJS(data: any): AssetDocumentUpdateV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new AssetDocumentUpdateV1Model();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetDocumentId"] = this.assetDocumentId !== undefined ? this.assetDocumentId : <any>null;
        data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAssetDocumentUpdateV1Model extends IFileV1Model {
    assetDocumentId?: number;
    assetId?: number;
}

export class AssetDrawingInsertV1Model extends FileV1Model implements IAssetDrawingInsertV1Model {
    assetId?: number;

    constructor(data?: IAssetDrawingInsertV1Model) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.assetId = _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
        }
    }

    static override fromJS(data: any): AssetDrawingInsertV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new AssetDrawingInsertV1Model();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAssetDrawingInsertV1Model extends IFileV1Model {
    assetId?: number;
}

export class AssetDrawingUpdateV1Model extends FileV1Model implements IAssetDrawingUpdateV1Model {
    assetDrawingId?: number;
    assetId?: number;

    constructor(data?: IAssetDrawingUpdateV1Model) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.assetDrawingId = _data["assetDrawingId"] !== undefined ? _data["assetDrawingId"] : <any>null;
            this.assetId = _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
        }
    }

    static override fromJS(data: any): AssetDrawingUpdateV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new AssetDrawingUpdateV1Model();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetDrawingId"] = this.assetDrawingId !== undefined ? this.assetDrawingId : <any>null;
        data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAssetDrawingUpdateV1Model extends IFileV1Model {
    assetDrawingId?: number;
    assetId?: number;
}

export class AssetLocationInsertV1Model implements IAssetLocationInsertV1Model {
    assetId?: number;
    blueprintId?: number;
    xCordinate?: number;
    yCordinate?: number;
    canvasWidth?: number;
    canvasHeight?: number;

    constructor(data?: IAssetLocationInsertV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetId = _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
            this.blueprintId = _data["blueprintId"] !== undefined ? _data["blueprintId"] : <any>null;
            this.xCordinate = _data["xCordinate"] !== undefined ? _data["xCordinate"] : <any>null;
            this.yCordinate = _data["yCordinate"] !== undefined ? _data["yCordinate"] : <any>null;
            this.canvasWidth = _data["canvasWidth"] !== undefined ? _data["canvasWidth"] : <any>null;
            this.canvasHeight = _data["canvasHeight"] !== undefined ? _data["canvasHeight"] : <any>null;
        }
    }

    static fromJS(data: any): AssetLocationInsertV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new AssetLocationInsertV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
        data["blueprintId"] = this.blueprintId !== undefined ? this.blueprintId : <any>null;
        data["xCordinate"] = this.xCordinate !== undefined ? this.xCordinate : <any>null;
        data["yCordinate"] = this.yCordinate !== undefined ? this.yCordinate : <any>null;
        data["canvasWidth"] = this.canvasWidth !== undefined ? this.canvasWidth : <any>null;
        data["canvasHeight"] = this.canvasHeight !== undefined ? this.canvasHeight : <any>null;
        return data;
    }
}

export interface IAssetLocationInsertV1Model {
    assetId?: number;
    blueprintId?: number;
    xCordinate?: number;
    yCordinate?: number;
    canvasWidth?: number;
    canvasHeight?: number;
}

export class AssetLocationUpdateV1Model implements IAssetLocationUpdateV1Model {
    assetLocationId?: number;
    assetId?: number;
    blueprintId?: number;
    xCordinate?: number | null;
    yCordinate?: number | null;
    canvasWidth?: number;
    canvasHeight?: number;

    constructor(data?: IAssetLocationUpdateV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetLocationId = _data["assetLocationId"] !== undefined ? _data["assetLocationId"] : <any>null;
            this.assetId = _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
            this.blueprintId = _data["blueprintId"] !== undefined ? _data["blueprintId"] : <any>null;
            this.xCordinate = _data["xCordinate"] !== undefined ? _data["xCordinate"] : <any>null;
            this.yCordinate = _data["yCordinate"] !== undefined ? _data["yCordinate"] : <any>null;
            this.canvasWidth = _data["canvasWidth"] !== undefined ? _data["canvasWidth"] : <any>null;
            this.canvasHeight = _data["canvasHeight"] !== undefined ? _data["canvasHeight"] : <any>null;
        }
    }

    static fromJS(data: any): AssetLocationUpdateV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new AssetLocationUpdateV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetLocationId"] = this.assetLocationId !== undefined ? this.assetLocationId : <any>null;
        data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
        data["blueprintId"] = this.blueprintId !== undefined ? this.blueprintId : <any>null;
        data["xCordinate"] = this.xCordinate !== undefined ? this.xCordinate : <any>null;
        data["yCordinate"] = this.yCordinate !== undefined ? this.yCordinate : <any>null;
        data["canvasWidth"] = this.canvasWidth !== undefined ? this.canvasWidth : <any>null;
        data["canvasHeight"] = this.canvasHeight !== undefined ? this.canvasHeight : <any>null;
        return data;
    }
}

export interface IAssetLocationUpdateV1Model {
    assetLocationId?: number;
    assetId?: number;
    blueprintId?: number;
    xCordinate?: number | null;
    yCordinate?: number | null;
    canvasWidth?: number;
    canvasHeight?: number;
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export class ODataValueOfIEnumerableOfAssetV1Model implements IODataValueOfIEnumerableOfAssetV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: AssetV1Model[] | null;

    constructor(data?: IODataValueOfIEnumerableOfAssetV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(AssetV1Model.fromJS(item));
            }
            else {
                this.value = <any>null;
            }
        }
    }

    static fromJS(data: any): ODataValueOfIEnumerableOfAssetV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new ODataValueOfIEnumerableOfAssetV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export interface IODataValueOfIEnumerableOfAssetV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: AssetV1Model[] | null;
}

export class AssetPhotoV1Model extends FileV1Model implements IAssetPhotoV1Model {
    assetPhotoId?: number;
    assetId?: number;
    assetPhotoTypeId?: number;
    assetPhotoType?: string | null;
    createdByUserId?: number;
    createdByUser?: string | null;
    updatedByUserId?: number;
    updatedByUser?: string | null;
    createdDate?: Date;
    updatedDate?: Date;

    constructor(data?: IAssetPhotoV1Model) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.assetPhotoId = _data["assetPhotoId"] !== undefined ? _data["assetPhotoId"] : <any>null;
            this.assetId = _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
            this.assetPhotoTypeId = _data["assetPhotoTypeId"] !== undefined ? _data["assetPhotoTypeId"] : <any>null;
            this.assetPhotoType = _data["assetPhotoType"] !== undefined ? _data["assetPhotoType"] : <any>null;
            this.createdByUserId = _data["createdByUserId"] !== undefined ? _data["createdByUserId"] : <any>null;
            this.createdByUser = _data["createdByUser"] !== undefined ? _data["createdByUser"] : <any>null;
            this.updatedByUserId = _data["updatedByUserId"] !== undefined ? _data["updatedByUserId"] : <any>null;
            this.updatedByUser = _data["updatedByUser"] !== undefined ? _data["updatedByUser"] : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>null;
        }
    }

    static override fromJS(data: any): AssetPhotoV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new AssetPhotoV1Model();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetPhotoId"] = this.assetPhotoId !== undefined ? this.assetPhotoId : <any>null;
        data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
        data["assetPhotoTypeId"] = this.assetPhotoTypeId !== undefined ? this.assetPhotoTypeId : <any>null;
        data["assetPhotoType"] = this.assetPhotoType !== undefined ? this.assetPhotoType : <any>null;
        data["createdByUserId"] = this.createdByUserId !== undefined ? this.createdByUserId : <any>null;
        data["createdByUser"] = this.createdByUser !== undefined ? this.createdByUser : <any>null;
        data["updatedByUserId"] = this.updatedByUserId !== undefined ? this.updatedByUserId : <any>null;
        data["updatedByUser"] = this.updatedByUser !== undefined ? this.updatedByUser : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAssetPhotoV1Model extends IFileV1Model {
    assetPhotoId?: number;
    assetId?: number;
    assetPhotoTypeId?: number;
    assetPhotoType?: string | null;
    createdByUserId?: number;
    createdByUser?: string | null;
    updatedByUserId?: number;
    updatedByUser?: string | null;
    createdDate?: Date;
    updatedDate?: Date;
}

export class AssetPhotoTypeV1Model implements IAssetPhotoTypeV1Model {
    assetPhotoTypeId?: number;
    assetPhotoType?: string | null;
    assetProfileId?: number | null;

    constructor(data?: IAssetPhotoTypeV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetPhotoTypeId = _data["assetPhotoTypeId"] !== undefined ? _data["assetPhotoTypeId"] : <any>null;
            this.assetPhotoType = _data["assetPhotoType"] !== undefined ? _data["assetPhotoType"] : <any>null;
            this.assetProfileId = _data["assetProfileId"] !== undefined ? _data["assetProfileId"] : <any>null;
        }
    }

    static fromJS(data: any): AssetPhotoTypeV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new AssetPhotoTypeV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetPhotoTypeId"] = this.assetPhotoTypeId !== undefined ? this.assetPhotoTypeId : <any>null;
        data["assetPhotoType"] = this.assetPhotoType !== undefined ? this.assetPhotoType : <any>null;
        data["assetProfileId"] = this.assetProfileId !== undefined ? this.assetProfileId : <any>null;
        return data;
    }
}

export interface IAssetPhotoTypeV1Model {
    assetPhotoTypeId?: number;
    assetPhotoType?: string | null;
    assetProfileId?: number | null;
}

export class AssetPhotoInsertV1Model extends FileV1Model implements IAssetPhotoInsertV1Model {
    assetId?: number;
    assetPhotoTypeId?: number;

    constructor(data?: IAssetPhotoInsertV1Model) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.assetId = _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
            this.assetPhotoTypeId = _data["assetPhotoTypeId"] !== undefined ? _data["assetPhotoTypeId"] : <any>null;
        }
    }

    static override fromJS(data: any): AssetPhotoInsertV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new AssetPhotoInsertV1Model();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
        data["assetPhotoTypeId"] = this.assetPhotoTypeId !== undefined ? this.assetPhotoTypeId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAssetPhotoInsertV1Model extends IFileV1Model {
    assetId?: number;
    assetPhotoTypeId?: number;
}

export class AssetPhotoUpdateV1Model extends FileV1Model implements IAssetPhotoUpdateV1Model {
    assetPhotoId?: number;
    assetId?: number;
    assetPhotoTypeId?: number;

    constructor(data?: IAssetPhotoUpdateV1Model) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.assetPhotoId = _data["assetPhotoId"] !== undefined ? _data["assetPhotoId"] : <any>null;
            this.assetId = _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
            this.assetPhotoTypeId = _data["assetPhotoTypeId"] !== undefined ? _data["assetPhotoTypeId"] : <any>null;
        }
    }

    static override fromJS(data: any): AssetPhotoUpdateV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new AssetPhotoUpdateV1Model();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetPhotoId"] = this.assetPhotoId !== undefined ? this.assetPhotoId : <any>null;
        data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
        data["assetPhotoTypeId"] = this.assetPhotoTypeId !== undefined ? this.assetPhotoTypeId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAssetPhotoUpdateV1Model extends IFileV1Model {
    assetPhotoId?: number;
    assetId?: number;
    assetPhotoTypeId?: number;
}

export class AssetVideoV1Model implements IAssetVideoV1Model {
    assetVideoId?: number;
    assetId?: number;
    fileName?: string | null;
    fileGuid?: string | null;
    fileBytes?: string | null;
    contentType?: string | null;
    createdByUserId?: number;
    createdDate?: Date;
    updatedByUserId?: number;
    updatedDate?: Date;

    constructor(data?: IAssetVideoV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetVideoId = _data["assetVideoId"] !== undefined ? _data["assetVideoId"] : <any>null;
            this.assetId = _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
            this.fileGuid = _data["fileGuid"] !== undefined ? _data["fileGuid"] : <any>null;
            this.fileBytes = _data["fileBytes"] !== undefined ? _data["fileBytes"] : <any>null;
            this.contentType = _data["contentType"] !== undefined ? _data["contentType"] : <any>null;
            this.createdByUserId = _data["createdByUserId"] !== undefined ? _data["createdByUserId"] : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.updatedByUserId = _data["updatedByUserId"] !== undefined ? _data["updatedByUserId"] : <any>null;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): AssetVideoV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new AssetVideoV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetVideoId"] = this.assetVideoId !== undefined ? this.assetVideoId : <any>null;
        data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        data["fileGuid"] = this.fileGuid !== undefined ? this.fileGuid : <any>null;
        data["fileBytes"] = this.fileBytes !== undefined ? this.fileBytes : <any>null;
        data["contentType"] = this.contentType !== undefined ? this.contentType : <any>null;
        data["createdByUserId"] = this.createdByUserId !== undefined ? this.createdByUserId : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["updatedByUserId"] = this.updatedByUserId !== undefined ? this.updatedByUserId : <any>null;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>null;
        return data;
    }
}

export interface IAssetVideoV1Model {
    assetVideoId?: number;
    assetId?: number;
    fileName?: string | null;
    fileGuid?: string | null;
    fileBytes?: string | null;
    contentType?: string | null;
    createdByUserId?: number;
    createdDate?: Date;
    updatedByUserId?: number;
    updatedDate?: Date;
}

export class AssetVideoUpdateV1Model implements IAssetVideoUpdateV1Model {
    assetVideoId?: number;
    assetId?: number;
    fileName?: string | null;
    videoBytes?: string | null;
    fileGuid?: string | null;
    contentType?: string | null;

    constructor(data?: IAssetVideoUpdateV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetVideoId = _data["assetVideoId"] !== undefined ? _data["assetVideoId"] : <any>null;
            this.assetId = _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : <any>null;
            this.videoBytes = _data["videoBytes"] !== undefined ? _data["videoBytes"] : <any>null;
            this.fileGuid = _data["fileGuid"] !== undefined ? _data["fileGuid"] : <any>null;
            this.contentType = _data["contentType"] !== undefined ? _data["contentType"] : <any>null;
        }
    }

    static fromJS(data: any): AssetVideoUpdateV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new AssetVideoUpdateV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetVideoId"] = this.assetVideoId !== undefined ? this.assetVideoId : <any>null;
        data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
        data["fileName"] = this.fileName !== undefined ? this.fileName : <any>null;
        data["videoBytes"] = this.videoBytes !== undefined ? this.videoBytes : <any>null;
        data["fileGuid"] = this.fileGuid !== undefined ? this.fileGuid : <any>null;
        data["contentType"] = this.contentType !== undefined ? this.contentType : <any>null;
        return data;
    }
}

export interface IAssetVideoUpdateV1Model {
    assetVideoId?: number;
    assetId?: number;
    fileName?: string | null;
    videoBytes?: string | null;
    fileGuid?: string | null;
    contentType?: string | null;
}

export class AssetWarrantyInsertV1Model extends FileV1Model implements IAssetWarrantyInsertV1Model {
    assetId?: number;

    constructor(data?: IAssetWarrantyInsertV1Model) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.assetId = _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
        }
    }

    static override fromJS(data: any): AssetWarrantyInsertV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new AssetWarrantyInsertV1Model();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAssetWarrantyInsertV1Model extends IFileV1Model {
    assetId?: number;
}

export class AssetWarrantyUpdateV1Model extends FileV1Model implements IAssetWarrantyUpdateV1Model {
    assetWarrantyId?: number;
    assetId?: number;

    constructor(data?: IAssetWarrantyUpdateV1Model) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.assetWarrantyId = _data["assetWarrantyId"] !== undefined ? _data["assetWarrantyId"] : <any>null;
            this.assetId = _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
        }
    }

    static override fromJS(data: any): AssetWarrantyUpdateV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new AssetWarrantyUpdateV1Model();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetWarrantyId"] = this.assetWarrantyId !== undefined ? this.assetWarrantyId : <any>null;
        data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAssetWarrantyUpdateV1Model extends IFileV1Model {
    assetWarrantyId?: number;
    assetId?: number;
}

export class AssetProfileTypeInsertV1Model implements IAssetProfileTypeInsertV1Model {
    assetProfileId?: number;
    assetProfileType?: string | null;
    shortName?: string | null;

    constructor(data?: IAssetProfileTypeInsertV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetProfileId = _data["assetProfileId"] !== undefined ? _data["assetProfileId"] : <any>null;
            this.assetProfileType = _data["assetProfileType"] !== undefined ? _data["assetProfileType"] : <any>null;
            this.shortName = _data["shortName"] !== undefined ? _data["shortName"] : <any>null;
        }
    }

    static fromJS(data: any): AssetProfileTypeInsertV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new AssetProfileTypeInsertV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetProfileId"] = this.assetProfileId !== undefined ? this.assetProfileId : <any>null;
        data["assetProfileType"] = this.assetProfileType !== undefined ? this.assetProfileType : <any>null;
        data["shortName"] = this.shortName !== undefined ? this.shortName : <any>null;
        return data;
    }
}

export interface IAssetProfileTypeInsertV1Model {
    assetProfileId?: number;
    assetProfileType?: string | null;
    shortName?: string | null;
}

export class AssetProfileTypeUpdateV1Model implements IAssetProfileTypeUpdateV1Model {
    assetProfileTypeId?: number;
    assetProfileId?: number;
    assetProfileType?: string | null;
    shortName?: string | null;

    constructor(data?: IAssetProfileTypeUpdateV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetProfileTypeId = _data["assetProfileTypeId"] !== undefined ? _data["assetProfileTypeId"] : <any>null;
            this.assetProfileId = _data["assetProfileId"] !== undefined ? _data["assetProfileId"] : <any>null;
            this.assetProfileType = _data["assetProfileType"] !== undefined ? _data["assetProfileType"] : <any>null;
            this.shortName = _data["shortName"] !== undefined ? _data["shortName"] : <any>null;
        }
    }

    static fromJS(data: any): AssetProfileTypeUpdateV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new AssetProfileTypeUpdateV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetProfileTypeId"] = this.assetProfileTypeId !== undefined ? this.assetProfileTypeId : <any>null;
        data["assetProfileId"] = this.assetProfileId !== undefined ? this.assetProfileId : <any>null;
        data["assetProfileType"] = this.assetProfileType !== undefined ? this.assetProfileType : <any>null;
        data["shortName"] = this.shortName !== undefined ? this.shortName : <any>null;
        return data;
    }
}

export interface IAssetProfileTypeUpdateV1Model {
    assetProfileTypeId?: number;
    assetProfileId?: number;
    assetProfileType?: string | null;
    shortName?: string | null;
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export class ODataValueOfIEnumerableOfAssetProfileTypeV1Model implements IODataValueOfIEnumerableOfAssetProfileTypeV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: AssetProfileTypeV1Model[] | null;

    constructor(data?: IODataValueOfIEnumerableOfAssetProfileTypeV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(AssetProfileTypeV1Model.fromJS(item));
            }
            else {
                this.value = <any>null;
            }
        }
    }

    static fromJS(data: any): ODataValueOfIEnumerableOfAssetProfileTypeV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new ODataValueOfIEnumerableOfAssetProfileTypeV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export interface IODataValueOfIEnumerableOfAssetProfileTypeV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: AssetProfileTypeV1Model[] | null;
}

export class AssetClassInsertV1Model implements IAssetClassInsertV1Model {
    accountId?: number;
    assetClass?: string | null;
    iconId?: number | null;
    assetProfileId?: number;
    inspectionFormId?: number;
    suggestedRepairFormId?: number;
    repairFormId?: number;

    constructor(data?: IAssetClassInsertV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : <any>null;
            this.assetClass = _data["assetClass"] !== undefined ? _data["assetClass"] : <any>null;
            this.iconId = _data["iconId"] !== undefined ? _data["iconId"] : <any>null;
            this.assetProfileId = _data["assetProfileId"] !== undefined ? _data["assetProfileId"] : <any>null;
            this.inspectionFormId = _data["inspectionFormId"] !== undefined ? _data["inspectionFormId"] : <any>null;
            this.suggestedRepairFormId = _data["suggestedRepairFormId"] !== undefined ? _data["suggestedRepairFormId"] : <any>null;
            this.repairFormId = _data["repairFormId"] !== undefined ? _data["repairFormId"] : <any>null;
        }
    }

    static fromJS(data: any): AssetClassInsertV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new AssetClassInsertV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId !== undefined ? this.accountId : <any>null;
        data["assetClass"] = this.assetClass !== undefined ? this.assetClass : <any>null;
        data["iconId"] = this.iconId !== undefined ? this.iconId : <any>null;
        data["assetProfileId"] = this.assetProfileId !== undefined ? this.assetProfileId : <any>null;
        data["inspectionFormId"] = this.inspectionFormId !== undefined ? this.inspectionFormId : <any>null;
        data["suggestedRepairFormId"] = this.suggestedRepairFormId !== undefined ? this.suggestedRepairFormId : <any>null;
        data["repairFormId"] = this.repairFormId !== undefined ? this.repairFormId : <any>null;
        return data;
    }
}

export interface IAssetClassInsertV1Model {
    accountId?: number;
    assetClass?: string | null;
    iconId?: number | null;
    assetProfileId?: number;
    inspectionFormId?: number;
    suggestedRepairFormId?: number;
    repairFormId?: number;
}

export class AssetClassUpdateV1Model implements IAssetClassUpdateV1Model {
    assetClassId?: number;
    accountId?: number;
    assetClass?: string | null;
    iconId?: number | null;
    inspectionFormId?: number;
    repairFormId?: number;
    suggestedRepairFormId?: number;
    assetProfileId?: number;

    constructor(data?: IAssetClassUpdateV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.assetClassId = _data["assetClassId"] !== undefined ? _data["assetClassId"] : <any>null;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : <any>null;
            this.assetClass = _data["assetClass"] !== undefined ? _data["assetClass"] : <any>null;
            this.iconId = _data["iconId"] !== undefined ? _data["iconId"] : <any>null;
            this.inspectionFormId = _data["inspectionFormId"] !== undefined ? _data["inspectionFormId"] : <any>null;
            this.repairFormId = _data["repairFormId"] !== undefined ? _data["repairFormId"] : <any>null;
            this.suggestedRepairFormId = _data["suggestedRepairFormId"] !== undefined ? _data["suggestedRepairFormId"] : <any>null;
            this.assetProfileId = _data["assetProfileId"] !== undefined ? _data["assetProfileId"] : <any>null;
        }
    }

    static fromJS(data: any): AssetClassUpdateV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new AssetClassUpdateV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["assetClassId"] = this.assetClassId !== undefined ? this.assetClassId : <any>null;
        data["accountId"] = this.accountId !== undefined ? this.accountId : <any>null;
        data["assetClass"] = this.assetClass !== undefined ? this.assetClass : <any>null;
        data["iconId"] = this.iconId !== undefined ? this.iconId : <any>null;
        data["inspectionFormId"] = this.inspectionFormId !== undefined ? this.inspectionFormId : <any>null;
        data["repairFormId"] = this.repairFormId !== undefined ? this.repairFormId : <any>null;
        data["suggestedRepairFormId"] = this.suggestedRepairFormId !== undefined ? this.suggestedRepairFormId : <any>null;
        data["assetProfileId"] = this.assetProfileId !== undefined ? this.assetProfileId : <any>null;
        return data;
    }
}

export interface IAssetClassUpdateV1Model {
    assetClassId?: number;
    accountId?: number;
    assetClass?: string | null;
    iconId?: number | null;
    inspectionFormId?: number;
    repairFormId?: number;
    suggestedRepairFormId?: number;
    assetProfileId?: number;
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export class ODataValueOfIEnumerableOfAssetClassV1Model implements IODataValueOfIEnumerableOfAssetClassV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: AssetClassV1Model[] | null;

    constructor(data?: IODataValueOfIEnumerableOfAssetClassV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(AssetClassV1Model.fromJS(item));
            }
            else {
                this.value = <any>null;
            }
        }
    }

    static fromJS(data: any): ODataValueOfIEnumerableOfAssetClassV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new ODataValueOfIEnumerableOfAssetClassV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export interface IODataValueOfIEnumerableOfAssetClassV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: AssetClassV1Model[] | null;
}

export class ProfileAboveCeilingV1Model implements IProfileAboveCeilingV1Model {
    profileAboveCeilingId?: number;
    assetId?: number;
    assetProfileTypeId?: number;
    assetProfileType?: string | null;
    barrierRating?: string | null;
    commonId?: string | null;
    complianceStatus?: string | null;
    inspectionConditions?: string | null;
    location?: string | null;
    material?: string | null;
    ratingDesign?: string | null;
    repairConditions?: string | null;
    specialConditions?: string | null;
    accessPictureGuid?: string | null;

    constructor(data?: IProfileAboveCeilingV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profileAboveCeilingId = _data["profileAboveCeilingId"] !== undefined ? _data["profileAboveCeilingId"] : <any>null;
            this.assetId = _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
            this.assetProfileTypeId = _data["assetProfileTypeId"] !== undefined ? _data["assetProfileTypeId"] : <any>null;
            this.assetProfileType = _data["assetProfileType"] !== undefined ? _data["assetProfileType"] : <any>null;
            this.barrierRating = _data["barrierRating"] !== undefined ? _data["barrierRating"] : <any>null;
            this.commonId = _data["commonId"] !== undefined ? _data["commonId"] : <any>null;
            this.complianceStatus = _data["complianceStatus"] !== undefined ? _data["complianceStatus"] : <any>null;
            this.inspectionConditions = _data["inspectionConditions"] !== undefined ? _data["inspectionConditions"] : <any>null;
            this.location = _data["location"] !== undefined ? _data["location"] : <any>null;
            this.material = _data["material"] !== undefined ? _data["material"] : <any>null;
            this.ratingDesign = _data["ratingDesign"] !== undefined ? _data["ratingDesign"] : <any>null;
            this.repairConditions = _data["repairConditions"] !== undefined ? _data["repairConditions"] : <any>null;
            this.specialConditions = _data["specialConditions"] !== undefined ? _data["specialConditions"] : <any>null;
            this.accessPictureGuid = _data["accessPictureGuid"] !== undefined ? _data["accessPictureGuid"] : <any>null;
        }
    }

    static fromJS(data: any): ProfileAboveCeilingV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileAboveCeilingV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileAboveCeilingId"] = this.profileAboveCeilingId !== undefined ? this.profileAboveCeilingId : <any>null;
        data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
        data["assetProfileTypeId"] = this.assetProfileTypeId !== undefined ? this.assetProfileTypeId : <any>null;
        data["assetProfileType"] = this.assetProfileType !== undefined ? this.assetProfileType : <any>null;
        data["barrierRating"] = this.barrierRating !== undefined ? this.barrierRating : <any>null;
        data["commonId"] = this.commonId !== undefined ? this.commonId : <any>null;
        data["complianceStatus"] = this.complianceStatus !== undefined ? this.complianceStatus : <any>null;
        data["inspectionConditions"] = this.inspectionConditions !== undefined ? this.inspectionConditions : <any>null;
        data["location"] = this.location !== undefined ? this.location : <any>null;
        data["material"] = this.material !== undefined ? this.material : <any>null;
        data["ratingDesign"] = this.ratingDesign !== undefined ? this.ratingDesign : <any>null;
        data["repairConditions"] = this.repairConditions !== undefined ? this.repairConditions : <any>null;
        data["specialConditions"] = this.specialConditions !== undefined ? this.specialConditions : <any>null;
        data["accessPictureGuid"] = this.accessPictureGuid !== undefined ? this.accessPictureGuid : <any>null;
        return data;
    }
}

export interface IProfileAboveCeilingV1Model {
    profileAboveCeilingId?: number;
    assetId?: number;
    assetProfileTypeId?: number;
    assetProfileType?: string | null;
    barrierRating?: string | null;
    commonId?: string | null;
    complianceStatus?: string | null;
    inspectionConditions?: string | null;
    location?: string | null;
    material?: string | null;
    ratingDesign?: string | null;
    repairConditions?: string | null;
    specialConditions?: string | null;
    accessPictureGuid?: string | null;
}

export class ProfileBelowCeilingV1Model implements IProfileBelowCeilingV1Model {
    profileBelowCeilingId?: number;
    assetId?: number;
    assetProfileTypeId?: number;
    assetProfileType?: string | null;
    barrierRating?: string | null;
    commonId?: string | null;
    complianceStatus?: string | null;
    inspectionConditions?: string | null;
    location?: string | null;
    material?: string | null;
    ratingDesign?: string | null;
    repairConditions?: string | null;
    specialConditions?: string | null;
    accessPictureGuid?: string | null;

    constructor(data?: IProfileBelowCeilingV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profileBelowCeilingId = _data["profileBelowCeilingId"] !== undefined ? _data["profileBelowCeilingId"] : <any>null;
            this.assetId = _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
            this.assetProfileTypeId = _data["assetProfileTypeId"] !== undefined ? _data["assetProfileTypeId"] : <any>null;
            this.assetProfileType = _data["assetProfileType"] !== undefined ? _data["assetProfileType"] : <any>null;
            this.barrierRating = _data["barrierRating"] !== undefined ? _data["barrierRating"] : <any>null;
            this.commonId = _data["commonId"] !== undefined ? _data["commonId"] : <any>null;
            this.complianceStatus = _data["complianceStatus"] !== undefined ? _data["complianceStatus"] : <any>null;
            this.inspectionConditions = _data["inspectionConditions"] !== undefined ? _data["inspectionConditions"] : <any>null;
            this.location = _data["location"] !== undefined ? _data["location"] : <any>null;
            this.material = _data["material"] !== undefined ? _data["material"] : <any>null;
            this.ratingDesign = _data["ratingDesign"] !== undefined ? _data["ratingDesign"] : <any>null;
            this.repairConditions = _data["repairConditions"] !== undefined ? _data["repairConditions"] : <any>null;
            this.specialConditions = _data["specialConditions"] !== undefined ? _data["specialConditions"] : <any>null;
            this.accessPictureGuid = _data["accessPictureGuid"] !== undefined ? _data["accessPictureGuid"] : <any>null;
        }
    }

    static fromJS(data: any): ProfileBelowCeilingV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileBelowCeilingV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileBelowCeilingId"] = this.profileBelowCeilingId !== undefined ? this.profileBelowCeilingId : <any>null;
        data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
        data["assetProfileTypeId"] = this.assetProfileTypeId !== undefined ? this.assetProfileTypeId : <any>null;
        data["assetProfileType"] = this.assetProfileType !== undefined ? this.assetProfileType : <any>null;
        data["barrierRating"] = this.barrierRating !== undefined ? this.barrierRating : <any>null;
        data["commonId"] = this.commonId !== undefined ? this.commonId : <any>null;
        data["complianceStatus"] = this.complianceStatus !== undefined ? this.complianceStatus : <any>null;
        data["inspectionConditions"] = this.inspectionConditions !== undefined ? this.inspectionConditions : <any>null;
        data["location"] = this.location !== undefined ? this.location : <any>null;
        data["material"] = this.material !== undefined ? this.material : <any>null;
        data["ratingDesign"] = this.ratingDesign !== undefined ? this.ratingDesign : <any>null;
        data["repairConditions"] = this.repairConditions !== undefined ? this.repairConditions : <any>null;
        data["specialConditions"] = this.specialConditions !== undefined ? this.specialConditions : <any>null;
        data["accessPictureGuid"] = this.accessPictureGuid !== undefined ? this.accessPictureGuid : <any>null;
        return data;
    }
}

export interface IProfileBelowCeilingV1Model {
    profileBelowCeilingId?: number;
    assetId?: number;
    assetProfileTypeId?: number;
    assetProfileType?: string | null;
    barrierRating?: string | null;
    commonId?: string | null;
    complianceStatus?: string | null;
    inspectionConditions?: string | null;
    location?: string | null;
    material?: string | null;
    ratingDesign?: string | null;
    repairConditions?: string | null;
    specialConditions?: string | null;
    accessPictureGuid?: string | null;
}

export class ProfileDamperV1Model implements IProfileDamperV1Model {
    profileDamperId?: number;
    assetId?: number;
    assetProfileTypeId?: number;
    assetProfileType?: string | null;
    barrierRating?: string | null;
    commonId?: string | null;
    ahuid?: string | null;
    inspectionConditions?: string | null;
    mechanism?: string | null;
    location?: string | null;
    repairConditions?: string | null;
    specialConditions?: string | null;
    accessPictureGuid?: string | null;
    priorDamperID?: string | null;

    constructor(data?: IProfileDamperV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profileDamperId = _data["profileDamperId"] !== undefined ? _data["profileDamperId"] : <any>null;
            this.assetId = _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
            this.assetProfileTypeId = _data["assetProfileTypeId"] !== undefined ? _data["assetProfileTypeId"] : <any>null;
            this.assetProfileType = _data["assetProfileType"] !== undefined ? _data["assetProfileType"] : <any>null;
            this.barrierRating = _data["barrierRating"] !== undefined ? _data["barrierRating"] : <any>null;
            this.commonId = _data["commonId"] !== undefined ? _data["commonId"] : <any>null;
            this.ahuid = _data["ahuid"] !== undefined ? _data["ahuid"] : <any>null;
            this.inspectionConditions = _data["inspectionConditions"] !== undefined ? _data["inspectionConditions"] : <any>null;
            this.mechanism = _data["mechanism"] !== undefined ? _data["mechanism"] : <any>null;
            this.location = _data["location"] !== undefined ? _data["location"] : <any>null;
            this.repairConditions = _data["repairConditions"] !== undefined ? _data["repairConditions"] : <any>null;
            this.specialConditions = _data["specialConditions"] !== undefined ? _data["specialConditions"] : <any>null;
            this.accessPictureGuid = _data["accessPictureGuid"] !== undefined ? _data["accessPictureGuid"] : <any>null;
            this.priorDamperID = _data["priorDamperID"] !== undefined ? _data["priorDamperID"] : <any>null;
        }
    }

    static fromJS(data: any): ProfileDamperV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileDamperV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileDamperId"] = this.profileDamperId !== undefined ? this.profileDamperId : <any>null;
        data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
        data["assetProfileTypeId"] = this.assetProfileTypeId !== undefined ? this.assetProfileTypeId : <any>null;
        data["assetProfileType"] = this.assetProfileType !== undefined ? this.assetProfileType : <any>null;
        data["barrierRating"] = this.barrierRating !== undefined ? this.barrierRating : <any>null;
        data["commonId"] = this.commonId !== undefined ? this.commonId : <any>null;
        data["ahuid"] = this.ahuid !== undefined ? this.ahuid : <any>null;
        data["inspectionConditions"] = this.inspectionConditions !== undefined ? this.inspectionConditions : <any>null;
        data["mechanism"] = this.mechanism !== undefined ? this.mechanism : <any>null;
        data["location"] = this.location !== undefined ? this.location : <any>null;
        data["repairConditions"] = this.repairConditions !== undefined ? this.repairConditions : <any>null;
        data["specialConditions"] = this.specialConditions !== undefined ? this.specialConditions : <any>null;
        data["accessPictureGuid"] = this.accessPictureGuid !== undefined ? this.accessPictureGuid : <any>null;
        data["priorDamperID"] = this.priorDamperID !== undefined ? this.priorDamperID : <any>null;
        return data;
    }
}

export interface IProfileDamperV1Model {
    profileDamperId?: number;
    assetId?: number;
    assetProfileTypeId?: number;
    assetProfileType?: string | null;
    barrierRating?: string | null;
    commonId?: string | null;
    ahuid?: string | null;
    inspectionConditions?: string | null;
    mechanism?: string | null;
    location?: string | null;
    repairConditions?: string | null;
    specialConditions?: string | null;
    accessPictureGuid?: string | null;
    priorDamperID?: string | null;
}

export class ProfileDoorV1Model implements IProfileDoorV1Model {
    profileDoorId?: number;
    assetId?: number;
    assetProfileTypeId?: number;
    assetProfileType?: string | null;
    action?: string | null;
    doorRating?: string | null;
    barrierRating?: string | null;
    commonId?: string | null;
    complianceStatus?: boolean;
    inspectionConditions?: string | null;
    repairConditions?: string | null;
    specialConditions?: string | null;
    requiredRating?: string | null;
    material?: string | null;
    location?: string | null;
    pushSideFileGuid?: string | null;
    pullSideFileGuid?: string | null;

    constructor(data?: IProfileDoorV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.profileDoorId = _data["profileDoorId"] !== undefined ? _data["profileDoorId"] : <any>null;
            this.assetId = _data["assetId"] !== undefined ? _data["assetId"] : <any>null;
            this.assetProfileTypeId = _data["assetProfileTypeId"] !== undefined ? _data["assetProfileTypeId"] : <any>null;
            this.assetProfileType = _data["assetProfileType"] !== undefined ? _data["assetProfileType"] : <any>null;
            this.action = _data["action"] !== undefined ? _data["action"] : <any>null;
            this.doorRating = _data["doorRating"] !== undefined ? _data["doorRating"] : <any>null;
            this.barrierRating = _data["barrierRating"] !== undefined ? _data["barrierRating"] : <any>null;
            this.commonId = _data["commonId"] !== undefined ? _data["commonId"] : <any>null;
            this.complianceStatus = _data["complianceStatus"] !== undefined ? _data["complianceStatus"] : <any>null;
            this.inspectionConditions = _data["inspectionConditions"] !== undefined ? _data["inspectionConditions"] : <any>null;
            this.repairConditions = _data["repairConditions"] !== undefined ? _data["repairConditions"] : <any>null;
            this.specialConditions = _data["specialConditions"] !== undefined ? _data["specialConditions"] : <any>null;
            this.requiredRating = _data["requiredRating"] !== undefined ? _data["requiredRating"] : <any>null;
            this.material = _data["material"] !== undefined ? _data["material"] : <any>null;
            this.location = _data["location"] !== undefined ? _data["location"] : <any>null;
            this.pushSideFileGuid = _data["pushSideFileGuid"] !== undefined ? _data["pushSideFileGuid"] : <any>null;
            this.pullSideFileGuid = _data["pullSideFileGuid"] !== undefined ? _data["pullSideFileGuid"] : <any>null;
        }
    }

    static fromJS(data: any): ProfileDoorV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new ProfileDoorV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["profileDoorId"] = this.profileDoorId !== undefined ? this.profileDoorId : <any>null;
        data["assetId"] = this.assetId !== undefined ? this.assetId : <any>null;
        data["assetProfileTypeId"] = this.assetProfileTypeId !== undefined ? this.assetProfileTypeId : <any>null;
        data["assetProfileType"] = this.assetProfileType !== undefined ? this.assetProfileType : <any>null;
        data["action"] = this.action !== undefined ? this.action : <any>null;
        data["doorRating"] = this.doorRating !== undefined ? this.doorRating : <any>null;
        data["barrierRating"] = this.barrierRating !== undefined ? this.barrierRating : <any>null;
        data["commonId"] = this.commonId !== undefined ? this.commonId : <any>null;
        data["complianceStatus"] = this.complianceStatus !== undefined ? this.complianceStatus : <any>null;
        data["inspectionConditions"] = this.inspectionConditions !== undefined ? this.inspectionConditions : <any>null;
        data["repairConditions"] = this.repairConditions !== undefined ? this.repairConditions : <any>null;
        data["specialConditions"] = this.specialConditions !== undefined ? this.specialConditions : <any>null;
        data["requiredRating"] = this.requiredRating !== undefined ? this.requiredRating : <any>null;
        data["material"] = this.material !== undefined ? this.material : <any>null;
        data["location"] = this.location !== undefined ? this.location : <any>null;
        data["pushSideFileGuid"] = this.pushSideFileGuid !== undefined ? this.pushSideFileGuid : <any>null;
        data["pullSideFileGuid"] = this.pullSideFileGuid !== undefined ? this.pullSideFileGuid : <any>null;
        return data;
    }
}

export interface IProfileDoorV1Model {
    profileDoorId?: number;
    assetId?: number;
    assetProfileTypeId?: number;
    assetProfileType?: string | null;
    action?: string | null;
    doorRating?: string | null;
    barrierRating?: string | null;
    commonId?: string | null;
    complianceStatus?: boolean;
    inspectionConditions?: string | null;
    repairConditions?: string | null;
    specialConditions?: string | null;
    requiredRating?: string | null;
    material?: string | null;
    location?: string | null;
    pushSideFileGuid?: string | null;
    pullSideFileGuid?: string | null;
}

export class AccountV1Model implements IAccountV1Model {
    accountId?: number;
    fileGuid?: string | null;
    name?: string | null;
    latitude?: number;
    longitude?: number;
    accountNumber?: string | null;
    country?: string | null;
    address?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    accountPhone?: string | null;
    accountEmail?: string | null;
    accountCode?: string | null;
    isActive?: boolean;
    createdByUserId?: number;
    createdDate?: Date;
    updatedByUserId?: number;
    updatedDate?: Date;

    constructor(data?: IAccountV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : <any>null;
            this.fileGuid = _data["fileGuid"] !== undefined ? _data["fileGuid"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : <any>null;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : <any>null;
            this.accountNumber = _data["accountNumber"] !== undefined ? _data["accountNumber"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.address = _data["address"] !== undefined ? _data["address"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : <any>null;
            this.accountPhone = _data["accountPhone"] !== undefined ? _data["accountPhone"] : <any>null;
            this.accountEmail = _data["accountEmail"] !== undefined ? _data["accountEmail"] : <any>null;
            this.accountCode = _data["accountCode"] !== undefined ? _data["accountCode"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.createdByUserId = _data["createdByUserId"] !== undefined ? _data["createdByUserId"] : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.updatedByUserId = _data["updatedByUserId"] !== undefined ? _data["updatedByUserId"] : <any>null;
            this.updatedDate = _data["updatedDate"] ? new Date(_data["updatedDate"].toString()) : <any>null;
        }
    }

    static fromJS(data: any): AccountV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new AccountV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId !== undefined ? this.accountId : <any>null;
        data["fileGuid"] = this.fileGuid !== undefined ? this.fileGuid : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["latitude"] = this.latitude !== undefined ? this.latitude : <any>null;
        data["longitude"] = this.longitude !== undefined ? this.longitude : <any>null;
        data["accountNumber"] = this.accountNumber !== undefined ? this.accountNumber : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["address"] = this.address !== undefined ? this.address : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["zip"] = this.zip !== undefined ? this.zip : <any>null;
        data["accountPhone"] = this.accountPhone !== undefined ? this.accountPhone : <any>null;
        data["accountEmail"] = this.accountEmail !== undefined ? this.accountEmail : <any>null;
        data["accountCode"] = this.accountCode !== undefined ? this.accountCode : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["createdByUserId"] = this.createdByUserId !== undefined ? this.createdByUserId : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["updatedByUserId"] = this.updatedByUserId !== undefined ? this.updatedByUserId : <any>null;
        data["updatedDate"] = this.updatedDate ? this.updatedDate.toISOString() : <any>null;
        return data;
    }
}

export interface IAccountV1Model {
    accountId?: number;
    fileGuid?: string | null;
    name?: string | null;
    latitude?: number;
    longitude?: number;
    accountNumber?: string | null;
    country?: string | null;
    address?: string | null;
    city?: string | null;
    state?: string | null;
    zip?: string | null;
    accountPhone?: string | null;
    accountEmail?: string | null;
    accountCode?: string | null;
    isActive?: boolean;
    createdByUserId?: number;
    createdDate?: Date;
    updatedByUserId?: number;
    updatedDate?: Date;
}

export class AccountInsertV1Model implements IAccountInsertV1Model {
    accountEmail?: string | null;
    accountNumber?: string | null;
    accountPhone?: string | null;
    address!: string;
    city?: string | null;
    country!: string;
    isActive?: boolean;
    latitude?: number;
    longitude?: number;
    name!: string;
    state?: string | null;
    zip?: string | null;

    constructor(data?: IAccountInsertV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountEmail = _data["accountEmail"] !== undefined ? _data["accountEmail"] : <any>null;
            this.accountNumber = _data["accountNumber"] !== undefined ? _data["accountNumber"] : <any>null;
            this.accountPhone = _data["accountPhone"] !== undefined ? _data["accountPhone"] : <any>null;
            this.address = _data["address"] !== undefined ? _data["address"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : <any>null;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : <any>null;
        }
    }

    static fromJS(data: any): AccountInsertV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new AccountInsertV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountEmail"] = this.accountEmail !== undefined ? this.accountEmail : <any>null;
        data["accountNumber"] = this.accountNumber !== undefined ? this.accountNumber : <any>null;
        data["accountPhone"] = this.accountPhone !== undefined ? this.accountPhone : <any>null;
        data["address"] = this.address !== undefined ? this.address : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["latitude"] = this.latitude !== undefined ? this.latitude : <any>null;
        data["longitude"] = this.longitude !== undefined ? this.longitude : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["zip"] = this.zip !== undefined ? this.zip : <any>null;
        return data;
    }
}

export interface IAccountInsertV1Model {
    accountEmail?: string | null;
    accountNumber?: string | null;
    accountPhone?: string | null;
    address: string;
    city?: string | null;
    country: string;
    isActive?: boolean;
    latitude?: number;
    longitude?: number;
    name: string;
    state?: string | null;
    zip?: string | null;
}

export class AccountUpdateV1Model implements IAccountUpdateV1Model {
    accountId!: number;
    accountEmail?: string | null;
    accountNumber?: string | null;
    accountPhone?: string | null;
    address!: string;
    city?: string | null;
    country!: string;
    isActive?: boolean;
    latitude?: number;
    longitude?: number;
    name!: string;
    state?: string | null;
    zip?: string | null;

    constructor(data?: IAccountUpdateV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : <any>null;
            this.accountEmail = _data["accountEmail"] !== undefined ? _data["accountEmail"] : <any>null;
            this.accountNumber = _data["accountNumber"] !== undefined ? _data["accountNumber"] : <any>null;
            this.accountPhone = _data["accountPhone"] !== undefined ? _data["accountPhone"] : <any>null;
            this.address = _data["address"] !== undefined ? _data["address"] : <any>null;
            this.city = _data["city"] !== undefined ? _data["city"] : <any>null;
            this.country = _data["country"] !== undefined ? _data["country"] : <any>null;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : <any>null;
            this.latitude = _data["latitude"] !== undefined ? _data["latitude"] : <any>null;
            this.longitude = _data["longitude"] !== undefined ? _data["longitude"] : <any>null;
            this.name = _data["name"] !== undefined ? _data["name"] : <any>null;
            this.state = _data["state"] !== undefined ? _data["state"] : <any>null;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : <any>null;
        }
    }

    static fromJS(data: any): AccountUpdateV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new AccountUpdateV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId !== undefined ? this.accountId : <any>null;
        data["accountEmail"] = this.accountEmail !== undefined ? this.accountEmail : <any>null;
        data["accountNumber"] = this.accountNumber !== undefined ? this.accountNumber : <any>null;
        data["accountPhone"] = this.accountPhone !== undefined ? this.accountPhone : <any>null;
        data["address"] = this.address !== undefined ? this.address : <any>null;
        data["city"] = this.city !== undefined ? this.city : <any>null;
        data["country"] = this.country !== undefined ? this.country : <any>null;
        data["isActive"] = this.isActive !== undefined ? this.isActive : <any>null;
        data["latitude"] = this.latitude !== undefined ? this.latitude : <any>null;
        data["longitude"] = this.longitude !== undefined ? this.longitude : <any>null;
        data["name"] = this.name !== undefined ? this.name : <any>null;
        data["state"] = this.state !== undefined ? this.state : <any>null;
        data["zip"] = this.zip !== undefined ? this.zip : <any>null;
        return data;
    }
}

export interface IAccountUpdateV1Model {
    accountId: number;
    accountEmail?: string | null;
    accountNumber?: string | null;
    accountPhone?: string | null;
    address: string;
    city?: string | null;
    country: string;
    isActive?: boolean;
    latitude?: number;
    longitude?: number;
    name: string;
    state?: string | null;
    zip?: string | null;
}

export class AccountLogoUploadV1Model extends FileV1Model implements IAccountLogoUploadV1Model {
    accountId?: number;

    constructor(data?: IAccountLogoUploadV1Model) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : <any>null;
        }
    }

    static override fromJS(data: any): AccountLogoUploadV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new AccountLogoUploadV1Model();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId !== undefined ? this.accountId : <any>null;
        super.toJSON(data);
        return data;
    }
}

export interface IAccountLogoUploadV1Model extends IFileV1Model {
    accountId?: number;
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export class ODataValueOfIEnumerableOfAccountV1Model implements IODataValueOfIEnumerableOfAccountV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: AccountV1Model[] | null;

    constructor(data?: IODataValueOfIEnumerableOfAccountV1Model) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["value"])) {
                this.value = [] as any;
                for (let item of _data["value"])
                    this.value!.push(AccountV1Model.fromJS(item));
            }
            else {
                this.value = <any>null;
            }
        }
    }

    static fromJS(data: any): ODataValueOfIEnumerableOfAccountV1Model {
        data = typeof data === 'object' ? data : {};
        let result = new ODataValueOfIEnumerableOfAccountV1Model();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.value)) {
            data["value"] = [];
            for (let item of this.value)
                data["value"].push(item.toJSON());
        }
        return data;
    }
}

/** Represents a placeholder for describing OData responses that are represented as an object with a single name/value pair whose name is "value". */
export interface IODataValueOfIEnumerableOfAccountV1Model {
    /** Gets or sets the OData response content in the "value". */
    value?: AccountV1Model[] | null;
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}